import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

export const LANGS = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'ru', label: 'RU', name: 'Русский' },
  { code: 'hy', label: 'AM', name: 'Հայերեն' },
];

// ─────────────────────────────────────────────────────────────────────────────
// TRANSLATIONS
// ─────────────────────────────────────────────────────────────────────────────
const T = {
  en: {
    ns_ios_install: "On iPhone, add Tunify to your Home Screen first — Safari only allows notifications for installed apps.",
    pwa_install: "Install app",
    pwa_ios_title: "Add Tunify to your Home Screen",
    pwa_ios_step1: "Tap the Share button in the Safari toolbar",
    pwa_ios_step2: "Choose \"Add to Home Screen\"",
    pwa_ios_note: "Opened from the Home Screen, Tunify runs full screen with no browser bars.",
    chat_emoji: "Emoji",
    ns_title: "Notifications",
    ns_push: "Browser push notifications",
    ns_push_desc: "Get a desktop notification when someone messages you, even when Tunify is in another tab.",
    ns_always_on: "Sound, the message badge and in-app alerts are always on and cannot be turned off.",
    ns_blocked: "Blocked in your browser settings. Allow notifications for this site to turn this on.",
    ns_unsupported: "Your browser does not support desktop notifications.",
    npr_title: "Turn on notifications",
    npr_text: "Get a notification the moment a client or designer messages you — even when Tunify is closed.",
    npr_enable: "Turn on",
    npr_later: "Not now",
    ds_rate_unit: "Per",
    ds_unit_hour: "per hour",
    ds_unit_sqm: "per m²",
    ds_unit_project: "per project",
    ds_unit_day: "per day",
    ds_per_sqm: "/m²",
    ds_per_project: "/project",
    ds_per_day: "/day",
    rs_own_colors: "Use my own two colours",
    rs_color_main: "Main colour",
    rs_color_accent: "Accent colour",
    rs_surfaces: "What may be redesigned",
    rs_surfaces_hint: "Doors and windows stay in the same openings — nothing is ever moved or added.",
    rs_surf_floor: "Floor",
    rs_surf_walls: "Walls",
    rs_surf_ceiling: "Ceiling",
    rs_surf_doors: "Doors",
    rs_surf_windows: "Windows",
    rs_opt_finished: "Renovated / finished",
    rs_opt_unfinished: "Unfinished / needs renovation",
    // Real Room AI Virtual Staging
    rs_open: "AI Staging",
    rs_title: "Real Room AI Staging",
    rs_sub: "Upload a photo of a real room and furnish it with AI.",
    rs_upload: "Upload a room photo",
    rs_upload_hint: "Drag a photo here, or click to choose one",
    rs_your_photo: "Your room photo",
    rs_replace: "click to replace",
    rs_room_type: "Room type",
    rs_style: "Interior style",
    rs_palette: "Colour palette",
    rs_state: "Room state",
    rs_notes: "Anything specific? (optional)",
    rs_notes_ph: "e.g. add indoor plants, a large round rug",
    rs_notes_hint: "Write in English — the AI understands it best.",
    rs_generate: "Stage this room",
    rs_working: "Staging…",
    rs_again: "Try again",
    rs_download: "Download",
    rs_open_image: "Open image",
    rs_err_not_image: "That file is not an image.",
    rs_err_read: "Could not read that image. Try another photo.",
    rs_disclaimer: "AI-generated. The room shape and windows are kept, but wall and floor finishes may not match your photo exactly.",
    rs_opt_living: "Living Room",
    rs_opt_bedroom: "Bedroom",
    rs_opt_kitchen: "Kitchen",
    rs_opt_bathroom: "Bathroom",
    rs_opt_dining: "Dining Room",
    rs_opt_office: "Home Office",
    rs_opt_modern_minimalist: "Modern Minimalist",
    rs_opt_scandinavian: "Scandinavian",
    rs_opt_luxury_modern: "Luxury Modern",
    rs_opt_japandi: "Japandi",
    rs_opt_industrial: "Industrial",
    rs_opt_boho: "Boho",
    rs_opt_warm_neutrals: "Warm Neutrals",
    rs_opt_cool_greys: "Cool Greys & Blues",
    rs_opt_earthy: "Earthy Tones",
    rs_opt_white_lightwood: "White & Light Wood",
    rs_opt_bold_dark: "Bold Dark Accent",
    rs_opt_auto: "Auto (AI chooses)",
    rs_opt_kids: "Kids' Room",
    rs_opt_nursery: "Nursery",
    rs_opt_teen: "Teen Room",
    rs_opt_guest: "Guest Room",
    rs_opt_hallway: "Hallway / Entryway",
    rs_opt_studio: "Studio Apartment",
    rs_opt_dressing: "Dressing Room",
    rs_opt_balcony: "Balcony / Loggia",
    rs_opt_classic: "Classic",
    rs_opt_neoclassic: "Neoclassic",
    rs_opt_contemporary: "Contemporary",
    rs_opt_mid_century: "Mid-Century Modern",
    rs_opt_art_deco: "Art Deco",
    rs_opt_mediterranean: "Mediterranean",
    rs_opt_rustic: "Rustic / Farmhouse",
    rs_opt_provence: "Provence",
    rs_opt_loft: "Loft",
    rs_opt_high_tech: "High-Tech",
    rs_opt_monochrome: "Monochrome",
    rs_opt_greige: "Greige & Taupe",
    rs_opt_sage: "Sage & Olive",
    rs_opt_blush: "Blush & Dusty Rose",
    rs_opt_jewel: "Jewel Tones",
    rs_opt_navy_brass: "Navy & Brass",
    rs_opt_pastel: "Soft Pastels",
    rs_opt_walnut_cream: "Walnut & Cream",
    rs_opt_empty: "Empty space (full staging)",
    rs_opt_furnished: "Furnished (redesign)",
    // Render-quality selector in the 3D views
    quality_label: 'Quality',
    quality_auto: 'Auto',
    quality_low: 'Low',
    quality_medium: 'Medium',
    quality_high: 'High',
    quality_high_note: 'Best looking, but can lag on phones and older computers.',
    quality_auto_note: 'Picks the best setting for your device.',
    // App / SaveLoad
    save: 'Save',
    saving: 'Saving…',
    saved: 'Saved',
    upload: 'Upload',
    dash_new_project_sub: 'Give your project a name to get started.',
    // ── DASHBOARD BANNER ──────────────────────────────────────────────────
    // One caption per wallpaper, each naming the feature the picture shows.
    // The banner is decorative on its own; these are what make it say
    // something.
    dbn1_title: 'Upload a room, AI furnishes it',
    dbn1_body:  'Send a photo of an empty space and get it back styled and furnished.',
    dbn2_title: 'Your 3D room, as a photograph',
    dbn2_body:  'Build the room in 3D, then turn any view into a photorealistic AI render.',
    dbn3_title: 'Draw the floor plan first',
    dbn3_body:  'Lay out walls, doors and windows on a grid, straight from your dashboard.',
    dbn4_title: 'Find a designer',
    dbn4_body:  'Browse portfolios, follow the ones you like and message them directly.',
    dbn5_title: 'Shop the whole room',
    dbn5_body:  'Furniture, lighting, tile, flooring and finishes — from shops on Tunify, with prices.',
    unsaved_title: 'Unsaved Changes',
    unsaved_sub: 'You have unsaved changes. What would you like to do?',
    unsaved_save: 'Save & Leave',
    unsaved_leave: 'Leave without saving',
    unsaved_stay: 'Stay',
    design_saved: 'Design saved!',
    design_loaded: 'Design loaded!',
    invalid_file: 'Invalid file',
    unsupported_version: 'Unsupported file version',
    try_now: 'Try for free',
    guest_save_tooltip: 'Sign up to save your project to the cloud',
    guest_locked_hint: 'Sign up for more',
    guest_customize_locked: 'Sign up to customize colors & styles',
    guest_screenshot_locked: 'Sign up to save screenshots',
    guest_time_locked: 'Sign up to unlock',
    time_morning: 'Morning',
    time_evening: 'Evening',
    time_night: 'Night',
    guest_welcome_title: 'Welcome to Tunify',
    guest_welcome_sub: 'You’re in the free trial — no account needed. Here’s how to get started:',
    guest_welcome_step1_title: 'Sketch your floor plan',
    guest_welcome_step1_body: 'Drag rooms onto the grid to lay out your home.',
    guest_welcome_step2_title: 'Review the floor plan',
    guest_welcome_step2_body: 'Open Floor Plan (bottom-left button) to see your layout come together.',
    guest_welcome_step2_body_mobile: 'Open Floor Plan (top-right button) to see your layout come together.',
    guest_welcome_step3_title: 'Explore in 3D',
    guest_welcome_step3_body: 'Click into any room to walk through it in full 3D.',
    guest_welcome_cta: 'Start Designing',

    // Builder — sidebar header
    custom_tools: 'Custom tools',
    draw_room: 'Draw Room',
    add_room: 'Add Room',
    free_wall: 'Free Wall',
    make_room: 'Make Room',
    free_room_fail: 'Close the free walls into a full loop first, then Make Room.',
    draw_walls: 'Draw Walls',
    draw_room_hint: 'Drag on the grid to draw a custom room',
    wall_mode_hint: 'Click grid intersections to place walls · click start point to close',
    wall_blocked_msg: "Can't place a wall on top of another wall",
    merge_btn: 'Merge',
    merge_tooltip: 'Merge rooms that share a wall',
    merge_hint: 'Click rooms to merge (they must share a wall)',
    merge_fail_msg: "These rooms don't share a wall, so they can't be merged",
    merge_free_msg: "Drawn rooms (angled or curved walls) can't be merged",
    rooms_tab: 'Rooms',
    furniture_tab: 'Furniture',
    drag_hint_rooms: 'Drag to grid · click for furniture',
    drag_hint_furniture: 'Drag to grid',
    openings_hint: 'Select a type, then click any wall to place it',
    clear_all: 'Clear all',
    view_floor_plan: 'View Floor Plan →',
    add_room_first: 'Add at least 1 room',
    wall_height_label: 'Wall Height',
    wall_label_short: 'Wall',
    room_width: 'Width',
    room_height: 'Height',
    room_name: 'Name',
    finish: 'Finish',
    cancel: 'Cancel',
    prev: 'Prev',
    done: 'Done',
    walls: 'Walls',
    remove: 'Remove',
    delete_room: 'Delete Room',
    delete_room_confirm: 'Delete this room?',
    delete_confirm: 'Delete this item?',
    yes: 'Yes',
    no: 'No',
    rotate: '↻ Rotate',
    change_type: 'Change type',
    color_label: 'Color',

    // FloorPlan
    edit_layout: '← Edit Layout',
    step2: 'Step 2 of 3',
    floor_plan_title: 'Your Floor Plan',
    floor_plan_sub: 'Select a room to begin designing it',
    fp_click_room_hint: 'Click on a room for 3D view',
    rooms_stat: 'Rooms',
    styled_stat: 'Styled',
    unstyled: 'Unstyled',
    view_3d: 'View 3D',

    // RoomEditor
    floor_plan_back: 'Floor Plan',
    layer_undo: 'Back',
    layer_undo_hint: 'Undo the last change on this layer',
    select_wall: 'Select Wall Area',
    select_floor: 'Select Floor Area',
    wall_pick_hint: 'Click ~1m areas on a wall…',
    floor_pick_hint: 'Click ~1m areas on the floor…',
    wall_cells: 'cells',
    wall_clear: 'Deselect',
    wall_reset_area: 'Erase',
    step3: 'Step 3 · Designing',
    complete_badge: '✦ Complete',
    reset: 'Reset',
    live_preview: 'Live Preview',
    floor_tab: 'Floor',
    walls_tab: 'Walls',
    ceiling_tab: 'Ceiling',
    custom_material: 'Custom Material',
    custom_preview_hint: 'live preview ↗',
    editing_color_for: 'Customizing style:',
    color_from_scratch_hint: 'Pick a color and finish to create a new custom material.',
    finish_label: 'Finish',
    name_label: 'Name',
    apply: 'Apply',
    applied: 'Applied ✓',

    // Openings
    wall_openings: 'Wall Openings',
    door: 'Door',
    window: 'Window',
    arch: 'Arch',
    archway: 'Archway',
    painting: 'Painting',
    ac: 'AC Unit',
    clock: 'Wall Clock',
    outlet: 'Power Outlet',
    radiator: 'Radiator',
    sill: 'Sill',
    size: 'Size',
    place_on_wall_hint: 'Click on any wall to place · click button again to cancel',
    openings_label: 'Openings',
    no_openings_hint: 'No openings yet · use Door/Window/Arch tool to add',
    wall_items_label: 'Wall Items',
    wall_items_hint: 'Select an item, then click any wall to mount it',
    room_wall: 'Room Wall',
    curve_btn: 'Curve',
    straight_btn: 'Straight',
    horizontal: 'horizontal',
    vertical: 'vertical',
    rotate_90: '90°',

    // 3D Room Editor (ThreeDRoom.jsx)
    edit_btn: 'Edit',
    fullscreen_tooltip: 'Full screen',
    exit_fullscreen_tooltip: 'Exit full screen',
    add_furniture_btn: '+ Furniture',
    add_opening_btn: '+ Opening',
    add_wallitem_btn: '+ Wall Item',
    add_lighting_btn: '+ Lighting',
    done_btn: 'Done',
    view_mode_label: 'view mode',
    edit_mode_label: 'edit mode',
    drag_rotate_color_hint: 'drag · ↻ rotate · color',
    copy_ctrlc_tooltip: 'Copy (Ctrl+C)',
    rotate90_tooltip: 'Rotate 90°',
    delete_tooltip: 'Delete',
    close_tooltip: 'Close',
    // Why a registration dialog just appeared over a profile — see GuestGateModal.
    gate_why_like: 'Create an account to like {name}.',
    gate_why_message: 'Create an account to message {name}.',
    drag_to_move_hint: 'drag to move',
    default_color: 'Default (original)',
    style_label: 'Style',
    design_label: 'Design',
    undo_ctrlz_tooltip: 'Undo (Ctrl+Z)',
    redo_ctrly_tooltip: 'Redo (Ctrl+Y)',
    go_to_prefix: '→ Go to',
    add_opening_modal_title: 'Add Opening',
    add_wallitem_modal_title: 'Add Wall Item',
    add_lighting_modal_title: 'Add Lighting',
    add_furniture_modal_title: 'Add Furniture',
    cat_living: 'Living Room',
    cat_kitchen: 'Kitchen & Dining',
    cat_bedroom: 'Bedroom',
    cat_bathroom: 'Bathroom',
    cat_office: 'Office',
    cat_anywhere: 'Anywhere',
    cat_items: 'items',
    cat_pick_hint: 'Pick a room to see its furniture',
    model_label: 'Model',
    model_count: 'models',
    type_label: 'Type',
    wall_label: 'Wall',
    wall_side_label: 'Side',
    wall_side_a: 'This side',
    wall_side_b: 'Other side',
    position_label: 'Position',
    along_wall: 'along wall',
    add_prefix: 'Add',
    item_label: 'Item',
    wall_top: 'Top',
    wall_bottom: 'Bottom',
    wall_left: 'Left',
    wall_right: 'Right',
    wall_suffix: 'wall',
    interior_wall_label: 'Interior wall',
    flip_to_other_side: 'Flip to other side',
    selected_label: 'selected',

    // 3D design styles — Door
    opstyle_door_panel4: '4-Panel',
    opstyle_door_flush: 'Flush Modern',
    opstyle_door_glass: 'Glass Panel',
    opstyle_door_barn: 'Barn Sliding',
    opstyle_door_french: 'French Double',
    opstyle_door_panel6: '6-Panel Colonial',
    // Window
    opstyle_window_doublehung: 'Double-Hung',
    opstyle_window_casement: 'Casement',
    opstyle_window_picture: 'Picture',
    opstyle_window_grid: 'Multi-Pane Grid',
    opstyle_window_arched: 'Arched Top',
    opstyle_window_sliding: 'Sliding',
    // Archway
    opstyle_archway_round: 'Round Arch',
    opstyle_archway_gothic: 'Gothic Arch',
    opstyle_archway_flat: 'Flat Cased',
    opstyle_archway_elliptical: 'Elliptical Arch',
    opstyle_archway_roman: 'Roman Keystone',
    opstyle_archway_modern: 'Modern Minimal',
    // Painting
    opstyle_painting_abstract: 'Abstract',
    opstyle_painting_baroque: 'Ornate Baroque',
    opstyle_painting_modern: 'Modern Black',
    opstyle_painting_canvas: 'Gallery Canvas',
    opstyle_painting_collage: 'Photo Collage',
    opstyle_painting_landscape: 'Landscape Oil',
    // AC Unit
    opstyle_ac_split: 'Split Unit',
    opstyle_ac_cassette: 'Cassette',
    opstyle_ac_curved: 'Curved Premium',
    opstyle_ac_window: 'Window Unit',
    opstyle_ac_slim: 'Slim High-Wall',
    opstyle_ac_retro: 'Retro Boxy',
    // Wall Clock
    opstyle_clock_analog: 'Classic Analog',
    opstyle_clock_digital: 'Digital LED',
    opstyle_clock_cuckoo: 'Cuckoo Wood',
    opstyle_clock_oversized: 'Oversized Minimal',
    opstyle_clock_vintage: 'Vintage Brass',
    opstyle_clock_skeleton: 'Skeleton Modern',
    // Power Outlet
    opstyle_outlet_eu: 'EU Round-Pin',
    opstyle_outlet_us: 'US Decora',
    opstyle_outlet_uk: 'UK 3-Pin',
    opstyle_outlet_usb: 'USB Combo',
    opstyle_outlet_brass: 'Brass Floor',
    opstyle_outlet_industrial: 'Industrial Metal',
    // Radiator
    opstyle_radiator_panel: 'Panel Convector',
    opstyle_radiator_castiron: 'Cast Iron Column',
    opstyle_radiator_towel: 'Towel Rail',
    opstyle_radiator_vertical: 'Vertical Designer',
    opstyle_radiator_skirting: 'Low Skirting',
    opstyle_radiator_electric: 'Electric Flat Panel',

    // House3DView
    back: 'Back',
    preview_3d: '3D Preview',
    full_house: 'Full House View',
    drag_hint_3d: 'Drag to rotate · Scroll to zoom',
    screenshot: 'Screenshot',

    // Room types (palette labels)
    room_living: 'Living Room',
    room_kitchen: 'Kitchen',
    room_bedroom: 'Bedroom',
    room_bathroom: 'Bathroom',
    room_hallway: 'Hallway',
    room_garage: 'Garage',
    room_office: 'Home Office',
    room_dining: 'Dining Room',
    room_custom: 'Room',

    // Furniture types (palette labels)
    furn_sofa: 'Sofa',
    furn_armchair: 'Armchair',
    furn_table: 'Dining Table',
    furn_chair: 'Chair',
    furn_bed: 'Bed',
    furn_desk: 'Desk',
    furn_tv: 'TV',
    furn_shelf: 'Bookshelf',
    furn_wardrobe: 'Wardrobe',
    furn_bathtub: 'Bathtub',
    furn_toilet: 'Toilet',
    furn_sink: 'Sink',
    furn_lamp: 'Floor Lamp',
    furn_plant: 'Plant',
    furn_rug: 'Rug',
    light_chandelier: 'Modern Chandelier',
    light_ceiling_lamp: 'Minimalist Ceiling Lamp',

    // Material categories
    cat_all: 'All',
    cat_wood: 'Wood',
    cat_laminate: 'Laminate',
    cat_stone: 'Stone',
    cat_tile: 'Tile',
    cat_carpet: 'Carpet',
    cat_vinyl: 'Vinyl',
    cat_neutral: 'Neutral',
    cat_colour: 'Color',
    cat_texture: 'Textured',
    cat_pattern: 'Pattern',
    cat_plain: 'Plain',

    // Finish options
    fin_matte: 'Matte',
    fin_satin: 'Satin',
    fin_semi_gloss: 'Semi-Gloss',
    fin_gloss: 'Gloss',
    fin_metallic: 'Metallic',
    fin_brushed_metal: 'Brushed',
    fin_velvet: 'Velvet',
    fin_pearl: 'Pearl',
    fin_concrete: 'Concrete',

    // Landing page
    lnd_signin: 'Sign In',
    lnd_browse_title:      'Browse products',
    lnd_search_ph:         'Search products…',
    lnd_search_btn:        'Search',
    lnd_search_loading:    'Searching…',
    lnd_search_none:       'Nothing matched that. Try a different word.',
    lnd_search_all:        'See all results →',
    lnd_cat_found:         '{n} products found',
    lnd_pages:             'Pages',
    lnd_prev:              'Previous page',
    lnd_next:              'Next page',
    lnd_sort:              'Sort',
    lnd_sort_new:          'Newest first',
    lnd_sort_cheap:        'Cheapest first',
    lnd_sort_dear:         'Most expensive first',
    lnd_sort_mix:          "Mixed order",
    sr_rec_title:          "Recommended",
    sr_rec_more:           "Show all recommended ({n} more)",
    sr_rec_less:           "Show fewer",
    sr_all_title:          "All products",
    lnd_badge_new:         'New',
    lnd_more_title:        'Want to see more?',
    lnd_more_sub:          'Create a free account to like, message designers, save products and design your own room in 3D.',
    lnd_more_cta:          'Register for more',
    // The gear beside the sign-up button, which opens the language picker.
    lang_settings: 'Language',
    lnd_signup: 'Sign Up',
    lnd_open_app: 'Open App',
    // ── THE THREE PILLARS ────────────────────────────────────────────────
    // The hero and the feature cards below say the same three things in the
    // same order — AI renders, 3D, finding a designer — because a
    // page that promises one set of things at the top and describes a
    // different set halfway down reads as two pages stapled together.
    //
    // Every claim here is a feature that exists: the AI render is
    // generateImageWithFlux (see RealStagingModal and DownloadModal), the 3D
    // is the editor, and designers are searchable, followable and messageable
    // (SearchPage, DesignerProfile, the chat).
    lnd_kicker: '3D home design · AI visualisation',
    lnd_title_pre: 'Design your home',
    lnd_title_hl: 'with AI,',
    lnd_title_post: 'in 3D.',
    lnd_sub: 'Sketch floor plans and furnish every room in 3D, turn any view into a photorealistic AI render, and find a designer to take it further — all in your browser, free.',
    // The same promise in one line, for phones — see .lnd-hero-sub--short.
    lnd_sub_short: 'Plan rooms in 3D, render them with AI, and find a designer. Free, in your browser.',
    lnd_cta: 'Start designing',
    lnd_badge_2d: '2D Plan',
    lnd_badge_3d: '+ 3D View',
    lnd_feat_kicker: 'Everything you need',
    lnd_feat_title: 'AI, 3D and designers',
    lnd_feat1_title: 'AI renders',
    lnd_feat1_desc: 'Turn any 3D view into a photorealistic image. Describe the mood you are after and get a finished render back in seconds.',
    lnd_feat2_title: 'Plan and furnish in 3D',
    lnd_feat2_desc: 'Draw floor plans on a grid, place doors, windows and furniture, then walk through the result in 3D.',
    lnd_feat3_title: 'Find a designer',
    lnd_feat3_desc: "Browse designers' published work, follow the ones you like and message them directly when you want a professional to take over.",
    lnd_steps_title: 'How it works',
    lnd_step1_label: 'Draw rooms',
    lnd_step1_sub: 'Click to place walls and close shapes into rooms on the grid.',
    lnd_step2_label: 'Add details',
    lnd_step2_sub: 'Place doors, windows, furniture and pick colors for every surface.',
    lnd_step3_label: 'View in 3D',
    lnd_step3_sub: 'One click switches to a full 3D walkthrough of your design.',
    lnd_bottom_title: 'Ready to start designing?',
    lnd_bottom_sub: 'No account needed. Open the builder and start creating your floor plan right now.',
// ── NAV ──
    nav_home: 'Home',
    nav_menu: 'Menu',
    nav_designers: 'Designers',
    nav_marketplace: 'Shop',
    nav_projects: 'My projects',
    // ── HOW IT WORKS ──
    lnd_steps_sub: 'From an empty grid to a photorealistic room, in four steps.',
    lnd_step4_label: 'Furnish it for real',
    lnd_step4_sub: 'Find the products in your design, or hand it to a designer to finish.',
    // ── BEFORE / AFTER ──
    lnd_tr_title: 'Before and after',
    lnd_tr_sub: 'Two ways in: stage a photo of a room you already have, or render one you built in 3D.',
    lnd_tr_before: 'Before',
    lnd_tr_after: 'After',
    lnd_tr1_t: 'An empty room, staged',
    lnd_tr1_b: 'Upload a photo of the room as it stands. The AI furnishes it while keeping the walls, windows and proportions exactly where they are.',
    lnd_tr2_t: 'A 3D scene, made real',
    lnd_tr2_b: 'Build the room in 3D, pick a view, and turn it into a photorealistic image — the same layout, lit and finished.',
    // ── PREVIEWS ──
    lnd_dsg_title: 'Designers on Tunify',
    lnd_dsg_all: 'View all designers',
    lnd_shops_title: "Shops on Tunify",
    lnd_shops_all: "View all shops",
    lnd_shop_title: 'Furnish it',
    lnd_shop_sub: 'Furniture, materials and finishes from shops on Tunify.',
    lnd_shop_all: 'Go to shop',
    lnd_dsg_projects: '{n} published',
    lnd_footer_copy: '© 2026 Tunify · All rights reserved',

    // AuthLayout brand panel
    al_headline_pre: 'Design Your',
    al_headline_hl:  'Dream Space',
    al_tagline:      'AI-powered interior design. Sketch floor plans, furnish rooms and walk through your design in 3D — completely free.',
    al_stat_free:    'Free forever',
    al_stat_3d:      'Live walkthrough',
    al_stat_furn:    'Furniture pieces',

    // Dashboard
    dash_sign_out:         'Sign Out',
    menu_language:         'Language',
    menu_dark_mode:        'Dark Mode',
    menu_light_mode:       'Light Mode',
    menu_sign_out:         'Sign Out',
    menu_admin:            'Admin panel',
    adm_title:             'Analytics',
    adm_sec_ai:            'AI spend by type',
    adm_flow_render:       '3D render',
    adm_flow_staging:      'Room staging',
    adm_flow_render_total: '3D render, all time',
    adm_flow_staging_total: 'Room staging, all time',
    adm_flow_sub:          '{n} images · {rate}/image',
    adm_n_images:          '{n} images',
    adm_flow_unattributed: '{n} generations were recorded before spend was split by type, so they appear in the total but in neither card.',
    adm_signed_in:         'Signed in as {who}. All dates are UTC.',
    adm_back:              'App',
    adm_tf_day:            'Today',
    adm_tf_week:           '7 days',
    adm_tf_month:          '30 days',
    adm_tf_year:           '12 months',
    adm_sec_product:       'Product',
    adm_sec_content:       'Content',
    adm_sec_accounts:      'Accounts by type',
    adm_sec_traffic:       'Traffic',
    adm_total_users:       'Total users',
    adm_total_posts:       'Total posts',
    adm_posts_today:       'Posts today',
    adm_projects:          'Projects',
    adm_products:          'Products',
    adm_right_now:         'right now',
    adm_new_users:         'New users',
    adm_active_users:      'Active users',
    adm_generations:       'AI generations',
    adm_spend:             'AI spend',
    adm_customers:         'Customers',
    adm_designers:         'Designers',
    adm_shops:             'Shops',
    adm_unclassified:      'Unclassified',
    adm_all_time:          'all time',
    adm_today:             'today',
    adm_in_range:          'in this range',
    adm_n_all_time:        '{n} all time',
    adm_spend_sub:         '{total} all time',
    adm_new_in_range:      '+{n} new',
    adm_no_type:           'no account type recorded',
    adm_chart_registrations: 'New registrations',
    adm_chart_dau:         'Daily active users',
    adm_peak:              'peak {n}',
    adm_visitors:          'Visitors',
    adm_cached:            'cached ≤30 min',
    adm_pageviews:         'Pageviews',
    adm_unique:            'Unique visitors',
    adm_distinct:          'distinct people',
    adm_sessions:          'Sessions',
    adm_visits:            'visits',
    adm_bounce:            'Bounce rate',
    adm_conversion:        'Conversion rate',
    adm_conversions_n:     '{n} conversions',
    adm_loading_traffic:   'Loading traffic…',
    adm_ga_not_connected:  'Analytics is not connected.',
    adm_ga_no_property:    'No GA4 property is configured.',
    adm_ga_step_access:    'Open Analytics → Admin → Property access management.',
    adm_ga_step_viewer:    'Add this account with the Viewer role:',
    adm_ga_step_viewer_generic: "Add this project's functions service account with the Viewer role.",
    adm_ga_step_wait:      'Wait a minute, then reload. No redeploy is needed.',
    adm_ga_step_id:        'Set the property id — the numeric id, not G-XXXXXXX:',
    adm_ga_step_api:       'Enable the Analytics Data API in Google Cloud.',
    adm_ga_step_redeploy:  'Redeploy:',
    adm_err_claim:         'Your session does not carry the admin claim yet. Sign out and back in.',
    adm_err_load:          'Could not load stats.',
    adm_no_data:           'No data for this range.',
    adm_foot:              'Counters are maintained by Cloud Functions as events happen; this page reads one document per total and one small row per day.',
    menu_plans:            'Plans & credits',
    menu_gen_code:         'Generate share code',
    menu_generating:       'Generating…',
    menu_code_hint:        'Give this code to a design owner so they can grant you edit access. Expires in 10 minutes.',
    dash_signing_out:      'Signing out…',
    dash_get_started:      'Get Started',
    dash_designer_title:   'Open Designer',
    dash_designer_desc:    'Draw floor plans, furnish rooms and view in 3D.',
    dash_workspace_title:  'My Workspace',
    dash_workspace_desc:   'Manage your projects and collections.',
    dash_inspo_title:      'Inspiration',
    dash_inspo_desc:       'Browse curated room designs and templates.',
    dash_coming_soon:      'Coming Soon',

    // Settings
    set_title:             'Account Settings',
    set_back_to_dash:      'Back to Dashboard',
    set_fullname_label:    'Full Name',
    set_no_name:           'No name set',
    set_save:              'Save Changes',
    set_saving:            'Saving…',
    set_saved:             'Full name updated.',
    set_save_failed:       'Could not save. Please try again.',
    set_change_password_title:  'Change Password',
    set_current_password_label: 'Current Password',
    set_current_password_ph:    'Enter your current password',
    set_new_password_label:     'New Password',
    set_change_password_btn:    'Change Password',
    set_changing_password:      'Changing…',
    set_password_changed:       'Password changed successfully.',
    set_wrong_current_password: 'Current password is incorrect.',
    set_google_only_password:   "You signed in with Google — there's no password to change here.",

    // Workspace
    ws_sign_out:                  'Sign Out',
    ws_signing_out:               'Signing out…',
    ws_title:                     'My Workspace',
    ws_sub:                       'Manage and organize your 3D floor plans and scenes',
    ws_new_collection:            'New Collection',
    ws_new_project:               'New Project',
    ws_add_project:               'Add Project',
    ws_tab_projects:              'All Projects',
    ws_tab_collections:           'Collections',
    ws_back_collections:          'Collections',
    ws_collection_label:          'Collection',
    ws_project_one:               'project',
    ws_project_many:              'projects',
    ws_in_collection:             'in this collection',
    ws_empty_projects_title:      'No projects yet',
    ws_empty_projects_sub:        'Create your first project to get started.',
    ws_new_project_action:        '+ New Project',
    ws_empty_collections_title:   'No collections yet',
    ws_empty_collections_sub:     'Group your projects into collections.',
    ws_new_collection_action:     '+ New Collection',
    ws_empty_col_title:           'No projects yet',
    ws_empty_col_sub:             'Add your first project to this collection.',
    ws_add_project_action:        '+ Add Project',
    ws_field_required:            'This field is required.',
    ws_create:                    'Create',
    ws_creating:                  'Creating…',
    ws_delete:                    'Delete',
    ws_rename:                    'Rename',
    ws_copy:                      'Copy',
    ws_rename_title:              'Rename Project',
    ws_save:                      'Save',
    ws_saving:                    'Saving…',
    ws_yes:                       'Yes',
    ws_no:                        'No',
    ws_confirm_del_title:         'Delete project?',
    ws_confirm_del_msg:           'This project will be permanently deleted. This cannot be undone.',
    ws_confirm_del_col_title:     'Delete collection?',
    ws_confirm_del_col_msg:       'The collection will be deleted. Its projects are kept and become standalone.',
    cc_estimate:                  'Estimate',
    cc_reload:                    'Recalculate',
    cc_title:                     'Cost Estimate',
    cc_currency:                  'Currency',
    cc_empty:                     'This project has no rooms yet — add some to estimate its cost.',
    cc_surfaces:                  'Surfaces',
    cc_room:                      'Room',
    cc_floor:                     'Floor',
    cc_wall:                      'Wall',
    cc_ceiling:                   'Ceiling',
    cc_total:                     'Total',
    cc_free_walls:                'Free walls',
    dl_title:            'Download image',
    dl_sub:              'Save the current view, or let AI turn it into a photorealistic render.',
    dl_model_flux:        'AI Generation',
    dl_model_flux_desc:   'Fast photorealistic pass over your design.',
    dl_model_soon:        'SOON',
    dl_model_locked_desc: 'Temporarily unavailable.',
    dl_original:         'Download original',
    dl_original_desc:    'Save the 3D view exactly as you see it now.',
    dl_ai:               'Generate FHD AI',
    dl_ai_desc:          'Photorealistic render of your layout, in full HD.',
    dl_ai_loading:       'Generating render…',
    dl_ai_loading_desc:  'This can take up to a minute. Please keep this open.',
    dl_ai_success:       'AI render downloaded.',
    dl_ai_failed:        'AI rendering failed. Please try again.',
    dl_ai_signin:        'Please sign in to use AI rendering.',
    dl_ready_sub:        'Your render is ready. Tap save to keep it.',
    dl_save:             'Save image',
    dl_save_desc:        'Save the render to your device.',
    dl_capture_failed:   'Could not capture the 3D view. Please try again.',
    cc_per_sqm:                   'price / m²',
    cc_items:                     'Items',
    cc_item:                      'Item',
    cc_qty:                       'Qty',
    cc_unit_price:                'Unit price',
    cc_items_total:               'Items total',
    cc_grand_total:               'Total price',
    cc_calculate:                 'Calculate',
    cc_cur_USD:                   'Dollar',
    cc_cur_RUB:                   'Ruble',
    cc_cur_AMD:                   'Dram',
    ws_modal_project_title:       'New Project',
    ws_modal_project_label:       'Project name',
    ws_modal_project_ph:          'e.g. Living Room Design',
    ws_size_label:                'Dashboard size',
    ws_modal_collection_title:    'New Collection',
    ws_modal_collection_label:    'Collection name',
    ws_modal_collection_ph:       'e.g. Summer House',
    ws_modal_addtocol_title:      'Add Project to Collection',
    ws_modal_addtocol_label:      'Project name',
    ws_modal_addtocol_ph:         'e.g. Master Bedroom',

    // Auth pages
    auth_login_title:      'Welcome Back',
    auth_login_sub:        'Sign in to continue designing your space.',
    auth_google_signin:    'Continue with Google',
    auth_google_signup:    'Sign up with Google',
    auth_or_email_signin:  'or continue with email',
    auth_phone_signin:     'Continue with phone',
    auth_phone_signup:     'Sign up with phone',
    auth_or_phone_signin:  'or continue with your phone',
    auth_or_phone_signup:  'or sign up with your phone',
    auth_phone_back_email: 'Use email instead',
    phone_label:           'Phone number',
    phone_country:         'Country',
    phone_ph:              '77 12 34 56',
    phone_hint:            "We'll text you a 6-digit code. Standard rates may apply.",
    // {privacy} and {terms} are replaced with links — keep both placeholders,
    // and put them wherever the sentence needs them in your language.
    phone_recaptcha_note:    'This site is protected by reCAPTCHA and the Google {privacy} and {terms} apply.',
    phone_recaptcha_privacy: 'Privacy Policy',
    phone_recaptcha_terms:   'Terms of Service',
    phone_send:            'Send code',
    phone_sending:         'Sending…',
    phone_code_label:      'Verification code',
    phone_code_sent:       'Enter the 6-digit code we sent to',
    phone_verify:          'Verify and continue',
    phone_verifying:       'Verifying…',
    phone_resend:          'Resend code',
    phone_resend_in:       'Resend in {n}s',
    phone_change:          'Change number',
    phone_err_required:      'Enter your phone number.',
    phone_err_invalid:       "That doesn't look like a valid number for the country you picked.",
    phone_err_code_required: 'Enter the 6-digit code.',
    phone_err_code_invalid:  'That code is not correct. Check it and try again.',
    phone_err_code_expired:  'That code has expired. Send a new one.',
    phone_err_expired_session: 'This verification timed out. Please request a new code.',
    phone_err_too_many:      'Too many attempts. Wait a few minutes and try again.',
    phone_err_quota:         'SMS is temporarily unavailable. Try again later or use email.',
    phone_err_captcha:       'Verification check failed. Reload the page and try again.',
    phone_err_network:       'Network error. Check your connection.',
    phone_err_not_enabled:   'Phone sign-in is not available right now.',
    phone_err_unauthorized_domain: "Couldn't verify this device. Reload the page and try again, or use email.",
    phone_err_disabled:      'This account has been disabled.',
    phone_err_in_use:        'That number is already linked to another account.',
    phone_err_generic:       'Something went wrong. Please try again.',
    auth_or_email_signup:  'or sign up with email',
    auth_email_label:      'Email',
    auth_email_ph:         'you@example.com',
    auth_id_label:         'Email or phone',
    auth_id_ph:            'you@example.com or +374 77 12 34 56',
    auth_id_phone_hint:    "Leave the password empty and we'll text you a code instead.",
    auth_id_phone_pw_hint: 'Signing in with your phone number and password.',
    auth_err_phone_no_password: 'No password is set for this number. Leave the password empty to sign in with a code.',
    auth_err_email_reserved: 'That address is reserved. Please use a different one.',
    auth_err_password_not_set: "Couldn't save that password. You can set one later in Settings.",
    phone_pw_intro:        'Your number is verified. Set a password so you can sign in without waiting for a code.',
    phone_pw_hint:         'At least 6 characters. You can always sign in with a code instead.',
    phone_pw_save:         'Save password',
    phone_pw_skip:         'Skip for now',
    nav_ai:                'AI',
    sup_admin_name:            'Admin',
    adm_support_target_you:    'Contact-admin chats come to this account.',
    adm_support_target_other:  'Contact-admin chats go to {uid}.',
    adm_support_target_none:   'No support account set — the Contact admin button is hidden for everyone.',
    adm_support_claim:         'Use this account',
    sup_contact_admin:     'Contact admin',
    sup_opening:           'Opening…',
    close:                 'Close',
    sup_sub:               'Send us a message and we will get back to you.',
    sup_message:           'Message',
    sup_message_ph:        'What can we help with?',
    sup_contact:           'How to reach you',
    sup_contact_ph:        'Phone or email',
    sup_send:              'Send message',
    sup_sending:           'Sending…',
    sup_done:              'Message sent. We will get back to you as soon as we can.',
    sup_or_call:           'Or call us directly',
    sup_err_failed:        'Could not send. Check your connection and try again.',
    sup_err_rejected:      'That message could not be accepted. Try shortening it.',
    sup_err_wait:          'Please wait {s}s before sending another message.',
    adm_support:           'Support messages',
    adm_support_none:      'No messages yet.',
    adm_support_new:       'New',
    adm_support_handled:   'Handled',
    adm_support_mark:      'Mark handled',
    adm_support_reopen:    'Reopen',
    adm_support_signedout: 'Not signed in',
    nav_about:             'About',
    nav_privacy:           'Privacy',
    nav_support:           'Contact us',
    builder_move:          'Move',
    builder_move_on:       'Moving',
    phone_exists_title:    'The number {number} already has a Tunify account.',
    phone_exists_body:     'You have been signed in to it. If you meant to create a second account, use a different number.',
    phone_exists_continue: 'Continue to my account',
    phone_taken_body:      'No code was sent. Sign in with this number instead, or go back and use a different one.',
    phone_taken_signin:    'Sign in with this number',
    phone_pw_reset_intro:  'Your number is confirmed. Choose a new password.',
    phone_pw_reset_save:   'Save new password',
    phone_pw_reset_skip:   'Continue without changing it',
    phone_pw_reset_new:    'There was no account for this number, so we created one. Choose a password.',
    auth_forgot_use_phone: 'Reset with a phone number instead',
    auth_forgot_use_email: 'Reset with an email address instead',
    auth_password_label:   'Password',
    auth_password_ph:      '••••••••',
    auth_forgot:           'Forgot password?',
    auth_signin_btn:       'Sign In',
    auth_signin_ing:       'Signing in…',
    auth_no_account:       "Don't have an account?",
    auth_create_free:      "Create one — it's free",
    auth_register_title:   'Create Account',
    auth_register_sub:     'Start designing your dream space — free, no credit card needed.',
    auth_name_label:       'Full Name',
    auth_name_ph:          'Jane Smith',
    auth_password_min_ph:  'Min. 6 characters',
    auth_confirm_label:    'Confirm Password',
    auth_confirm_ph:       'Repeat your password',
    auth_signup_btn:       'Create Free Account',
    auth_signup_ing:       'Creating account…',
    auth_have_account:     'Already have an account?',
    auth_signin_link:      'Sign in',
    auth_pw_tooshort:      'Too short',
    auth_pw_weak:          'Weak',
    auth_pw_fair:          'Fair',
    auth_pw_good:          'Good',
    auth_pw_strong:        'Strong',
    auth_forgot_title:     'Reset Password',
    auth_forgot_sub:       "Enter your email and we'll send you a 6-digit code to reset your password.",
    auth_reset_step_sub:   'Enter the code we sent you and choose a new password.',
    auth_reset_password_btn: 'Reset Password',
    auth_resetting:        'Resetting…',
    auth_reset_done_title: 'Password Reset!',
    auth_reset_done_sub:   'You can now sign in with your new password.',
    auth_code_sent_to:     'Code sent to',
    auth_email_addr_label: 'Email Address',
    auth_send_reset:       'Send Reset Link',
    auth_sending:          'Sending…',
    auth_back_login:       '← Back to Sign In',
    auth_inbox_title:      'Check your inbox',
    auth_inbox_sent:       "We've sent a password reset link to",
    auth_inbox_spam:       "Check your spam folder if you don't see it within a minute.",
    auth_err_name:         'Full name must be at least 2 characters.',
    auth_err_email_req:    'Email is required.',
    auth_err_email_inv:    'Enter a valid email address.',
    auth_err_email_taken:  'An account already exists with this email.',
    auth_err_email_google: 'This email is registered with Google. Please sign in with Google instead.',
    auth_err_no_account:   'No account found with this email address.',
    auth_err_pass_req:     'Password is required.',
    auth_err_pass_min:     'Password must be at least 6 characters.',
    auth_err_conf_req:     'Please confirm your password.',
    auth_err_conf_match:   'Passwords do not match.',

    // Email OTP verification (RegisterForm + EmailCodeVerify)
    auth_send_code:        'Send Code',
    auth_sending_code:     'Sending…',
    auth_code_label:       'Verification Code',
    auth_verify_btn:       'Verify',
    auth_verifying:        'Verifying…',
    auth_resend_code:      'Resend Code',
    pl_title: 'Plans & Credits',
    pl_title_credits: 'AI Credits',
    pl_lead_credits: 'Credits pay for AI generation. Buy a pack once — there is no subscription and credits never expire.',
    pl_balance: 'You have {n} credits',
    pl_on_plan: '{p} plan',
    crb_title: 'Your AI credits',
    icm_title: 'Not enough credits',
    pst_your_plan: 'Your plan',
    ann_title: 'Profile banner',
    ann_sub_one: 'One image shown at the top of your public profile.',
    ann_sub_many: 'Up to {n} images, shown as a carousel at the top of your public profile.',
    ann_add: 'Add image',
    ann_working: 'Working…',
    ann_remove: 'Remove',
    ann_move_left: 'Move left',
    ann_move_right: 'Move right',
    ann_err_not_image: 'That file is not an image.',
    ann_err_read: 'That image could not be read. Try another one.',
    ann_err_too_big: 'That image is too large even after compression. Try a smaller one.',
    ann_err_save: 'Could not save. Please try again.',
    ann_err_denied: 'Your plan does not allow this. Refresh and check your plan.',
    pst_msg_free: 'Get your profile higher in search',
    pst_msg_bronze: 'Move higher and become a recommended designer',
    pst_msg_silver: 'Reach the top of search and the homepage',
    pst_msg_gold: 'Highest plan — top placement everywhere',
    pst_upgrade: 'Upgrade to {p}',
    pst_manage: 'Manage plan',
    icm_body: 'This generation costs more credits than you have left. Top up to carry on.',
    icm_have: 'You have',
    icm_need: 'Required',
    icm_buy: 'Buy credits',
    icm_cancel: 'Not now',
    pl_lead: 'Start free. Upgrade when you want more room, better placement and monthly credits.',
    pl_free: 'Free',
    pl_name_free: 'Free',
    pl_name_bronze: 'Bronze',
    pl_name_silver: 'Silver',
    pl_name_gold: 'Gold',
    pl_per_mo: '{n}/mo',
    pl_once: '{n} once',
    pl_month: 'month',
    pl_popular: 'Most popular',
    pl_current: 'Your plan',
    pl_choose: 'Choose',
    pl_unlimited: 'Unlimited',
    pl_credits: 'credits',
    pl_credits_mo: '{n} credits every month',
    pl_credits_once: '{n} credits to get started',
    pl_f_credits: 'AI credits',
    pl_f_portfolio: 'Portfolio images',
    pl_f_projects: 'Projects',
    pl_f_discount: 'Off credit packs',
    pl_f_messaging: 'Client messaging',
    pl_f_search: 'Search position',
    pl_f_recommended: 'Recommendations',
    pl_f_social: 'Our Instagram & TikTok',
    pl_f_design: 'Profile page design',
    pl_f_banner: 'Profile banner',
    pl_lead_shop: 'Get your shop and its products seen first — in search, in recommendations and on the homepage.',
    pl_f_prodimg: 'Product images',
    pl_f_recshops: 'Recommended shops',
    pl_f_landing: 'Shown on the homepage',
    pl_recshop_none: 'Never',
    pl_recshop_chance: 'In the running',
    pl_recshop_always: 'Always',
    pl_social_days: '{n} days',
    pl_design_default: 'Standard',
    pl_ask_title: 'Questions, or something you need that is not here?',
    pl_ask_body: 'Message the Tunify team directly and we will get back to you.',
    pl_ask_btn: 'Contact admin',
    pl_banner_one: '1 image',
    pl_banner_many: '{n} — carousel',
    pl_f_support: 'Priority support',
    pl_rank_0: 'Standard',
    pl_rank_1: 'Normal',
    pl_rank_2: 'Higher',
    pl_rank_3: 'Highest',
    // Keyed on searchRank, so the four steps line up with the four ranks the
    // recommendations rail actually orders by. See the row in Plans.jsx.
    //
    // SHORT ON PURPOSE. The label beside them already says "Recommendations", so
    // repeating the word in every cell only cost the row a second line — these
    // read as the scale they are: never, small, good, always.
    pl_rec_0: 'Never',
    pl_rec_1: 'Small chance',
    pl_rec_2: 'Good chance',
    pl_rec_3: 'Always',
    // Keyed on socialPromos — a count of posts per month.
    pl_social_0: '—',
    pl_social_1: '1× a month',
    pl_social_2: '2+ a month',
    pl_design_free: 'Default',
    pl_design_bronze: 'Bronze',
    pl_design_silver: 'Silver',
    pl_design_gold: 'Gold',
    pl_packs_title: 'Buy credits',
    pl_packs_lead: 'A 3D render costs {render} credit. AI staging from a photo costs {staging}. Credits never expire.',
    pl_best: 'Best value',
    pl_per_credit: '${n} each',
    pl_soon: 'Payments are not connected yet — these prices are final but nothing can be purchased in the app today.',
    auth_code_spam_hint:   'The email can take a minute to arrive. If you do not see it, check your spam or junk folder.',
    auth_resend_in:        'Resend in',
    auth_email_verified:   'Email verified.',
    auth_enter_email_first: 'Enter a valid email first.',
    auth_enter_code:       'Enter the 6-digit code.',
    auth_verify_email_gate: 'Please verify your email address first.',
    auth_verify_step_sub:  "First, let's verify your email address.",
    auth_details_step_sub: 'Almost done — choose a name and password.',
    auth_type_step_sub: 'How will you use Tunify?',
    auth_continue: 'Continue',
    ut_title: 'Account type',
    ut_customer: 'Customer',
    atg_welcome: 'Welcome to Tunify',
    atg_sub: 'Pick the one that fits. You can change it later in Settings.',
    atg_change_later: 'You can switch account type at any time in Settings.',
    atg_save_failed: 'Could not save that. Check your connection and try again.',
    ut_customer_desc: 'Design your own home in 3D, plan rooms and estimate costs.',
    ut_designer: 'Designer',
    ut_designer_desc: 'Everything a customer gets, plus a public profile to publish your work and be found by clients.',
    ut_shop: 'Shop',
    ut_shop_desc: 'Sell materials, furniture or fittings — a public storefront with your products, prices and contacts.',

    // ── SHOP PROFILE ──
    shop_logo: 'Logo',
    shop_name: 'Shop name',
    shop_name_ph: 'e.g. Stone & Wood',
    shop_categories: 'What you sell',
    shop_delivery: 'We deliver',
    shop_delivery_hint: 'Shown on your profile and used as a search filter.',
    shop_location: 'Location',
    shop_description: 'About the shop',
    shop_description_ph: 'What you sell, which brands you carry, opening hours…',
    shop_website: 'Website',
    shop_socials: 'Contacts and socials',
    shop_social_handle: 'username',
    shop_social_phone: 'Phone',
    shop_social_instagram: 'Instagram',
    shop_social_facebook: 'Facebook',
    shop_social_tiktok: 'TikTok',
    shop_social_telegram: 'Telegram',
    shop_section_title: 'Shop profile',
    shop_section_sub: 'This is what customers see when they find you.',
    shop_save: 'Save shop profile',
    shop_saved: 'Shop profile saved.',
    shop_err_name: 'Enter your shop name (at least 2 characters).',
    shop_err_categories: 'Pick at least one category.',
    shop_cat_building_materials: 'Building materials',
    shop_cat_furniture: 'Furniture',
    shop_cat_openings: 'Windows & doors',
    shop_cat_walls: 'Walls & paint',
    shop_cat_floor: 'Flooring',
    shop_cat_ceiling: 'Ceilings',
    shop_cat_lighting: 'Lighting',
    shop_cat_electronics: 'Electronics',
    shop_cat_plumbing: 'Plumbing',
    shop_cat_tiles: 'Tiles',
    shop_cat_textiles: 'Textiles',
    shop_cat_decor: 'Decor',
    shop_cat_kitchen: 'Kitchen',
    shop_cat_bathroom: 'Bathroom',
    shop_cat_garden: 'Garden & outdoor',
    shop_cat_tools: 'Tools',
    // ── PRODUCT TAXONOMY ──
    prod_type: 'Product type',
    prod_type_ph: 'Choose a type…',
    prod_subtype: 'Subtype',
    prod_subtype_ph: 'Choose a subtype…',
    prod_color: 'Colour',
    prod_price_range: 'Price',
    prod_price_min: 'From',
    prod_price_max: 'To',
    prod_err_type: 'Choose a product type.',
    prod_err_subtype: 'Choose a subtype.',
    prod_err_color: 'Choose a colour.',
    search_products: 'Find products',
    search_mode_products: 'Products',
    search_product_ph: 'Search by name, type or colour…',
    search_none_products: 'No products match these filters.',
    prod_color_white: 'White',
    prod_color_beige: 'Beige',
    prod_color_grey: 'Grey',
    prod_color_black: 'Black',
    prod_color_brown: 'Brown',
    prod_color_wood: 'Wood',
    prod_color_gold: 'Gold',
    prod_color_silver: 'Silver',
    prod_color_blue: 'Blue',
    prod_color_green: 'Green',
    prod_color_red: 'Red',
    prod_color_yellow: 'Yellow',
    prod_color_orange: 'Orange',
    prod_color_pink: 'Pink',
    prod_color_purple: 'Purple',
    prod_color_multicolor: 'Multicolour',
    prod_sub_cement: 'Cement & mortar',
    prod_sub_plaster_mix: 'Plaster & filler',
    prod_sub_insulation: 'Insulation',
    prod_sub_timber: 'Timber & boards',
    prod_sub_drywall: 'Drywall',
    prod_sub_brick_block: 'Brick & block',
    prod_sub_adhesive: 'Adhesives & sealants',
    prod_sub_waterproofing: 'Waterproofing',
    prod_sub_sofa: 'Sofa',
    prod_sub_armchair: 'Armchair',
    prod_sub_chair: 'Chair',
    prod_sub_table: 'Table',
    prod_sub_bed: 'Bed',
    prod_sub_wardrobe: 'Wardrobe',
    prod_sub_shelving: 'Shelving',
    prod_sub_desk: 'Desk',
    prod_sub_sideboard: 'Sideboard',
    prod_sub_stool: 'Stool & bench',
    prod_sub_window: 'Window',
    prod_sub_door_interior: 'Interior door',
    prod_sub_door_entrance: 'Entrance door',
    prod_sub_sliding_door: 'Sliding door',
    prod_sub_door_handle: 'Handles & locks',
    prod_sub_window_sill: 'Window sill',
    prod_sub_paint: 'Paint',
    prod_sub_wallpaper: 'Wallpaper',
    prod_sub_wall_panel: 'Wall panels',
    prod_sub_decorative_plaster: 'Decorative plaster',
    prod_sub_wall_moulding: 'Mouldings & trim',
    prod_sub_parquet: 'Parquet',
    prod_sub_laminate: 'Laminate',
    prod_sub_floor_tile: 'Floor tile',
    prod_sub_carpet: 'Carpet',
    prod_sub_vinyl: 'Vinyl & LVT',
    prod_sub_skirting: 'Skirting board',
    prod_sub_underlay: 'Underlay',
    prod_sub_stretch_ceiling: 'Stretch ceiling',
    prod_sub_ceiling_panel: 'Ceiling panels',
    prod_sub_plasterboard_ceiling: 'Plasterboard ceiling',
    prod_sub_cornice: 'Cornice',
    prod_sub_chandelier: 'Chandelier',
    prod_sub_pendant_light: 'Pendant light',
    prod_sub_ceiling_light: 'Ceiling light',
    prod_sub_wall_light: 'Wall light',
    prod_sub_floor_lamp: 'Floor lamp',
    prod_sub_table_lamp: 'Table lamp',
    prod_sub_led_strip: 'LED strip',
    prod_sub_spotlight: 'Spotlight',
    prod_sub_outdoor_light: 'Outdoor light',
    prod_sub_tv: 'TV',
    prod_sub_fridge: 'Fridge',
    prod_sub_oven: 'Oven',
    prod_sub_hob: 'Hob',
    prod_sub_extractor_hood: 'Extractor hood',
    prod_sub_dishwasher: 'Dishwasher',
    prod_sub_washing_machine: 'Washing machine',
    prod_sub_air_conditioner: 'Air conditioner',
    prod_sub_water_heater_el: 'Water heater',
    prod_sub_smart_home: 'Smart home',
    prod_sub_audio: 'Audio',
    prod_sub_plumbing_sink: 'Sink',
    prod_sub_basin: 'Washbasin',
    prod_sub_toilet: 'Toilet',
    prod_sub_bathtub: 'Bathtub',
    prod_sub_shower_cabin: 'Shower cabin',
    prod_sub_tap: 'Tap & mixer',
    prod_sub_radiator: 'Radiator',
    prod_sub_boiler: 'Boiler',
    prod_sub_pipe_fitting: 'Pipes & fittings',
    prod_sub_ceramic_tile: 'Ceramic tile',
    prod_sub_porcelain_tile: 'Porcelain tile',
    prod_sub_mosaic: 'Mosaic',
    prod_sub_natural_stone: 'Natural stone',
    prod_sub_grout: 'Grout & adhesive',
    prod_sub_curtains: 'Curtains & blinds',
    prod_sub_rug: 'Rug',
    prod_sub_cushion: 'Cushions',
    prod_sub_bedding: 'Bedding',
    prod_sub_upholstery_fabric: 'Upholstery fabric',
    prod_sub_towels: 'Towels',
    prod_sub_mirror: 'Mirror',
    prod_sub_wall_art: 'Wall art',
    prod_sub_vase: 'Vase',
    prod_sub_clock: 'Clock',
    prod_sub_candle_holder: 'Candles & holders',
    prod_sub_planter_indoor: 'Indoor planter',
    prod_sub_figurine: 'Figurines',
    prod_sub_photo_frame: 'Photo frames',
    prod_sub_kitchen_set: 'Kitchen units',
    prod_sub_countertop: 'Countertop',
    prod_sub_backsplash: 'Backsplash',
    prod_sub_kitchen_sink: 'Kitchen sink',
    prod_sub_kitchen_tap: 'Kitchen tap',
    prod_sub_cookware: 'Cookware',
    prod_sub_kitchen_storage: 'Kitchen storage',
    prod_sub_vanity_unit: 'Vanity unit',
    prod_sub_bathroom_cabinet: 'Bathroom cabinet',
    prod_sub_shower_enclosure: 'Shower enclosure',
    prod_sub_towel_rail: 'Towel rail',
    prod_sub_bathroom_mirror: 'Bathroom mirror',
    prod_sub_bathroom_accessory: 'Bathroom accessories',
    prod_sub_garden_furniture: 'Garden furniture',
    prod_sub_planter_outdoor: 'Outdoor planter',
    prod_sub_garden_lighting: 'Garden lighting',
    prod_sub_paving: 'Paving',
    prod_sub_bbq_grill: 'BBQ & grill',
    prod_sub_fencing: 'Fencing',
    prod_sub_power_tool: 'Power tools',
    prod_sub_hand_tool: 'Hand tools',
    prod_sub_ladder: 'Ladders',
    prod_sub_measuring_tool: 'Measuring tools',
    prod_sub_fixings: 'Fixings',
    prod_sub_safety_gear: 'Safety gear',
    // Public shop profile + product listings
    shop_not_found: 'This shop could not be found.',
    // A listing opened by link that has since been removed or hidden — see
    // ProductPage. Deliberately not "nothing published yet", which is what an
    // empty shop says.
    prod_gone: 'This listing is no longer available.',
    // The product page's two contact actions, beside Add to basket.
    prod_call: 'Call',
    prod_zoom: 'View full size',
    gate_why_basket: 'Create an account to add {name} to your basket.',
    shop_tab_products: 'Products',
    shop_no_products: 'Nothing published yet.',
    gal_menu_details: 'Description and price',
    gal_details_sub: 'What this product is, what it costs and where to buy it.',
    gal_product_desc_ph: 'Name, size, material, brand…',
    gal_name: 'Product name',
    gal_name_ph: 'e.g. Oak dining chair',
    gal_price: 'Price',
    gal_price_ph: '0',
    gal_product_link: 'Link to the product',
    gal_link_optional: 'The link is optional — leave it blank to hide it.',
    gal_price_gate: 'A price is required. Until you set one this photo stays unpublished — you can add it later from the tile’s menu.',
    gal_err_price: 'Enter a price greater than 0.',
    gal_err_price_max: 'That price is too high.',
    gal_err_link: 'That does not look like a link.',
    gal_needs_price: 'Needs a price',
    gal_needs_details: 'Needs a type',
    gal_buy: 'View product',
    gal_skip: 'Skip',
    gal_image_count: '{n} images',
    gal_new_post: 'New post',
    gal_new_post_sub: 'Add up to {max} photos, then say what they show.',
    gal_new_product_sub: 'Add up to {max} photos, then say what this product is and what it costs.',
    gal_add_images: 'Add photos',
    gal_remove_image: 'Remove this photo',
    gal_shot_n: 'Photo {n}',
    gal_post: 'Post',
    gal_images_hint: '{n} of {max} photos. The first one is the cover.',
    gal_err_no_image: 'Add at least one photo.',
    gal_images: 'Images in this post',
    gal_err_images_max: 'Only the first {n} images were added — that is the most one post can hold.',
    ds_avatar: 'Profile picture',
    ds_avatar_hint: 'Square image. Resized automatically.',
    ds_avatar_remove: 'Remove',
    avl_open: 'View profile picture',
    tab_feed: 'Home',
    tab_search: 'Search',
    tab_messages: 'Messages',
    tab_alerts: 'Alerts',
    tab_profile: 'Profile',
    nav_primary: 'Main navigation',
    avl_change: 'Change photo',
    avl_add: 'Add photo',
    avl_delete_confirm: 'Remove your profile picture?',
    avc_title: 'Position your photo',
    avc_hint: 'Drag to move · pinch or scroll to zoom',
    avc_zoom: 'Zoom',
    avc_apply: 'Apply',
    ps_likes: 'Likes',
    ml_title: 'My liked',
    // ── BASKET ──
    bsk_title: 'My basket',
    bsk_add: 'Add to basket',
    bsk_remove: 'Remove from basket',
    bsk_clear: 'Empty basket',
    // The two confirmations. Reuse bsk_remove / bsk_clear as the confirm
    // BUTTON labels — they already name the exact action — so only the
    // question and its consequence are new.
    bsk_remove_title: 'Remove this item?',
    bsk_remove_msg: 'It will be taken out of your basket. You can add it again from its page at any time.',
    bsk_clear_title: 'Empty the basket?',
    bsk_clear_msg: 'All {n} saved items will be removed.',
    bsk_empty: 'Your basket is empty. Open a product from a shop and tap the basket icon.',
    bsk_unavailable: 'No longer available',
    chat_title: 'Messages',
    chat_message: 'Message',
    chat_none: 'No conversations yet.',
    chat_pick: 'Choose a conversation.',
    chat_empty: 'No messages yet. Say hello.',
    chat_no_messages: 'No messages yet',
    chat_placeholder: 'Write a message...',
    chat_send: 'Send',
    chat_older: 'Load older messages',
    // ── floor plan import (create-project modal) ──
    fp_label: 'Floor plan (optional)',
    fp_upload: 'Upload a floor plan',
    fp_upload_hint: 'PNG or JPG — we detect rooms, doors and windows',
    fp_ai_notice: 'AI-generated, and typically 70–100% accurate depending on the drawing. Check the walls, doors and windows against your plan and correct anything that is wrong — everything stays editable.',
    fp_detecting: 'Detecting rooms…',
    fp_found: '{rooms} rooms · {doors} doors · {windows} windows',
    fp_nothing_found: 'Nothing detected — you can still create the project and draw it yourself.',
    fp_failed: 'Could not read this plan. Try another image.',
    fp_not_configured: 'Floor plan detection is not configured.',
    fp_remove: 'Remove',
    fp_scale: 'Scale',
    fp_scale_hint: 'Drag until the size matches the real home.',
    fp_overlay: 'Original plan',
    fp_overlay_hint: 'Fade the uploaded drawing in behind to check the walls line up.',
    chat_edit: 'Edit',
    chat_save: 'Save',
    chat_edited: 'edited',
    chat_reply: "Reply",
    chat_react: "React",
    chat_actions: "Message actions",
    chat_img_add: "Send a picture",
    chat_img_open: "Open picture",
    chat_img_working: "Preparing picture…",
    chat_blocked_word: 'That message was not sent — "{word}" is not allowed here.',
    chat_send_failed: 'Message not sent. Please try again.',
    chat_img_type: "That file is not an image.",
    chat_img_large: "That picture is too large to send.",

    // ── comments on a photo ──
    cm_title: "Comments",
    cm_none: "No comments yet. Be the first.",
    cm_loading: "Loading comments…",
    cm_post: "Post",
    cm_placeholder: "Add a comment…",
    cm_replying: "Replying to {name}",
    cm_edited: "edited",
    cm_someone: "Someone",
    cm_signin: "Sign in to join the conversation.",
    cm_now: "just now",
    cm_m: "{n}m",
    cm_h: "{n}h",
    cm_d: "{n}d",
    chat_copy: "Copy",
    chat_replying_to: "Replying to",
    chat_reply_gone: "Message unavailable",
    chat_delete: 'Remove conversation',
    chat_delete_confirm: 'Remove this conversation from your list? It comes back if they write again.',
    chat_delete_msg_confirm: 'Delete this message for everyone?',
    chat_loading: 'Loading...',
    chat_someone: 'Someone',
    chat_you: 'You:',
    ml_sub: 'Photos and 3D designs you have liked.',
    ml_empty: 'Nothing liked yet. Tap the heart on work you admire.',
    ml_untitled: 'Untitled project',
    ps_views: 'Views',
    ps_like: 'Like',
    ps_liked: 'Liked',
    ps_unlike: 'Remove like',
    ps_login_to_like: 'Sign in to like',
    ps_like_own: 'This is your own work',
    ds_fullname: 'Full name',
    ds_fullname_ph: 'Jane Doe',
    ds_optional: '(optional)',
    ds_styles: 'Design styles',
    ds_experience: 'Years of experience',
    ds_rate: 'Rate',
    ds_rate_ph: 'e.g. 5000',
    ds_currency: 'Currency',
    ds_err_rate: 'Enter a valid rate.',
    ds_years_short: '{n} yrs experience',
    ds_per_hour: '/hr',
    gal_prev: 'Previous',
    gal_shrink: 'Exit full view',
    gal_next: 'Next',
    ds_location: 'Location',
    ds_location_ph: 'Start typing a city…',
    ds_location_map_hint: 'Search for a place, or click the map to drop a pin.',
    ds_description: 'About you',
    ds_description_ph: 'Tell clients about your work and approach…',
    ds_websites: 'Websites',
    ds_add_website: 'Add website',
    ds_contacts: 'Contacts',
    ds_add_contact: 'Add contact',
    ds_contact_link: 'Link',
    ds_contact_phone: 'Phone',
    ds_remove: 'Remove',
    ds_err_name: 'Please enter your full name (at least 2 characters).',
    ds_err_name_long: 'That name is too long.',
    ds_err_desc_long: 'Description is too long.',
    ds_err_experience: 'Enter a whole number of years between 0 and 70.',
    ds_err_styles_max: 'Too many styles selected.',
    ds_err_sites_max: 'Too many websites.',
    ds_err_site_invalid: 'One of the website addresses is not valid.',
    ds_err_contacts_max: 'Too many contacts.',
    ds_err_contact_invalid: 'One of the contacts is not a valid link or phone number.',
    ds_err_avatar: 'That image could not be processed. Try another.',
    ds_err_avatar_large: 'That image is too large even after compression.',
    ds_section_title: 'Designer profile',
    gal_photos_title: 'Photos',
    like_add: 'Like',
    like_liked: 'Liked',
    like_remove: 'Remove like',
    like_own: 'This is your own profile',
    like_count: 'Likes',
    md_title: 'My designers',
    md_card_desc: 'Designers you liked.',
    md_empty: 'You have not liked any designers yet. Open a profile and tap Like.',
    md_liked_shops: 'Shops you like',
    md_recommended: 'Recommended designers',
    md_recommended_sub: 'Popular work surfaces more often, and the list changes each visit.',
    md_projects: 'Projects',
    md_projects_sub: 'Work and products published across Tunify.',
    md_shops: 'Shops',
    md_shops_sub: 'Materials, furniture and fittings from shops on Tunify.',
    md_work: 'Published',
    md_filter_all: 'All',
    md_filter_projects: 'Projects',
    md_filter_products: 'Products',
    md_no_projects: 'No projects published yet.',
    md_no_products: 'No products published yet.',
    md_none: 'Nothing to show yet.',
    gal_show_more: 'Show more ({n})',
    notif_title: 'Notifications',
    notif_none: 'No notifications yet.',
    notif_liked: '{name} liked your profile',
    notif_liked_project: '{name} liked your project',
    notif_liked_photo: '{name} liked your photo',
    notif_replied: "{name} replied to your comment",
    notif_commented_photo: '{name} commented on your photo',
    notif_commented_design: '{name} commented on your design',
    search_designers: 'Find designers',
    search_shops: 'Find shops',
    search_mode: 'What are you looking for',
    search_mode_designers: 'Designers',
    search_mode_shops: 'Shops',
    search_shop_ph: 'Search by name or what they sell…',
    search_delivery_only: 'With delivery only',
    search_none_shops: 'No shops match these filters.',
    search_ph: 'Search by name or style…',
    search_any: 'Any',
    search_exp_min: '{n}+ years',
    search_clear: 'Clear filters',
    search_loading: 'Loading…',
    search_none: 'No designers match these filters.',
    search_count: '{n} designers',
    dp_not_found: 'This designer profile is not available.',
    dp_no_work: 'Nothing published here yet.',
    // ── PAID TIERS ──
    // `{p}` is the plan's own name — "Bronze", "Silver", "Gold" — substituted
    // rather than translated, because that is what the pricing page calls these
    // plans in every language. A localised word here would name a plan nobody
    // can find. See PLANS in constants/plans.js and pl_on_plan below.
    //
    // The capability keys are `dp_cap_<flag>`, where <flag> is the field name in
    // constants/plans.js — so the chip row is generated from the plan record and
    // adding a flag there is the only edit a new capability needs.
    dp_tier_verified: 'Verified {p} designer',
    dp_cap_recommended: 'Recommended',
    dp_cap_partner: "Partner",
    dp_cap_prioritySupport: 'Priority',
    nav_login: 'Sign in',
    gal_settings: 'Settings',
    gal_menu_publish: 'Make public',
    gal_menu_unpublish: 'Make private',
    gal_menu_description: 'Description',
    gal_desc_sub: 'Shown under this item on your public profile.',
    gal_save: 'Save',
    gal_yes: 'Yes, delete',
    gal_no: 'Cancel',
    dg_title: 'Published work',
    dg_tab_img: 'Img',
    dg_tab_3d: '3D',
    dg_3d_empty: 'No published designs yet. Open a project in your workspace and choose Publish from its menu.',
    pub_action: 'Publish',
    pub_title: 'Publish to profile',
    pub_sub: 'Choose a cover image and describe this design. It will appear on your public profile.',
    pub_pick_cover: '+ Choose cover image',
    pub_publish: 'Publish',
    pub_allow_copy: "Let viewers save a copy to their workspace",
    pub_allow_download: "Let viewers download an image of it",
    pub_err_cover: 'Please choose a cover image first.',
    gal_designs_title: 'Published 3D designs',
    gal_sub: 'Published items appear on your public profile.',
    gal_add: '+ Add images',
    gal_uploading: 'Uploading…',
    gal_empty: 'Nothing published yet. Add images to show clients your work.',
    gal_designs_empty: 'No published designs yet. Add a render of a 3D room you have designed.',
    gal_desc_ph: 'Add a description…',
    gal_hide: 'Hide from profile',
    gal_show: 'Show on profile',
    gal_hidden: 'Hidden',
    gal_delete: 'Delete',
    gal_open: 'Open image',
    gal_delete_confirm: 'Delete this item permanently?',
    gal_err_upload: 'That image could not be uploaded. Try another.',
    gal_err_large: 'That image is too large even after compression.',
    gal_err_save: 'Change could not be saved. Please try again.',
    gal_err_max: 'You have reached the maximum number of items.',
    ds_section_sub: 'This information appears on your public profile and in search.',
    ds_save: 'Save profile',
    ds_saved: 'Designer profile saved.',
    ds_saved_unpublished: 'Profile saved, but not yet visible in search. Try saving again shortly.',
    ds_become: 'Become a designer',
    ds_become_desc: 'Publish your work and let clients find you.',
    ds_style_modern: 'Modern',
    ds_style_minimalist: 'Minimalist',
    ds_style_scandinavian: 'Scandinavian',
    ds_style_industrial: 'Industrial',
    ds_style_loft: 'Loft',
    ds_style_classic: 'Classic',
    ds_style_neoclassic: 'Neoclassic',
    ds_style_contemporary: 'Contemporary',
    ds_style_art_deco: 'Art Deco',
    ds_style_mid_century: 'Mid-century',
    ds_style_bohemian: 'Bohemian',
    ds_style_rustic: 'Rustic',
    ds_style_farmhouse: 'Farmhouse',
    ds_style_provence: 'Provence',
    ds_style_mediterranean: 'Mediterranean',
    ds_style_japandi: 'Japandi',
    ds_style_high_tech: 'High-tech',
    ds_style_eclectic: 'Eclectic',
    auth_change_email:     '← Change email',

    // Share / public read-only view
    share: 'Share',
    share_title: 'Share this design',
    share_desc: 'Anyone with this link can view your design in 3D — walk through the rooms and the full house. They can’t edit anything.',
    share_link_label: 'Shareable link',
    share_copy: 'Copy link',
    share_copied: 'Copied!',
    share_enabling: 'Preparing link…',
    share_error: 'Could not create the link. Please try again.',
    shared_readonly: 'View only',
    shared_save_copy: 'Save a copy',
    shared_save_copy_title: 'Save to your projects',
    shared_save_copy_desc: 'A copy of this design is added to your workspace, where you can edit it freely.',
    shared_save_copy_btn: 'Save copy',
    shared_editable: 'Editable',
    shared_no_edit_access: "Something's wrong — you don't have edit access to this design.",
    shared_edit_expired: "Your edit access has expired — please generate a new code and send it to the owner.",
    share_editable_label: 'Editable?',
    share_editable_hint: "Paste an editor's share code to let them edit this design through the link.",
    share_code_ph: 'Paste share code',
    share_code_apply: 'Enable',
    share_code_ok: 'Edit access granted for that code.',
    share_code_used: 'This code has already been used.',
    share_code_expired: 'This code has expired. Ask for a new one.',
    share_code_invalid: "That code doesn't exist.",
    share_code_error: "Couldn't enable editing — check your Firestore rules and try a new code.",
    // Sending a design, photo or 3D design into a conversation as a card.
    share_to_chat: 'Send in a message',
    share_to_chat_note: 'Add a note (optional)',
    share_to_chat_none: 'No conversations yet. Open one from someone’s profile first.',
    share_to_chat_sent: 'Sent',
    share_to_chat_error: 'Could not send. Please try again.',
    share_kind_project: 'Design',
    share_kind_photo: 'Photo',
    share_kind_design: '3D design',
    share_msg_open: 'Open',
    share_msg_untitled: 'Untitled design',
    share_msg_gone: 'This link is unavailable',
    shared_view_house: 'Full house',
    shared_view_rooms: 'Rooms',
    shared_made_with: 'Made with Tunify',
    shared_try: 'Create your own',
    shared_not_available: 'This design isn’t available. The link may be incorrect, or sharing was turned off.',
    shared_back_home: 'Go to Tunify',
    shared_loading: 'Loading design…',
    shared_no_rooms: 'This design doesn’t have any rooms yet.',
    loading_3d: 'Preparing 3D view…',
  },

  ru: {
    ns_ios_install: "На iPhone сначала добавьте Tunify на главный экран — Safari разрешает уведомления только установленным приложениям.",
    pwa_install: "Установить приложение",
    pwa_ios_title: "Добавьте Tunify на главный экран",
    pwa_ios_step1: "Нажмите кнопку «Поделиться» на панели Safari",
    pwa_ios_step2: "Выберите «На экран «Домой»»",
    pwa_ios_note: "Запущенный с главного экрана, Tunify работает во весь экран без панелей браузера.",
    chat_emoji: "Эмодзи",
    ns_title: "Уведомления",
    ns_push: "Push-уведомления браузера",
    ns_push_desc: "Получайте уведомление на рабочем столе, когда вам пишут, даже если Tunify в другой вкладке.",
    ns_always_on: "Звук, счётчик сообщений и уведомления внутри приложения всегда включены и не отключаются.",
    ns_blocked: "Заблокировано в настройках браузера. Разрешите уведомления для этого сайта.",
    ns_unsupported: "Ваш браузер не поддерживает уведомления на рабочем столе.",
    npr_title: "Включите уведомления",
    npr_text: "Получайте уведомление сразу, как только вам напишет клиент или дизайнер — даже когда Tunify закрыт.",
    npr_enable: "Включить",
    npr_later: "Не сейчас",
    ds_rate_unit: "За",
    ds_unit_hour: "за час",
    ds_unit_sqm: "за м²",
    ds_unit_project: "за проект",
    ds_unit_day: "за день",
    ds_per_sqm: "/м²",
    ds_per_project: "/проект",
    ds_per_day: "/день",
    rs_own_colors: "Свои два цвета",
    rs_color_main: "Основной цвет",
    rs_color_accent: "Акцентный цвет",
    rs_surfaces: "Что можно переделать",
    rs_surfaces_hint: "Двери и окна остаются в тех же проёмах — ничего не переносится и не добавляется.",
    rs_surf_floor: "Пол",
    rs_surf_walls: "Стены",
    rs_surf_ceiling: "Потолок",
    rs_surf_doors: "Двери",
    rs_surf_windows: "Окна",
    rs_opt_finished: "С ремонтом",
    rs_opt_unfinished: "Без ремонта",
    // Real Room AI Virtual Staging
    rs_open: "AI-обстановка",
    rs_title: "AI-обстановка реальной комнаты",
    rs_sub: "Загрузите фото реальной комнаты и обставьте её с помощью AI.",
    rs_upload: "Загрузите фото комнаты",
    rs_upload_hint: "Перетащите фото сюда или нажмите, чтобы выбрать",
    rs_your_photo: "Фото вашей комнаты",
    rs_replace: "нажмите, чтобы заменить",
    rs_room_type: "Тип комнаты",
    rs_style: "Стиль интерьера",
    rs_palette: "Цветовая палитра",
    rs_state: "Состояние комнаты",
    rs_notes: "Особые пожелания? (необязательно)",
    rs_notes_ph: "e.g. add indoor plants, a large round rug",
    rs_notes_hint: "Пишите по-английски — так AI понимает лучше всего.",
    rs_generate: "Обставить комнату",
    rs_working: "Обставляем…",
    rs_again: "Ещё раз",
    rs_download: "Скачать",
    rs_open_image: "Открыть изображение",
    rs_err_not_image: "Этот файл не является изображением.",
    rs_err_read: "Не удалось прочитать изображение. Попробуйте другое фото.",
    rs_disclaimer: "Сгенерировано AI. Форма комнаты и окна сохраняются, но отделка стен и пола может отличаться от вашего фото.",
    rs_opt_living: "Гостиная",
    rs_opt_bedroom: "Спальня",
    rs_opt_kitchen: "Кухня",
    rs_opt_bathroom: "Ванная",
    rs_opt_dining: "Столовая",
    rs_opt_office: "Домашний офис",
    rs_opt_modern_minimalist: "Современный минимализм",
    rs_opt_scandinavian: "Скандинавский",
    rs_opt_luxury_modern: "Люкс-модерн",
    rs_opt_japandi: "Джапанди",
    rs_opt_industrial: "Индустриальный",
    rs_opt_boho: "Бохо",
    rs_opt_warm_neutrals: "Тёплые нейтральные",
    rs_opt_cool_greys: "Холодные серые и синие",
    rs_opt_earthy: "Землистые тона",
    rs_opt_white_lightwood: "Белый и светлое дерево",
    rs_opt_bold_dark: "Тёмный акцент",
    rs_opt_auto: "Авто (ИИ выберет)",
    rs_opt_kids: "Детская",
    rs_opt_nursery: "Комната для малыша",
    rs_opt_teen: "Комната подростка",
    rs_opt_guest: "Гостевая комната",
    rs_opt_hallway: "Прихожая",
    rs_opt_studio: "Студия",
    rs_opt_dressing: "Гардеробная",
    rs_opt_balcony: "Балкон / Лоджия",
    rs_opt_classic: "Классический",
    rs_opt_neoclassic: "Неоклассика",
    rs_opt_contemporary: "Современный",
    rs_opt_mid_century: "Мид-сенчури",
    rs_opt_art_deco: "Ар-деко",
    rs_opt_mediterranean: "Средиземноморский",
    rs_opt_rustic: "Рустик / Кантри",
    rs_opt_provence: "Прованс",
    rs_opt_loft: "Лофт",
    rs_opt_high_tech: "Хай-тек",
    rs_opt_monochrome: "Монохром",
    rs_opt_greige: "Грейж и тауп",
    rs_opt_sage: "Шалфей и олива",
    rs_opt_blush: "Пудровый и роза",
    rs_opt_jewel: "Драгоценные тона",
    rs_opt_navy_brass: "Тёмно-синий и латунь",
    rs_opt_pastel: "Мягкие пастельные",
    rs_opt_walnut_cream: "Орех и кремовый",
    rs_opt_empty: "Пустая комната (полная обстановка)",
    rs_opt_furnished: "С мебелью (редизайн)",
    // Выбор качества рендера в 3D-видах
    quality_label: 'Качество',
    quality_auto: 'Авто',
    quality_low: 'Низкое',
    quality_medium: 'Среднее',
    quality_high: 'Высокое',
    quality_high_note: 'Выглядит лучше всего, но может тормозить на телефонах и старых компьютерах.',
    quality_auto_note: 'Подбирает лучшие настройки для вашего устройства.',
    // App / SaveLoad
    save: 'Сохранить',
    saving: 'Сохранение…',
    saved: 'Сохранено',
    upload: 'Загрузить',
    dash_new_project_sub: 'Дайте название проекту, чтобы начать.',
    dbn1_title: 'Загрузите фото — ИИ обставит',
    dbn1_body:  'Пришлите снимок пустой комнаты и получите её обставленной и оформленной.',
    dbn2_title: 'Ваша 3D-комната как фотография',
    dbn2_body:  'Постройте комнату в 3D, затем превратите любой вид в фотореалистичную ИИ-визуализацию.',
    dbn3_title: 'Начните с планировки',
    dbn3_body:  'Расставьте стены, двери и окна по сетке прямо из личного кабинета.',
    dbn4_title: 'Найдите дизайнера',
    dbn4_body:  'Смотрите портфолио, подписывайтесь на понравившихся и пишите им напрямую.',
    dbn5_title: 'Всё для комнаты — в одном месте',
    dbn5_body:  'Мебель, свет, плитка, напольные покрытия и отделка — от магазинов Tunify, с ценами.',
    unsaved_title: 'Несохранённые изменения',
    unsaved_sub: 'У вас есть несохранённые изменения. Что вы хотите сделать?',
    unsaved_save: 'Сохранить и выйти',
    unsaved_leave: 'Выйти без сохранения',
    unsaved_stay: 'Остаться',
    design_saved: 'Дизайн сохранён!',
    design_loaded: 'Дизайн загружен!',
    invalid_file: 'Неверный файл',
    unsupported_version: 'Неподдерживаемая версия',
    try_now: 'Попробовать бесплатно',
    guest_save_tooltip: 'Зарегистрируйтесь, чтобы сохранить проект в облаке',
    guest_locked_hint: 'Регистрация откроет больше',
    guest_customize_locked: 'Зарегистрируйтесь, чтобы менять цвета и стили',
    guest_screenshot_locked: 'Зарегистрируйтесь, чтобы сохранять скриншоты',
    guest_time_locked: 'Зарегистрируйтесь, чтобы открыть',
    time_morning: 'Утро',
    time_evening: 'Вечер',
    time_night: 'Ночь',
    guest_welcome_title: 'Добро пожаловать в Tunify',
    guest_welcome_sub: 'Вы в бесплатной пробной версии — регистрация не нужна. Как начать:',
    guest_welcome_step1_title: 'Создайте план этажа',
    guest_welcome_step1_body: 'Перетаскивайте комнаты на сетку, чтобы спроектировать дом.',
    guest_welcome_step2_title: 'Проверьте план этажа',
    guest_welcome_step2_body: 'Откройте «План этажа» (кнопка внизу слева), чтобы увидеть общую планировку.',
    guest_welcome_step2_body_mobile: 'Откройте «План этажа» (кнопка вверху справа), чтобы увидеть общую планировку.',
    guest_welcome_step3_title: 'Осмотрите в 3D',
    guest_welcome_step3_body: 'Нажмите на любую комнату, чтобы пройтись по ней в полном 3D.',
    guest_welcome_cta: 'Начать проектировать',

    // Builder
    custom_tools: 'Инструменты',
    draw_room: 'Нарисовать комнату',
    add_room: 'Добавить комнату',
    free_wall: 'Свободная стена',
    make_room: 'Создать комнату',
    free_room_fail: 'Сначала замкните свободные стены в контур, затем «Создать комнату».',
    draw_walls: 'Нарисовать стены',
    draw_room_hint: 'Перетащите на сетке, чтобы нарисовать комнату',
    wall_mode_hint: 'Нажмите на пересечения сетки для размещения стен',
    wall_blocked_msg: 'Нельзя разместить стену поверх другой стены',
    merge_btn: 'Объединить',
    merge_tooltip: 'Объединить комнаты с общей стеной',
    merge_hint: 'Нажимайте на комнаты для объединения (нужна общая стена)',
    merge_fail_msg: 'У этих комнат нет общей стены — объединить нельзя',
    merge_free_msg: 'Нарисованные комнаты (с наклонными или изогнутыми стенами) объединять нельзя',
    rooms_tab: 'Комнаты',
    furniture_tab: 'Мебель',
    drag_hint_rooms: 'Перетащите на сетку · нажмите для мебели',
    drag_hint_furniture: 'Перетащите на сетку',
    openings_hint: 'Выберите тип, затем нажмите на стену, чтобы разместить',
    clear_all: 'Очистить всё',
    view_floor_plan: 'Поэтажный план →',
    add_room_first: 'Добавьте хотя бы 1 комнату',
    wall_height_label: 'Высота стен',
    wall_label_short: 'Стена',
    room_width: 'Ширина',
    room_height: 'Высота',
    room_name: 'Название',
    finish: 'Завершить',
    cancel: 'Отмена',
    prev: 'Назад',
    done: 'Готово',
    walls: 'Стены',
    remove: 'Удалить',
    delete_room: 'Удалить комнату',
    delete_room_confirm: 'Удалить эту комнату?',
    delete_confirm: 'Удалить этот элемент?',
    yes: 'Да',
    no: 'Нет',
    rotate: '↻ Повернуть',
    change_type: 'Изменить тип',
    color_label: 'Цвет',

    // FloorPlan
    edit_layout: '← Редактировать план',
    step2: 'Шаг 2 из 3',
    floor_plan_title: 'Ваш поэтажный план',
    floor_plan_sub: 'Выберите комнату для оформления',
    fp_click_room_hint: 'Нажмите на комнату для 3D-просмотра',
    rooms_stat: 'Комнаты',
    styled_stat: 'Оформлено',
    unstyled: 'Без дизайна',
    view_3d: '3D Просмотр',

    // RoomEditor
    floor_plan_back: 'Поэтажный план',
    layer_undo: 'Назад',
    layer_undo_hint: 'Отменить последнее изменение этого слоя',
    select_wall: 'Выбрать участок',
    select_floor: 'Выбрать участок пола',
    wall_pick_hint: 'Кликайте участки (~1м) на стене…',
    floor_pick_hint: 'Кликайте участки (~1м) на полу…',
    wall_cells: 'яч.',
    wall_clear: 'Отменить',
    wall_reset_area: 'Стереть',
    step3: 'Шаг 3 · Дизайн',
    complete_badge: '✦ Готово',
    reset: 'Сбросить',
    live_preview: 'Предпросмотр',
    floor_tab: 'Пол',
    walls_tab: 'Стены',
    ceiling_tab: 'Потолок',
    custom_material: 'Свой материал',
    custom_preview_hint: 'предпросмотр ↗',
    editing_color_for: 'Настройка стиля:',
    color_from_scratch_hint: 'Выберите цвет и отделку, чтобы создать новый материал.',
    finish_label: 'Отделка',
    name_label: 'Название',
    apply: 'Применить',
    applied: 'Применено ✓',

    // Openings
    wall_openings: 'Проёмы в стенах',
    door: 'Дверь',
    window: 'Окно',
    arch: 'Арка',
    archway: 'Арочный проём',
    painting: 'Картина',
    ac: 'Кондиционер',
    clock: 'Настенные часы',
    outlet: 'Розетка',
    radiator: 'Радиатор',
    sill: 'Подоконник',
    size: 'Размер',
    place_on_wall_hint: 'Нажмите на стену для размещения · нажмите кнопку снова для отмены',
    openings_label: 'Проёмы',
    no_openings_hint: 'Нет проёмов · используйте инструменты Дверь/Окно/Арка',
    wall_items_label: 'Настенные предметы',
    wall_items_hint: 'Выберите предмет, затем нажмите на стену, чтобы разместить',
    room_wall: 'Стена комнаты',
    curve_btn: 'Изогнуть',
    straight_btn: 'Прямая',
    horizontal: 'горизонтальный',
    vertical: 'вертикальный',
    rotate_90: '90°',

    // 3D Room Editor (ThreeDRoom.jsx)
    edit_btn: 'Редактировать',
    fullscreen_tooltip: 'Полный экран',
    exit_fullscreen_tooltip: 'Выйти из полноэкранного режима',
    add_furniture_btn: '+ Мебель',
    add_opening_btn: '+ Проём',
    add_wallitem_btn: '+ Предмет',
    add_lighting_btn: '+ Освещение',
    done_btn: 'Готово',
    view_mode_label: 'режим просмотра',
    edit_mode_label: 'режим редактирования',
    drag_rotate_color_hint: 'перетащить · ↻ повернуть · цвет',
    copy_ctrlc_tooltip: 'Копировать (Ctrl+C)',
    rotate90_tooltip: 'Повернуть на 90°',
    delete_tooltip: 'Удалить',
    close_tooltip: 'Закрыть',
    gate_why_like: 'Создайте аккаунт, чтобы поставить лайк — {name}.',
    gate_why_message: 'Создайте аккаунт, чтобы написать — {name}.',
    drag_to_move_hint: 'перетащите для перемещения',
    default_color: 'По умолчанию (оригинал)',
    style_label: 'Стиль',
    design_label: 'Дизайн',
    undo_ctrlz_tooltip: 'Отменить (Ctrl+Z)',
    redo_ctrly_tooltip: 'Повторить (Ctrl+Y)',
    go_to_prefix: '→ Перейти в',
    add_opening_modal_title: 'Добавить проём',
    add_wallitem_modal_title: 'Добавить предмет',
    add_lighting_modal_title: 'Добавить освещение',
    add_furniture_modal_title: 'Добавить мебель',
    cat_living: 'Гостиная',
    cat_kitchen: 'Кухня и столовая',
    cat_bedroom: 'Спальня',
    cat_bathroom: 'Ванная',
    cat_office: 'Кабинет',
    cat_anywhere: 'Везде',
    cat_items: 'предметов',
    cat_pick_hint: 'Выберите комнату, чтобы увидеть мебель',
    model_label: 'Модель',
    model_count: 'моделей',
    type_label: 'Тип',
    wall_label: 'Стена',
    wall_side_label: 'Сторона',
    wall_side_a: 'Эта сторона',
    wall_side_b: 'Другая сторона',
    position_label: 'Позиция',
    along_wall: 'вдоль стены',
    add_prefix: 'Добавить',
    item_label: 'Предмет',
    wall_top: 'Верх',
    wall_bottom: 'Низ',
    wall_left: 'Слева',
    wall_right: 'Справа',
    wall_suffix: 'стена',
    interior_wall_label: 'Внутренняя стена',
    flip_to_other_side: 'Перенести на другую сторону',
    selected_label: 'выбрано',

    // 3D design styles — Door
    opstyle_door_panel4: '4 филёнки',
    opstyle_door_flush: 'Гладкая современная',
    opstyle_door_glass: 'Со стеклом',
    opstyle_door_barn: 'Раздвижная амбарная',
    opstyle_door_french: 'Французская двойная',
    opstyle_door_panel6: '6 филёнок, колониальная',
    // Window
    opstyle_window_doublehung: 'Двойное подъёмное',
    opstyle_window_casement: 'Створчатое',
    opstyle_window_picture: 'Панорамное',
    opstyle_window_grid: 'Многостворчатая решётка',
    opstyle_window_arched: 'С аркой сверху',
    opstyle_window_sliding: 'Раздвижное',
    // Archway
    opstyle_archway_round: 'Круглая арка',
    opstyle_archway_gothic: 'Готическая арка',
    opstyle_archway_flat: 'Прямой проём',
    opstyle_archway_elliptical: 'Эллиптическая арка',
    opstyle_archway_roman: 'Римская с замковым камнем',
    opstyle_archway_modern: 'Современный минимализм',
    // Painting
    opstyle_painting_abstract: 'Абстракция',
    opstyle_painting_baroque: 'Барокко',
    opstyle_painting_modern: 'Современная чёрная',
    opstyle_painting_canvas: 'Холст без рамы',
    opstyle_painting_collage: 'Фотоколлаж',
    opstyle_painting_landscape: 'Пейзаж маслом',
    // AC Unit
    opstyle_ac_split: 'Сплит-система',
    opstyle_ac_cassette: 'Кассетный',
    opstyle_ac_curved: 'Изогнутый премиум',
    opstyle_ac_window: 'Оконный',
    opstyle_ac_slim: 'Тонкий настенный',
    opstyle_ac_retro: 'Ретро',
    // Wall Clock
    opstyle_clock_analog: 'Классические аналоговые',
    opstyle_clock_digital: 'Цифровые LED',
    opstyle_clock_cuckoo: 'Кукушка (дерево)',
    opstyle_clock_oversized: 'Крупные минималистичные',
    opstyle_clock_vintage: 'Винтажные латунные',
    opstyle_clock_skeleton: 'Скелетон модерн',
    // Power Outlet
    opstyle_outlet_eu: 'Евророзетка',
    opstyle_outlet_us: 'Американская',
    opstyle_outlet_uk: 'Британская 3-контактная',
    opstyle_outlet_usb: 'С портом USB',
    opstyle_outlet_brass: 'Латунная напольная',
    opstyle_outlet_industrial: 'Промышленная металлическая',
    // Radiator
    opstyle_radiator_panel: 'Панельный конвектор',
    opstyle_radiator_castiron: 'Чугунная секция',
    opstyle_radiator_towel: 'Полотенцесушитель',
    opstyle_radiator_vertical: 'Вертикальный дизайнерский',
    opstyle_radiator_skirting: 'Низкий плинтусный',
    opstyle_radiator_electric: 'Электрическая панель',

    // House3DView
    back: 'Назад',
    preview_3d: '3D Просмотр',
    full_house: 'Весь дом',
    drag_hint_3d: 'Перетащите для вращения · Прокрутите для масштаба',
    screenshot: 'Снимок',

    // Room types
    room_living: 'Гостиная',
    room_kitchen: 'Кухня',
    room_bedroom: 'Спальня',
    room_bathroom: 'Ванная',
    room_hallway: 'Коридор',
    room_garage: 'Гараж',
    room_office: 'Кабинет',
    room_dining: 'Столовая',
    room_custom: 'Комната',

    // Furniture types
    furn_sofa: 'Диван',
    furn_armchair: 'Кресло',
    furn_table: 'Обеденный стол',
    furn_chair: 'Стул',
    furn_bed: 'Кровать',
    furn_desk: 'Письменный стол',
    furn_tv: 'Телевизор',
    furn_shelf: 'Книжная полка',
    furn_wardrobe: 'Шкаф',
    furn_bathtub: 'Ванна',
    furn_toilet: 'Унитаз',
    furn_sink: 'Раковина',
    furn_lamp: 'Торшер',
    furn_plant: 'Растение',
    furn_rug: 'Ковёр',
    light_chandelier: 'Современная люстра',
    light_ceiling_lamp: 'Минималистичный потолочный светильник',

    // Material categories
    cat_all: 'Все',
    cat_wood: 'Дерево',
    cat_laminate: 'Ламинат',
    cat_stone: 'Камень',
    cat_tile: 'Плитка',
    cat_carpet: 'Ковёр',
    cat_vinyl: 'Винил',
    cat_neutral: 'Нейтральный',
    cat_colour: 'Цвет',
    cat_texture: 'Текстура',
    cat_pattern: 'Узор',
    cat_plain: 'Однотонный',

    // Finish options
    fin_matte: 'Матовый',
    fin_satin: 'Сатиновый',
    fin_semi_gloss: 'Полуглянцевый',
    fin_gloss: 'Глянцевый',
    fin_metallic: 'Металлик',
    fin_brushed_metal: 'Шлифованный',
    fin_velvet: 'Бархат',
    fin_pearl: 'Перламутр',
    fin_concrete: 'Бетон',

    // Landing page
    lnd_signin: 'Войти',
    lnd_browse_title:      'Каталог товаров',
    lnd_search_ph:         'Поиск товаров…',
    lnd_search_btn:        'Найти',
    lnd_search_loading:    'Идёт поиск…',
    lnd_search_none:       'Ничего не найдено. Попробуйте другое слово.',
    lnd_search_all:        'Показать все результаты →',
    lnd_cat_found:         'Найдено товаров: {n}',
    lnd_pages:             'Страницы',
    lnd_prev:              'Предыдущая страница',
    lnd_next:              'Следующая страница',
    lnd_sort:              'Сортировка',
    lnd_sort_new:          'Сначала новые',
    lnd_sort_cheap:        'Сначала дешёвые',
    lnd_sort_dear:         'Сначала дорогие',
    lnd_sort_mix:          "Вперемешку",
    sr_rec_title:          "Рекомендуемые",
    sr_rec_more:           "Показать все рекомендуемые (ещё {n})",
    sr_rec_less:           "Свернуть",
    sr_all_title:          "Все товары",
    lnd_badge_new:         'Новое',
    lnd_more_title:        'Хотите увидеть больше?',
    lnd_more_sub:          'Создайте бесплатный аккаунт, чтобы ставить лайки, писать дизайнерам, сохранять товары и проектировать комнату в 3D.',
    lnd_more_cta:          'Зарегистрироваться',
    lang_settings: 'Язык',
    lnd_signup: 'Регистрация',
    lnd_open_app: 'Открыть',
    lnd_kicker: '3D-дизайн дома · AI-визуализация',
    lnd_title_pre: 'Спроектируйте дом',
    lnd_title_hl: 'с помощью ИИ,',
    lnd_title_post: 'в 3D.',
    lnd_sub: 'Чертите планировки и обставляйте комнаты в 3D, превращайте любой вид в фотореалистичную ИИ-визуализацию и находите дизайнера, который продолжит работу, — всё в браузере и бесплатно.',
    lnd_sub_short: 'Планируйте комнаты в 3D, визуализируйте их с ИИ и находите дизайнера. Бесплатно, в браузере.',
    lnd_cta: 'Начать проект',
    lnd_badge_2d: '2D план',
    lnd_badge_3d: '+ 3D вид',
    lnd_feat_kicker: 'Всё что нужно',
    lnd_feat_title: 'ИИ, 3D и дизайнеры',
    lnd_feat1_title: 'ИИ-визуализации',
    lnd_feat1_desc: 'Превратите любой 3D-вид в фотореалистичное изображение. Опишите нужное настроение и получите готовый рендер за секунды.',
    lnd_feat2_title: 'Планировка и мебель в 3D',
    lnd_feat2_desc: 'Чертите планы по сетке, расставляйте двери, окна и мебель, а затем осматривайте результат в 3D.',
    lnd_feat3_title: 'Найдите дизайнера',
    lnd_feat3_desc: 'Смотрите работы дизайнеров, подписывайтесь на понравившихся и пишите им напрямую, когда захотите передать проект профессионалу.',
    lnd_steps_title: 'Как это работает',
    lnd_step1_label: 'Рисуйте комнаты',
    lnd_step1_sub: 'Кликайте на сетке для размещения стен и формирования контуров комнат.',
    lnd_step2_label: 'Добавьте детали',
    lnd_step2_sub: 'Расставьте двери, окна, мебель и выберите цвета для каждой поверхности.',
    lnd_step3_label: 'Смотрите в 3D',
    lnd_step3_sub: 'Один клик — и полная 3D-прогулка по вашему проекту.',
    lnd_bottom_title: 'Готовы начать проектирование?',
    lnd_bottom_sub: 'Регистрация не нужна. Откройте конструктор и создайте план прямо сейчас.',
    nav_home: 'Главная',
    nav_menu: 'Меню',
    nav_designers: 'Дизайнеры',
    nav_marketplace: 'Магазин',
    nav_projects: 'Мои проекты',
    lnd_steps_sub: 'От пустой сетки до фотореалистичной комнаты — за четыре шага.',
    lnd_step4_label: 'Обставьте по-настоящему',
    lnd_step4_sub: 'Найдите товары из вашего проекта или передайте его дизайнеру.',
    lnd_tr_title: 'До и после',
    lnd_tr_sub: 'Два пути: обставить фото существующей комнаты или отрендерить то, что вы построили в 3D.',
    lnd_tr_before: 'До',
    lnd_tr_after: 'После',
    lnd_tr1_t: 'Пустая комната с мебелью',
    lnd_tr1_b: 'Загрузите фото комнаты как есть. ИИ обставит её, сохранив стены, окна и пропорции на своих местах.',
    lnd_tr2_t: '3D-сцена как настоящая',
    lnd_tr2_b: 'Постройте комнату в 3D, выберите ракурс и превратите его в фотореалистичное изображение — та же планировка, со светом и отделкой.',
    lnd_dsg_title: 'Дизайнеры на Tunify',
    lnd_dsg_all: 'Все дизайнеры',
    lnd_shops_title: "Магазины на Tunify",
    lnd_shops_all: "Все магазины",
    lnd_shop_title: 'Обставьте',
    lnd_shop_sub: 'Мебель, материалы и отделка от магазинов на Tunify.',
    lnd_shop_all: 'В магазин',
    lnd_dsg_projects: 'опубликовано: {n}',
    lnd_footer_copy: '© 2026 Tunify · Все права защищены',

    // AuthLayout brand panel
    al_headline_pre: 'Спроектируйте',
    al_headline_hl:  'Дом мечты',
    al_tagline:      'Дизайн интерьера с ИИ. Чертите планировки, обставляйте комнаты и совершайте 3D-прогулки — прямо в браузере, бесплатно.',
    al_stat_free:    'Навсегда бесплатно',
    al_stat_3d:      '3D-прогулка',
    al_stat_furn:    'Предметов мебели',

    // Dashboard
    dash_sign_out:         'Выйти',
    menu_language:         'Язык',
    menu_dark_mode:        'Тёмная тема',
    menu_light_mode:       'Светлая тема',
    menu_sign_out:         'Выйти',
    menu_admin:            'Панель администратора',
    adm_title:             'Аналитика',
    adm_sec_ai:            'Расходы на AI по типу',
    adm_flow_render:       '3D-рендер',
    adm_flow_staging:      'Стейджинг комнаты',
    adm_flow_render_total: '3D-рендер, за всё время',
    adm_flow_staging_total: 'Стейджинг, за всё время',
    adm_flow_sub:          '{n} изображений · {rate}/изображение',
    adm_n_images:          '{n} изображений',
    adm_flow_unattributed: '{n} генераций записаны до разделения расходов по типу — они входят в общий итог, но не попадают ни в одну карточку.',
    adm_signed_in:         'Вы вошли как {who}. Все даты — UTC.',
    adm_back:              'Приложение',
    adm_tf_day:            'Сегодня',
    adm_tf_week:           '7 дней',
    adm_tf_month:          '30 дней',
    adm_tf_year:           '12 месяцев',
    adm_sec_product:       'Продукт',
    adm_sec_content:       'Контент',
    adm_sec_accounts:      'Аккаунты по типу',
    adm_sec_traffic:       'Трафик',
    adm_total_users:       'Всего пользователей',
    adm_total_posts:       'Всего публикаций',
    adm_posts_today:       'Публикаций сегодня',
    adm_projects:          'Проекты',
    adm_products:          'Товары',
    adm_right_now:         'сейчас',
    adm_new_users:         'Новые пользователи',
    adm_active_users:      'Активные пользователи',
    adm_generations:       'AI-генерации',
    adm_spend:             'Расходы на AI',
    adm_customers:         'Клиенты',
    adm_designers:         'Дизайнеры',
    adm_shops:             'Магазины',
    adm_unclassified:      'Без типа',
    adm_all_time:          'за всё время',
    adm_today:             'сегодня',
    adm_in_range:          'за период',
    adm_n_all_time:        '{n} за всё время',
    adm_spend_sub:         '{total} за всё время',
    adm_new_in_range:      '+{n} новых',
    adm_no_type:           'тип аккаунта не записан',
    adm_chart_registrations: 'Новые регистрации',
    adm_chart_dau:         'Активные пользователи за день',
    adm_peak:              'пик {n}',
    adm_visitors:          'Посетители',
    adm_cached:            'из кэша, ≤30 мин',
    adm_pageviews:         'Просмотры страниц',
    adm_unique:            'Уникальные посетители',
    adm_distinct:          'уникальных людей',
    adm_sessions:          'Сессии',
    adm_visits:            'визиты',
    adm_bounce:            'Показатель отказов',
    adm_conversion:        'Конверсия',
    adm_conversions_n:     '{n} конверсий',
    adm_loading_traffic:   'Загрузка трафика…',
    adm_ga_not_connected:  'Аналитика не подключена.',
    adm_ga_no_property:    'Ресурс GA4 не настроен.',
    adm_ga_step_access:    'Откройте Analytics → Администратор → Управление доступом к ресурсу.',
    adm_ga_step_viewer:    'Добавьте этот аккаунт с ролью «Читатель»:',
    adm_ga_step_viewer_generic: 'Добавьте сервисный аккаунт функций этого проекта с ролью «Читатель».',
    adm_ga_step_wait:      'Подождите минуту и обновите страницу. Повторное развёртывание не нужно.',
    adm_ga_step_id:        'Укажите ID ресурса — числовой, не G-XXXXXXX:',
    adm_ga_step_api:       'Включите Analytics Data API в Google Cloud.',
    adm_ga_step_redeploy:  'Разверните заново:',
    adm_err_claim:         'В вашей сессии ещё нет прав администратора. Выйдите и войдите снова.',
    adm_err_load:          'Не удалось загрузить статистику.',
    adm_no_data:           'Нет данных за этот период.',
    adm_foot:              'Счётчики обновляются Cloud Functions по мере событий; эта страница читает один документ на каждый итог и по одной небольшой записи в день.',
    menu_plans:            'Тарифы и кредиты',
    menu_gen_code:         'Создать код доступа',
    menu_generating:       'Создание…',
    menu_code_hint:        'Передайте этот код владельцу проекта, чтобы получить доступ на редактирование. Действует 10 минут.',
    dash_signing_out:      'Выход…',
    dash_get_started:      'Начать',
    dash_designer_title:   'Открыть конструктор',
    dash_designer_desc:    'Чертите планировки, расставляйте мебель и смотрите в 3D.',
    dash_workspace_title:  'Мои проекты',
    dash_workspace_desc:   'Управляйте своими проектами и коллекциями.',
    dash_inspo_title:      'Вдохновение',
    dash_inspo_desc:       'Подборки готовых дизайнов и шаблонов интерьеров.',
    dash_coming_soon:      'Скоро',

    // Settings
    set_title:             'Настройки аккаунта',
    set_back_to_dash:      'Назад в панель',
    set_fullname_label:    'Полное имя',
    set_no_name:           'Имя не указано',
    set_save:              'Сохранить изменения',
    set_saving:            'Сохранение…',
    set_saved:             'Полное имя обновлено.',
    set_save_failed:       'Не удалось сохранить. Попробуйте снова.',
    set_change_password_title:  'Изменить пароль',
    set_current_password_label: 'Текущий пароль',
    set_current_password_ph:    'Введите текущий пароль',
    set_new_password_label:     'Новый пароль',
    set_change_password_btn:    'Изменить пароль',
    set_changing_password:      'Изменение…',
    set_password_changed:       'Пароль успешно изменён.',
    set_wrong_current_password: 'Неверный текущий пароль.',
    set_google_only_password:   'Вы вошли через Google — здесь нет пароля для изменения.',

    // Workspace
    ws_sign_out:                  'Выйти',
    ws_signing_out:               'Выход…',
    ws_title:                     'Мои проекты',
    ws_sub:                       'Управляйте своими 3D-планировками и сценами',
    ws_new_collection:            'Новая коллекция',
    ws_new_project:               'Новый проект',
    ws_add_project:               'Добавить проект',
    ws_tab_projects:              'Все проекты',
    ws_tab_collections:           'Коллекции',
    ws_back_collections:          'Коллекции',
    ws_collection_label:          'Коллекция',
    ws_project_one:               'проект',
    ws_project_many:              'проектов',
    ws_in_collection:             'в этой коллекции',
    ws_empty_projects_title:      'Нет проектов',
    ws_empty_projects_sub:        'Создайте первый проект, чтобы начать.',
    ws_new_project_action:        '+ Новый проект',
    ws_empty_collections_title:   'Нет коллекций',
    ws_empty_collections_sub:     'Объедините проекты в коллекции.',
    ws_new_collection_action:     '+ Новая коллекция',
    ws_empty_col_title:           'Нет проектов',
    ws_empty_col_sub:             'Добавьте первый проект в эту коллекцию.',
    ws_add_project_action:        '+ Добавить проект',
    ws_field_required:            'Это поле обязательно.',
    ws_create:                    'Создать',
    ws_creating:                  'Создаём…',
    ws_delete:                    'Удалить',
    ws_rename:                    'Переименовать',
    ws_copy:                      'Копировать',
    ws_rename_title:              'Переименовать проект',
    ws_save:                      'Сохранить',
    ws_saving:                    'Сохранение…',
    ws_yes:                       'Да',
    ws_no:                        'Нет',
    ws_confirm_del_title:         'Удалить проект?',
    ws_confirm_del_msg:           'Проект будет удалён без возможности восстановления.',
    ws_confirm_del_col_title:     'Удалить коллекцию?',
    ws_confirm_del_col_msg:       'Коллекция будет удалена. Её проекты сохранятся и станут самостоятельными.',
    cc_estimate:                  'Смета',
    cc_reload:                    'Пересчитать',
    cc_title:                     'Смета стоимости',
    cc_currency:                  'Валюта',
    cc_empty:                     'В проекте пока нет комнат — добавьте их, чтобы рассчитать стоимость.',
    cc_surfaces:                  'Поверхности',
    cc_room:                      'Комната',
    cc_floor:                     'Пол',
    cc_wall:                      'Стены',
    cc_ceiling:                   'Потолок',
    cc_total:                     'Итого',
    cc_free_walls:                'Свободные стены',
    dl_title:            'Скачать изображение',
    dl_sub:              'Сохраните текущий вид или превратите его в фотореалистичный рендер с помощью ИИ.',
    dl_model_flux:        'AI Generation',
    dl_model_flux_desc:   'Быстрая фотореалистичная обработка проекта.',
    dl_model_soon:        'СКОРО',
    dl_model_locked_desc: 'Временно недоступно.',
    dl_original:         'Скачать оригинал',
    dl_original_desc:    'Сохранить 3D-вид точно так, как он выглядит сейчас.',
    dl_ai:               'Создать FHD ИИ',
    dl_ai_desc:          'Фотореалистичный рендер вашей планировки в Full HD.',
    dl_ai_loading:       'Создаём рендер…',
    dl_ai_loading_desc:  'Это может занять до минуты. Не закрывайте окно.',
    dl_ai_success:       'ИИ-рендер загружен.',
    dl_ai_failed:        'Не удалось создать рендер. Попробуйте ещё раз.',
    dl_ai_signin:        'Войдите, чтобы использовать ИИ-рендеринг.',
    dl_ready_sub:        'Рендер готов. Нажмите, чтобы сохранить.',
    dl_save:             'Сохранить изображение',
    dl_save_desc:        'Сохранить рендер на устройство.',
    dl_capture_failed:   'Не удалось снять 3D-вид. Попробуйте ещё раз.',
    cc_per_sqm:                   'цена / м²',
    cc_items:                     'Предметы',
    cc_item:                      'Предмет',
    cc_qty:                       'Кол-во',
    cc_unit_price:                'Цена за шт.',
    cc_items_total:               'Итого предметы',
    cc_grand_total:               'Итоговая цена',
    cc_calculate:                 'Рассчитать',
    cc_cur_USD:                   'Доллар',
    cc_cur_RUB:                   'Рубль',
    cc_cur_AMD:                   'Драм',
    ws_modal_project_title:       'Новый проект',
    ws_modal_project_label:       'Название проекта',
    ws_modal_project_ph:          'напр. Дизайн гостиной',
    ws_size_label:                'Размер холста',
    ws_modal_collection_title:    'Новая коллекция',
    ws_modal_collection_label:    'Название коллекции',
    ws_modal_collection_ph:       'напр. Летний дом',
    ws_modal_addtocol_title:      'Добавить проект в коллекцию',
    ws_modal_addtocol_label:      'Название проекта',
    ws_modal_addtocol_ph:         'напр. Мастер-спальня',

    // Auth pages
    auth_login_title:      'С возвращением',
    auth_login_sub:        'Войдите, чтобы продолжить проектирование.',
    auth_google_signin:    'Войти через Google',
    auth_google_signup:    'Зарегистрироваться через Google',
    auth_or_email_signin:  'или войдите по email',
    auth_phone_signin:     'Войти по телефону',
    auth_phone_signup:     'Регистрация по телефону',
    auth_or_phone_signin:  'или войдите по номеру телефона',
    auth_or_phone_signup:  'или зарегистрируйтесь по телефону',
    auth_phone_back_email: 'Использовать email',
    phone_label:           'Номер телефона',
    phone_country:         'Страна',
    phone_ph:              '77 12 34 56',
    phone_hint:            'Мы отправим SMS с 6-значным кодом. Может взиматься плата оператора.',
    phone_recaptcha_note:    'Этот сайт защищён reCAPTCHA; применяются {privacy} и {terms} Google.',
    phone_recaptcha_privacy: 'Политика конфиденциальности',
    phone_recaptcha_terms:   'Условия использования',
    phone_send:            'Отправить код',
    phone_sending:         'Отправка…',
    phone_code_label:      'Код подтверждения',
    phone_code_sent:       'Введите 6-значный код, отправленный на номер',
    phone_verify:          'Подтвердить и продолжить',
    phone_verifying:       'Проверка…',
    phone_resend:          'Отправить снова',
    phone_resend_in:       'Повтор через {n} с',
    phone_change:          'Изменить номер',
    phone_err_required:      'Введите номер телефона.',
    phone_err_invalid:       'Похоже, это неверный номер для выбранной страны.',
    phone_err_code_required: 'Введите 6-значный код.',
    phone_err_code_invalid:  'Неверный код. Проверьте и попробуйте снова.',
    phone_err_code_expired:  'Срок действия кода истёк. Запросите новый.',
    phone_err_expired_session: 'Время проверки истекло. Запросите новый код.',
    phone_err_too_many:      'Слишком много попыток. Подождите несколько минут.',
    phone_err_quota:         'SMS временно недоступны. Попробуйте позже или используйте email.',
    phone_err_captcha:       'Проверка не пройдена. Обновите страницу и попробуйте снова.',
    phone_err_network:       'Ошибка сети. Проверьте подключение.',
    phone_err_not_enabled:   'Вход по телефону сейчас недоступен.',
    phone_err_unauthorized_domain: 'Не удалось проверить устройство. Обновите страницу и попробуйте снова или используйте email.',
    phone_err_disabled:      'Этот аккаунт заблокирован.',
    phone_err_in_use:        'Этот номер уже привязан к другому аккаунту.',
    phone_err_generic:       'Что-то пошло не так. Попробуйте снова.',
    auth_or_email_signup:  'или зарегистрируйтесь по email',
    auth_email_label:      'Email',
    auth_email_ph:         'вы@пример.com',
    auth_id_label:         'Email или телефон',
    auth_id_ph:            'вы@пример.com или +374 77 12 34 56',
    auth_id_phone_hint:    'Оставьте пароль пустым — отправим код в SMS.',
    auth_id_phone_pw_hint: 'Вход по номеру телефона и паролю.',
    auth_err_phone_no_password: 'Для этого номера пароль не задан. Оставьте поле пустым, чтобы войти по коду.',
    auth_err_email_reserved: 'Этот адрес зарезервирован. Используйте другой.',
    auth_err_password_not_set: 'Не удалось сохранить пароль. Его можно задать позже в настройках.',
    phone_pw_intro:        'Номер подтверждён. Задайте пароль, чтобы входить без ожидания кода.',
    phone_pw_hint:         'Минимум 6 символов. Вы всегда сможете войти и по коду.',
    phone_pw_save:         'Сохранить пароль',
    phone_pw_skip:         'Пропустить',
    nav_ai:                'AI',
    sup_admin_name:            'Админ',
    adm_support_target_you:    'Обращения к админу приходят на этот аккаунт.',
    adm_support_target_other:  'Обращения к админу идут на {uid}.',
    adm_support_target_none:   'Аккаунт поддержки не выбран — кнопка «Связаться с админом» скрыта у всех.',
    adm_support_claim:         'Использовать этот аккаунт',
    sup_contact_admin:     'Связаться с админом',
    sup_opening:           'Открываем…',
    close:                 'Закрыть',
    sup_sub:               'Напишите нам, и мы ответим.',
    sup_message:           'Сообщение',
    sup_message_ph:        'Чем мы можем помочь?',
    sup_contact:           'Как с вами связаться',
    sup_contact_ph:        'Телефон или email',
    sup_send:              'Отправить',
    sup_sending:           'Отправка…',
    sup_done:              'Сообщение отправлено. Мы ответим как только сможем.',
    sup_or_call:           'Или позвоните напрямую',
    sup_err_failed:        'Не удалось отправить. Проверьте соединение и попробуйте снова.',
    sup_err_rejected:      'Сообщение не принято. Попробуйте сократить его.',
    sup_err_wait:          'Подождите {s} с перед отправкой следующего сообщения.',
    adm_support:           'Сообщения в поддержку',
    adm_support_none:      'Пока нет сообщений.',
    adm_support_new:       'Новое',
    adm_support_handled:   'Обработано',
    adm_support_mark:      'Отметить обработанным',
    adm_support_reopen:    'Вернуть в новые',
    adm_support_signedout: 'Без входа',
    nav_about:             'О нас',
    nav_privacy:           'Конфиденциальность',
    nav_support:           'Связаться с нами',
    builder_move:          'Переместить',
    builder_move_on:       'Перемещение',
    phone_exists_title:    'На номер {number} уже зарегистрирован аккаунт Tunify.',
    phone_exists_body:     'Мы выполнили вход в него. Если вы хотели создать второй аккаунт, используйте другой номер.',
    phone_exists_continue: 'Перейти в аккаунт',
    phone_taken_body:      'Код не отправлен. Войдите с этим номером или вернитесь и укажите другой.',
    phone_taken_signin:    'Войти с этим номером',
    phone_pw_reset_intro:  'Номер подтверждён. Придумайте новый пароль.',
    phone_pw_reset_save:   'Сохранить новый пароль',
    phone_pw_reset_skip:   'Продолжить без смены пароля',
    phone_pw_reset_new:    'Аккаунта с этим номером не было — мы его создали. Придумайте пароль.',
    auth_forgot_use_phone: 'Сбросить по номеру телефона',
    auth_forgot_use_email: 'Сбросить по адресу email',
    auth_password_label:   'Пароль',
    auth_password_ph:      '••••••••',
    auth_forgot:           'Забыли пароль?',
    auth_signin_btn:       'Войти',
    auth_signin_ing:       'Вход…',
    auth_no_account:       'Нет аккаунта?',
    auth_create_free:      'Создайте бесплатно',
    auth_register_title:   'Создать аккаунт',
    auth_register_sub:     'Начните проектировать — бесплатно, без карты.',
    auth_name_label:       'Полное имя',
    auth_name_ph:          'Иван Иванов',
    auth_password_min_ph:  'Мин. 6 символов',
    auth_confirm_label:    'Подтвердите пароль',
    auth_confirm_ph:       'Повторите пароль',
    auth_signup_btn:       'Создать аккаунт',
    auth_signup_ing:       'Создаём аккаунт…',
    auth_have_account:     'Уже есть аккаунт?',
    auth_signin_link:      'Войти',
    auth_pw_tooshort:      'Слишком короткий',
    auth_pw_weak:          'Слабый',
    auth_pw_fair:          'Средний',
    auth_pw_good:          'Хороший',
    auth_pw_strong:        'Надёжный',
    auth_forgot_title:     'Сброс пароля',
    auth_forgot_sub:       'Введите email — мы отправим 6-значный код для сброса пароля.',
    auth_reset_step_sub:   'Введите код и выберите новый пароль.',
    auth_reset_password_btn: 'Сбросить пароль',
    auth_resetting:        'Сброс…',
    auth_reset_done_title: 'Пароль сброшен!',
    auth_reset_done_sub:   'Теперь вы можете войти с новым паролем.',
    auth_code_sent_to:     'Код отправлен на',
    auth_email_addr_label: 'Email адрес',
    auth_send_reset:       'Отправить ссылку',
    auth_sending:          'Отправка…',
    auth_back_login:       '← Назад ко входу',
    auth_inbox_title:      'Проверьте почту',
    auth_inbox_sent:       'Мы отправили ссылку для сброса пароля на',
    auth_inbox_spam:       'Если письмо не пришло — проверьте папку «Спам».',
    auth_err_name:         'Имя должно содержать не менее 2 символов.',
    auth_err_email_req:    'Введите email.',
    auth_err_email_inv:    'Введите корректный email.',
    auth_err_email_taken:  'Аккаунт с этим email уже существует.',
    auth_err_email_google: 'Этот email зарегистрирован через Google. Войдите через Google.',
    auth_err_no_account:   'Аккаунт с этим email не найден.',
    auth_err_pass_req:     'Введите пароль.',
    auth_err_pass_min:     'Пароль должен содержать не менее 6 символов.',
    auth_err_conf_req:     'Подтвердите пароль.',
    auth_err_conf_match:   'Пароли не совпадают.',

    // Email OTP verification (RegisterForm + EmailCodeVerify)
    auth_send_code:        'Отправить код',
    auth_sending_code:     'Отправка…',
    auth_code_label:       'Код подтверждения',
    auth_verify_btn:       'Подтвердить',
    auth_verifying:        'Проверка…',
    auth_resend_code:      'Отправить снова',
    pl_title: 'Тарифы и кредиты',
    pl_title_credits: 'AI-кредиты',
    pl_lead_credits: 'Кредиты оплачивают AI-генерацию. Пакет покупается один раз — без подписки, кредиты не сгорают.',
    pl_balance: 'У вас {n} кредитов',
    pl_on_plan: 'Тариф {p}',
    crb_title: 'Ваши AI-кредиты',
    icm_title: 'Недостаточно кредитов',
    pst_your_plan: 'Ваш тариф',
    ann_title: 'Баннер профиля',
    ann_sub_one: 'Одно изображение вверху вашего публичного профиля.',
    ann_sub_many: 'До {n} изображений — карусель вверху вашего публичного профиля.',
    ann_add: 'Добавить',
    ann_working: 'Обработка…',
    ann_remove: 'Удалить',
    ann_move_left: 'Влево',
    ann_move_right: 'Вправо',
    ann_err_not_image: 'Это не изображение.',
    ann_err_read: 'Не удалось прочитать изображение. Попробуйте другое.',
    ann_err_too_big: 'Изображение слишком большое даже после сжатия. Выберите меньше.',
    ann_err_save: 'Не удалось сохранить. Попробуйте ещё раз.',
    ann_err_denied: 'Ваш тариф этого не позволяет. Обновите страницу и проверьте тариф.',
    pst_msg_free: 'Поднимите профиль выше в поиске',
    pst_msg_bronze: 'Выше в поиске и в рекомендациях',
    pst_msg_silver: 'Первые места в поиске и на главной',
    pst_msg_gold: 'Максимальный тариф — везде первые места',
    pst_upgrade: 'Перейти на {p}',
    pst_manage: 'Управление тарифом',
    icm_body: 'Эта генерация стоит больше кредитов, чем у вас осталось. Пополните баланс, чтобы продолжить.',
    icm_have: 'У вас',
    icm_need: 'Нужно',
    icm_buy: 'Купить кредиты',
    icm_cancel: 'Не сейчас',
    pl_lead: 'Начните бесплатно. Переходите на платный тариф, когда нужно больше места, лучшая позиция и кредиты каждый месяц.',
    pl_free: 'Бесплатно',
    pl_name_free: 'Бесплатный',
    pl_name_bronze: 'Бронза',
    pl_name_silver: 'Серебро',
    pl_name_gold: 'Золото',
    pl_per_mo: '{n}/мес',
    pl_once: '{n} разово',
    pl_month: 'мес',
    pl_popular: 'Популярный',
    pl_current: 'Ваш тариф',
    pl_choose: 'Выбрать',
    pl_unlimited: 'Без ограничений',
    pl_credits: 'кредитов',
    pl_credits_mo: '{n} кредитов каждый месяц',
    pl_credits_once: '{n} кредита для начала',
    pl_f_credits: 'AI-кредиты',
    pl_f_portfolio: 'Изображений в портфолио',
    pl_f_projects: 'Проекты',
    pl_f_discount: 'Скидка на пакеты',
    pl_f_messaging: 'Сообщения от клиентов',
    pl_f_search: 'Позиция в поиске',
    pl_f_recommended: 'Рекомендации',
    pl_f_social: 'Наш Instagram и TikTok',
    pl_f_design: 'Дизайн страницы профиля',
    pl_f_banner: 'Баннер профиля',
    pl_lead_shop: 'Ваш магазин и товары — выше в поиске, в рекомендациях и на главной.',
    pl_f_prodimg: 'Фото товара',
    pl_f_recshops: 'Рекомендуемые магазины',
    pl_f_landing: 'Показ на главной',
    pl_recshop_none: 'Никогда',
    pl_recshop_chance: 'Есть шанс',
    pl_recshop_always: 'Всегда',
    pl_social_days: '{n} дня',
    pl_ask_title: 'Есть вопрос или нужно что-то, чего здесь нет?',
    pl_ask_body: 'Напишите команде Tunify напрямую — мы ответим.',
    pl_ask_btn: 'Написать администратору',
    pl_banner_one: '1 изображение',
    pl_banner_many: '{n} — карусель',
    pl_f_support: 'Приоритетная поддержка',
    pl_rank_0: 'Обычная',
    pl_rank_1: 'Нормальная',
    pl_rank_2: 'Выше',
    pl_rank_3: 'Максимальная',
    pl_rec_0: 'Никогда',
    pl_rec_1: 'Малый шанс',
    pl_rec_2: 'Хороший шанс',
    pl_rec_3: 'Всегда',
    pl_social_0: '—',
    pl_social_1: '1 в месяц',
    pl_social_2: '2+ в месяц',
    pl_design_free: 'Обычный',
    pl_design_bronze: 'Bronze',
    pl_design_silver: 'Silver',
    pl_design_gold: 'Gold',
    pl_packs_title: 'Купить кредиты',
    pl_packs_lead: '3D-рендер — {render} кредит. AI-визуализация по фото — {staging}. Кредиты не сгорают.',
    pl_best: 'Выгоднее всего',
    pl_per_credit: '${n} за кредит',
    pl_soon: 'Оплата пока не подключена — цены окончательные, но купить внутри приложения нельзя.',
    auth_code_spam_hint:   'Письмо может идти около минуты. Если его нет, проверьте папку «Спам».',
    auth_resend_in:        'Повторно через',
    auth_email_verified:   'Email подтверждён.',
    auth_enter_email_first: 'Сначала введите корректный email.',
    auth_enter_code:       'Введите 6-значный код.',
    auth_verify_email_gate: 'Сначала подтвердите свой email.',
    auth_verify_step_sub:  'Сначала подтвердите свой email.',
    auth_details_step_sub: 'Почти готово — укажите имя и пароль.',
    auth_type_step_sub: 'Как вы будете использовать Tunify?',
    auth_continue: 'Продолжить',
    ut_title: 'Тип аккаунта',
    ut_customer: 'Клиент',
    atg_welcome: 'Добро пожаловать в Tunify',
    atg_sub: 'Выберите подходящий вариант. Позже его можно изменить в настройках.',
    atg_change_later: 'Тип аккаунта можно изменить в любой момент в настройках.',
    atg_save_failed: 'Не удалось сохранить. Проверьте соединение и попробуйте снова.',
    ut_customer_desc: 'Проектируйте свой дом в 3D, планируйте комнаты и считайте бюджет.',
    ut_designer: 'Дизайнер',
    ut_designer_desc: 'Всё то же, плюс публичный профиль: публикуйте работы и получайте клиентов.',
    ut_shop: 'Магазин',
    ut_shop_desc: 'Продавайте материалы, мебель и фурнитуру — публичная витрина с товарами, ценами и контактами.',

    // ── ПРОФИЛЬ МАГАЗИНА ──
    shop_logo: 'Логотип',
    shop_name: 'Название магазина',
    shop_name_ph: 'например, Камень и Дерево',
    shop_categories: 'Что вы продаёте',
    shop_delivery: 'Есть доставка',
    shop_delivery_hint: 'Показывается в профиле и работает как фильтр в поиске.',
    shop_location: 'Адрес',
    shop_description: 'О магазине',
    shop_description_ph: 'Что продаёте, какие бренды, часы работы…',
    shop_website: 'Сайт',
    shop_socials: 'Контакты и соцсети',
    shop_social_handle: 'имя',
    shop_social_phone: 'Телефон',
    shop_social_instagram: 'Instagram',
    shop_social_facebook: 'Facebook',
    shop_social_tiktok: 'TikTok',
    shop_social_telegram: 'Telegram',
    shop_section_title: 'Профиль магазина',
    shop_section_sub: 'Это то, что видят покупатели, когда находят вас.',
    shop_save: 'Сохранить профиль магазина',
    shop_saved: 'Профиль магазина сохранён.',
    shop_err_name: 'Укажите название магазина (минимум 2 символа).',
    shop_err_categories: 'Выберите хотя бы одну категорию.',
    shop_cat_building_materials: 'Стройматериалы',
    shop_cat_furniture: 'Мебель',
    shop_cat_openings: 'Окна и двери',
    shop_cat_walls: 'Стены и краска',
    shop_cat_floor: 'Напольные покрытия',
    shop_cat_ceiling: 'Потолки',
    shop_cat_lighting: 'Освещение',
    shop_cat_electronics: 'Электроника',
    shop_cat_plumbing: 'Сантехника',
    shop_cat_tiles: 'Плитка',
    shop_cat_textiles: 'Текстиль',
    shop_cat_decor: 'Декор',
    shop_cat_kitchen: 'Кухня',
    shop_cat_bathroom: 'Ванная',
    shop_cat_garden: 'Сад и улица',
    shop_cat_tools: 'Инструменты',
    // ── PRODUCT TAXONOMY ──
    prod_type: 'Тип товара',
    prod_type_ph: 'Выберите тип…',
    prod_subtype: 'Подтип',
    prod_subtype_ph: 'Выберите подтип…',
    prod_color: 'Цвет',
    prod_price_range: 'Цена',
    prod_price_min: 'От',
    prod_price_max: 'До',
    prod_err_type: 'Выберите тип товара.',
    prod_err_subtype: 'Выберите подтип.',
    prod_err_color: 'Выберите цвет.',
    search_products: 'Найти товары',
    search_mode_products: 'Товары',
    search_product_ph: 'Поиск по названию, типу или цвету…',
    search_none_products: 'Товары по этим фильтрам не найдены.',
    prod_color_white: 'Белый',
    prod_color_beige: 'Бежевый',
    prod_color_grey: 'Серый',
    prod_color_black: 'Чёрный',
    prod_color_brown: 'Коричневый',
    prod_color_wood: 'Дерево',
    prod_color_gold: 'Золотой',
    prod_color_silver: 'Серебряный',
    prod_color_blue: 'Синий',
    prod_color_green: 'Зелёный',
    prod_color_red: 'Красный',
    prod_color_yellow: 'Жёлтый',
    prod_color_orange: 'Оранжевый',
    prod_color_pink: 'Розовый',
    prod_color_purple: 'Фиолетовый',
    prod_color_multicolor: 'Разноцветный',
    prod_sub_cement: 'Цемент и раствор',
    prod_sub_plaster_mix: 'Штукатурка и шпаклёвка',
    prod_sub_insulation: 'Утеплитель',
    prod_sub_timber: 'Пиломатериалы',
    prod_sub_drywall: 'Гипсокартон',
    prod_sub_brick_block: 'Кирпич и блоки',
    prod_sub_adhesive: 'Клеи и герметики',
    prod_sub_waterproofing: 'Гидроизоляция',
    prod_sub_sofa: 'Диван',
    prod_sub_armchair: 'Кресло',
    prod_sub_chair: 'Стул',
    prod_sub_table: 'Стол',
    prod_sub_bed: 'Кровать',
    prod_sub_wardrobe: 'Шкаф',
    prod_sub_shelving: 'Стеллаж',
    prod_sub_desk: 'Письменный стол',
    prod_sub_sideboard: 'Комод',
    prod_sub_stool: 'Табурет и банкетка',
    prod_sub_window: 'Окно',
    prod_sub_door_interior: 'Межкомнатная дверь',
    prod_sub_door_entrance: 'Входная дверь',
    prod_sub_sliding_door: 'Раздвижная дверь',
    prod_sub_door_handle: 'Ручки и замки',
    prod_sub_window_sill: 'Подоконник',
    prod_sub_paint: 'Краска',
    prod_sub_wallpaper: 'Обои',
    prod_sub_wall_panel: 'Стеновые панели',
    prod_sub_decorative_plaster: 'Декоративная штукатурка',
    prod_sub_wall_moulding: 'Молдинги и лепнина',
    prod_sub_parquet: 'Паркет',
    prod_sub_laminate: 'Ламинат',
    prod_sub_floor_tile: 'Напольная плитка',
    prod_sub_carpet: 'Ковролин',
    prod_sub_vinyl: 'Винил и кварцвинил',
    prod_sub_skirting: 'Плинтус',
    prod_sub_underlay: 'Подложка',
    prod_sub_stretch_ceiling: 'Натяжной потолок',
    prod_sub_ceiling_panel: 'Потолочные панели',
    prod_sub_plasterboard_ceiling: 'Потолок из гипсокартона',
    prod_sub_cornice: 'Карниз',
    prod_sub_chandelier: 'Люстра',
    prod_sub_pendant_light: 'Подвесной светильник',
    prod_sub_ceiling_light: 'Потолочный светильник',
    prod_sub_wall_light: 'Бра',
    prod_sub_floor_lamp: 'Торшер',
    prod_sub_table_lamp: 'Настольная лампа',
    prod_sub_led_strip: 'Светодиодная лента',
    prod_sub_spotlight: 'Точечный светильник',
    prod_sub_outdoor_light: 'Уличный светильник',
    prod_sub_tv: 'Телевизор',
    prod_sub_fridge: 'Холодильник',
    prod_sub_oven: 'Духовой шкаф',
    prod_sub_hob: 'Варочная панель',
    prod_sub_extractor_hood: 'Вытяжка',
    prod_sub_dishwasher: 'Посудомоечная машина',
    prod_sub_washing_machine: 'Стиральная машина',
    prod_sub_air_conditioner: 'Кондиционер',
    prod_sub_water_heater_el: 'Водонагреватель',
    prod_sub_smart_home: 'Умный дом',
    prod_sub_audio: 'Аудиотехника',
    prod_sub_plumbing_sink: 'Раковина',
    prod_sub_basin: 'Умывальник',
    prod_sub_toilet: 'Унитаз',
    prod_sub_bathtub: 'Ванна',
    prod_sub_shower_cabin: 'Душевая кабина',
    prod_sub_tap: 'Смеситель',
    prod_sub_radiator: 'Радиатор',
    prod_sub_boiler: 'Котёл',
    prod_sub_pipe_fitting: 'Трубы и фитинги',
    prod_sub_ceramic_tile: 'Керамическая плитка',
    prod_sub_porcelain_tile: 'Керамогранит',
    prod_sub_mosaic: 'Мозаика',
    prod_sub_natural_stone: 'Натуральный камень',
    prod_sub_grout: 'Затирка и клей',
    prod_sub_curtains: 'Шторы и жалюзи',
    prod_sub_rug: 'Ковёр',
    prod_sub_cushion: 'Подушки',
    prod_sub_bedding: 'Постельное бельё',
    prod_sub_upholstery_fabric: 'Мебельная ткань',
    prod_sub_towels: 'Полотенца',
    prod_sub_mirror: 'Зеркало',
    prod_sub_wall_art: 'Картины и постеры',
    prod_sub_vase: 'Ваза',
    prod_sub_clock: 'Часы',
    prod_sub_candle_holder: 'Свечи и подсвечники',
    prod_sub_planter_indoor: 'Кашпо',
    prod_sub_figurine: 'Статуэтки',
    prod_sub_photo_frame: 'Фоторамки',
    prod_sub_kitchen_set: 'Кухонный гарнитур',
    prod_sub_countertop: 'Столешница',
    prod_sub_backsplash: 'Кухонный фартук',
    prod_sub_kitchen_sink: 'Кухонная мойка',
    prod_sub_kitchen_tap: 'Кухонный смеситель',
    prod_sub_cookware: 'Посуда',
    prod_sub_kitchen_storage: 'Кухонное хранение',
    prod_sub_vanity_unit: 'Тумба под раковину',
    prod_sub_bathroom_cabinet: 'Шкаф для ванной',
    prod_sub_shower_enclosure: 'Душевое ограждение',
    prod_sub_towel_rail: 'Полотенцесушитель',
    prod_sub_bathroom_mirror: 'Зеркало для ванной',
    prod_sub_bathroom_accessory: 'Аксессуары для ванной',
    prod_sub_garden_furniture: 'Садовая мебель',
    prod_sub_planter_outdoor: 'Уличное кашпо',
    prod_sub_garden_lighting: 'Садовое освещение',
    prod_sub_paving: 'Тротуарная плитка',
    prod_sub_bbq_grill: 'Мангал и гриль',
    prod_sub_fencing: 'Ограждения',
    prod_sub_power_tool: 'Электроинструмент',
    prod_sub_hand_tool: 'Ручной инструмент',
    prod_sub_ladder: 'Лестницы и стремянки',
    prod_sub_measuring_tool: 'Измерительный инструмент',
    prod_sub_fixings: 'Крепёж',
    prod_sub_safety_gear: 'Средства защиты',
    // Публичная страница магазина + карточки товаров
    shop_not_found: 'Такой магазин не найден.',
    prod_gone: 'Это объявление больше недоступно.',
    prod_call: 'Позвонить',
    prod_zoom: 'Открыть во весь экран',
    gate_why_basket: 'Создайте аккаунт, чтобы добавить «{name}» в корзину.',
    shop_tab_products: 'Товары',
    shop_no_products: 'Пока ничего не опубликовано.',
    gal_menu_details: 'Описание и цена',
    gal_details_sub: 'Что это за товар, сколько стоит и где его купить.',
    gal_product_desc_ph: 'Название, размер, материал, бренд…',
    gal_name: 'Название товара',
    gal_name_ph: 'например, Дубовый стул',
    gal_price: 'Цена',
    gal_price_ph: '0',
    gal_product_link: 'Ссылка на товар',
    gal_link_optional: 'Ссылка необязательна — оставьте пустой, чтобы скрыть.',
    gal_price_gate: 'Цена обязательна. Пока она не указана, фото не публикуется — добавить её можно позже через меню карточки.',
    gal_err_price: 'Укажите цену больше 0.',
    gal_err_price_max: 'Слишком большая цена.',
    gal_err_link: 'Это не похоже на ссылку.',
    gal_needs_price: 'Нужна цена',
    gal_needs_details: 'Нужен тип',
    gal_buy: 'Посмотреть товар',
    gal_skip: 'Пропустить',
    gal_image_count: '{n} фото',
    gal_new_post: 'Новая публикация',
    gal_new_post_sub: 'Добавьте до {max} фото и опишите их.',
    gal_new_product_sub: 'Добавьте до {max} фото, затем укажите, что это за товар и сколько он стоит.',
    gal_add_images: 'Добавить фото',
    gal_remove_image: 'Удалить это фото',
    gal_shot_n: 'Фото {n}',
    gal_post: 'Опубликовать',
    gal_images_hint: '{n} из {max} фото. Первое — обложка.',
    gal_err_no_image: 'Добавьте хотя бы одно фото.',
    gal_images: 'Фото в этой публикации',
    gal_err_images_max: 'Добавлены только первые {n} фото — больше в одну публикацию не помещается.',
    ds_avatar: 'Фото профиля',
    ds_avatar_hint: 'Квадратное изображение. Размер меняется автоматически.',
    ds_avatar_remove: 'Удалить',
    avl_open: 'Посмотреть фото профиля',
    tab_feed: 'Главная',
    tab_search: 'Поиск',
    tab_messages: 'Сообщения',
    tab_alerts: 'Уведомления',
    tab_profile: 'Профиль',
    nav_primary: 'Основная навигация',
    avl_change: 'Изменить фото',
    avl_add: 'Добавить фото',
    avl_delete_confirm: 'Удалить фото профиля?',
    avc_title: 'Разместите фото',
    avc_hint: 'Перетащите, чтобы сдвинуть · щипок или колесо для масштаба',
    avc_zoom: 'Масштаб',
    avc_apply: 'Применить',
    ps_likes: 'Лайки',
    ml_title: 'Понравившиеся',
    // ── КОРЗИНА ──
    bsk_title: 'Моя корзина',
    bsk_add: 'В корзину',
    bsk_remove: 'Убрать из корзины',
    bsk_clear: 'Очистить корзину',
    bsk_remove_title: 'Убрать этот товар?',
    bsk_remove_msg: 'Он будет убран из корзины. Вы сможете добавить его снова с его страницы в любой момент.',
    bsk_clear_title: 'Очистить корзину?',
    bsk_clear_msg: 'Все сохранённые товары ({n}) будут убраны.',
    bsk_empty: 'Корзина пуста. Откройте товар магазина и нажмите на значок корзины.',
    bsk_unavailable: 'Больше недоступно',
    chat_title: 'Сообщения',
    chat_message: 'Написать',
    chat_none: 'Пока нет переписок.',
    chat_pick: 'Выберите переписку.',
    chat_empty: 'Сообщений пока нет. Поздоровайтесь.',
    chat_no_messages: 'Сообщений пока нет',
    chat_placeholder: 'Написать сообщение...',
    chat_send: 'Отправить',
    chat_older: 'Показать старые сообщения',
    // ── floor plan import (create-project modal) ──
    fp_label: 'План этажа (необязательно)',
    fp_upload: 'Загрузить план этажа',
    fp_upload_hint: 'PNG или JPG — распознаем комнаты, двери и окна',
    fp_ai_notice: 'Создано ИИ, точность обычно 70–100% в зависимости от чертежа. Сверьте стены, двери и окна с планом и исправьте неточности — всё остаётся редактируемым.',
    fp_detecting: 'Распознаём комнаты…',
    fp_found: '{rooms} комнат · {doors} дверей · {windows} окон',
    fp_nothing_found: 'Ничего не найдено — проект можно создать и начертить вручную.',
    fp_failed: 'Не удалось прочитать план. Попробуйте другое изображение.',
    fp_not_configured: 'Распознавание планов не настроено.',
    fp_remove: 'Удалить',
    fp_scale: 'Масштаб',
    fp_scale_hint: 'Двигайте, пока размер не совпадёт с реальным домом.',
    fp_overlay: 'Исходный план',
    fp_overlay_hint: 'Проявите загруженный чертёж сзади, чтобы проверить совпадение стен.',
    chat_edit: 'Изменить',
    chat_save: 'Сохранить',
    chat_edited: 'изменено',
    chat_reply: "Ответить",
    chat_react: "Реакция",
    chat_actions: "Действия с сообщением",
    chat_img_add: "Отправить фото",
    chat_img_open: "Открыть фото",
    chat_img_working: "Подготовка фото…",
    chat_blocked_word: 'Сообщение не отправлено — слово «{word}» здесь недопустимо.',
    chat_send_failed: 'Сообщение не отправлено. Попробуйте ещё раз.',
    chat_img_type: "Этот файл не является изображением.",
    chat_img_large: "Это фото слишком большое для отправки.",

    // ── comments on a photo ──
    cm_title: "Комментарии",
    cm_none: "Пока нет комментариев. Будьте первым.",
    cm_loading: "Загрузка комментариев…",
    cm_post: "Отправить",
    cm_placeholder: "Написать комментарий…",
    cm_replying: "Ответ для {name}",
    cm_edited: "изменено",
    cm_someone: "Кто-то",
    cm_signin: "Войдите, чтобы участвовать в обсуждении.",
    cm_now: "только что",
    cm_m: "{n} мин",
    cm_h: "{n} ч",
    cm_d: "{n} дн",
    chat_copy: "Копировать",
    chat_replying_to: "Ответ на",
    chat_reply_gone: "Сообщение недоступно",
    chat_delete: 'Удалить переписку',
    chat_delete_confirm: 'Убрать эту переписку из списка? Она вернётся, если вам напишут снова.',
    chat_delete_msg_confirm: 'Удалить это сообщение у всех?',
    chat_loading: 'Загрузка...',
    chat_someone: 'Кто-то',
    chat_you: 'Вы:',
    ml_sub: 'Фото и 3D-проекты, которые вам понравились.',
    ml_empty: 'Пока ничего нет. Нажмите на сердечко у понравившейся работы.',
    ml_untitled: 'Без названия',
    ps_views: 'Просмотры',
    ps_like: 'Нравится',
    ps_liked: 'Нравится',
    ps_unlike: 'Убрать лайк',
    ps_login_to_like: 'Войдите, чтобы поставить лайк',
    ps_like_own: 'Это ваша работа',
    ds_fullname: 'Полное имя',
    ds_fullname_ph: 'Иван Иванов',
    ds_optional: '(необязательно)',
    ds_styles: 'Стили дизайна',
    ds_experience: 'Опыт работы (лет)',
    ds_rate: 'Ставка',
    ds_rate_ph: 'например 5000',
    ds_currency: 'Валюта',
    ds_err_rate: 'Введите корректную ставку.',
    ds_years_short: '{n} лет опыта',
    ds_per_hour: '/час',
    gal_prev: 'Назад',
    gal_shrink: 'Выйти из полного просмотра',
    gal_next: 'Вперёд',
    ds_location: 'Локация',
    ds_location_ph: 'Начните вводить город…',
    ds_location_map_hint: 'Найдите место или кликните по карте, чтобы поставить метку.',
    ds_description: 'О себе',
    ds_description_ph: 'Расскажите клиентам о своей работе и подходе…',
    ds_websites: 'Сайты',
    ds_add_website: 'Добавить сайт',
    ds_contacts: 'Контакты',
    ds_add_contact: 'Добавить контакт',
    ds_contact_link: 'Ссылка',
    ds_contact_phone: 'Телефон',
    ds_remove: 'Удалить',
    ds_err_name: 'Введите полное имя (минимум 2 символа).',
    ds_err_name_long: 'Слишком длинное имя.',
    ds_err_desc_long: 'Слишком длинное описание.',
    ds_err_experience: 'Введите целое число лет от 0 до 70.',
    ds_err_styles_max: 'Выбрано слишком много стилей.',
    ds_err_sites_max: 'Слишком много сайтов.',
    ds_err_site_invalid: 'Один из адресов сайта указан неверно.',
    ds_err_contacts_max: 'Слишком много контактов.',
    ds_err_contact_invalid: 'Один из контактов не является ссылкой или телефоном.',
    ds_err_avatar: 'Не удалось обработать изображение. Попробуйте другое.',
    ds_err_avatar_large: 'Изображение слишком большое даже после сжатия.',
    ds_section_title: 'Профиль дизайнера',
    gal_photos_title: 'Фотографии',
    like_add: 'Нравится',
    like_liked: 'Нравится',
    like_remove: 'Убрать лайк',
    like_own: 'Это ваш профиль',
    like_count: 'Лайки',
    md_title: 'Мои дизайнеры',
    md_card_desc: 'Понравившиеся дизайнеры.',
    md_empty: 'Вы пока никого не отметили. Откройте профиль и нажмите «Нравится».',
    md_liked_shops: 'Понравившиеся магазины',
    md_recommended: 'Рекомендуемые дизайнеры',
    md_recommended_sub: 'Популярные работы показываются чаще, список меняется при каждом визите.',
    md_projects: 'Проекты',
    md_projects_sub: 'Работы и товары, опубликованные на Tunify.',
    md_shops: 'Магазины',
    md_shops_sub: 'Материалы, мебель и фурнитура от магазинов на Tunify.',
    md_work: 'Опубликованное',
    md_filter_all: 'Всё',
    md_filter_projects: 'Проекты',
    md_filter_products: 'Товары',
    md_no_projects: 'Проектов пока нет.',
    md_no_products: 'Товаров пока нет.',
    md_none: 'Пока нечего показать.',
    gal_show_more: 'Показать ещё ({n})',
    notif_title: 'Уведомления',
    notif_none: 'Уведомлений пока нет.',
    notif_liked: '{name} оценил ваш профиль',
    notif_liked_project: '{name} оценил ваш проект',
    notif_liked_photo: '{name} оценил ваше фото',
    notif_replied: "{name} ответил(а) на ваш комментарий",
    notif_commented_photo: '{name} прокомментировал(а) ваше фото',
    notif_commented_design: '{name} прокомментировал(а) ваш проект',
    search_designers: 'Найти дизайнеров',
    search_shops: 'Найти магазины',
    search_mode: 'Что вы ищете',
    search_mode_designers: 'Дизайнеры',
    search_mode_shops: 'Магазины',
    search_shop_ph: 'Поиск по названию или товарам…',
    search_delivery_only: 'Только с доставкой',
    search_none_shops: 'Магазины по этим фильтрам не найдены.',
    search_ph: 'Поиск по имени или стилю…',
    search_any: 'Любой',
    search_exp_min: 'от {n} лет',
    search_clear: 'Сбросить фильтры',
    search_loading: 'Загрузка…',
    search_none: 'Дизайнеры по этим фильтрам не найдены.',
    search_count: 'Дизайнеров: {n}',
    dp_not_found: 'Этот профиль недоступен.',
    dp_no_work: 'Здесь пока ничего не опубликовано.',
    dp_tier_verified: 'Подтверждённый {p}-дизайнер',
    dp_cap_recommended: 'Рекомендуемый',
    dp_cap_partner: "Партнёр",
    dp_cap_prioritySupport: 'Приоритет',
    nav_login: 'Войти',
    gal_settings: 'Настройки',
    gal_menu_publish: 'Сделать публичным',
    gal_menu_unpublish: 'Сделать скрытым',
    gal_menu_description: 'Описание',
    gal_desc_sub: 'Отображается под этим элементом в вашем профиле.',
    gal_save: 'Сохранить',
    gal_yes: 'Да, удалить',
    gal_no: 'Отмена',
    dg_title: 'Опубликованные работы',
    dg_tab_img: 'Фото',
    dg_tab_3d: '3D',
    dg_3d_empty: 'Опубликованных проектов пока нет. Откройте проект и выберите «Опубликовать» в его меню.',
    pub_action: 'Опубликовать',
    pub_title: 'Опубликовать в профиле',
    pub_sub: 'Выберите обложку и опишите проект. Он появится в вашем публичном профиле.',
    pub_pick_cover: '+ Выбрать обложку',
    pub_publish: 'Опубликовать',
    pub_allow_copy: "Разрешить сохранять копию в свою рабочую область",
    pub_allow_download: "Разрешить скачивать изображение",
    pub_err_cover: 'Сначала выберите обложку.',
    gal_designs_title: 'Опубликованные 3D-проекты',
    gal_sub: 'Опубликованные элементы отображаются в вашем профиле.',
    gal_add: '+ Добавить изображения',
    gal_uploading: 'Загрузка…',
    gal_empty: 'Пока ничего не опубликовано. Добавьте изображения своих работ.',
    gal_designs_empty: 'Опубликованных проектов пока нет. Добавьте рендер 3D-комнаты.',
    gal_desc_ph: 'Добавьте описание…',
    gal_hide: 'Скрыть из профиля',
    gal_show: 'Показать в профиле',
    gal_hidden: 'Скрыто',
    gal_delete: 'Удалить',
    gal_open: 'Открыть изображение',
    gal_delete_confirm: 'Удалить этот элемент навсегда?',
    gal_err_upload: 'Не удалось загрузить изображение. Попробуйте другое.',
    gal_err_large: 'Изображение слишком большое даже после сжатия.',
    gal_err_save: 'Не удалось сохранить изменение. Попробуйте ещё раз.',
    gal_err_max: 'Достигнуто максимальное количество элементов.',
    ds_section_sub: 'Эта информация отображается в публичном профиле и в поиске.',
    ds_save: 'Сохранить профиль',
    ds_saved: 'Профиль дизайнера сохранён.',
    ds_saved_unpublished: 'Профиль сохранён, но пока не виден в поиске. Попробуйте сохранить ещё раз.',
    ds_become: 'Стать дизайнером',
    ds_become_desc: 'Публикуйте работы, чтобы клиенты вас находили.',
    ds_style_modern: 'Модерн',
    ds_style_minimalist: 'Минимализм',
    ds_style_scandinavian: 'Скандинавский',
    ds_style_industrial: 'Индустриальный',
    ds_style_loft: 'Лофт',
    ds_style_classic: 'Классика',
    ds_style_neoclassic: 'Неоклассика',
    ds_style_contemporary: 'Современный',
    ds_style_art_deco: 'Ар-деко',
    ds_style_mid_century: 'Середина века',
    ds_style_bohemian: 'Бохо',
    ds_style_rustic: 'Рустик',
    ds_style_farmhouse: 'Фермерский',
    ds_style_provence: 'Прованс',
    ds_style_mediterranean: 'Средиземноморский',
    ds_style_japandi: 'Джапанди',
    ds_style_high_tech: 'Хай-тек',
    ds_style_eclectic: 'Эклектика',
    auth_change_email:     '← Изменить email',

    // Share / public read-only view
    share: 'Поделиться',
    share_title: 'Поделиться проектом',
    share_desc: 'Любой, у кого есть ссылка, сможет просмотреть ваш проект в 3D — пройтись по комнатам и по всему дому. Редактировать нельзя.',
    share_link_label: 'Ссылка для просмотра',
    share_copy: 'Копировать ссылку',
    share_copied: 'Скопировано!',
    share_enabling: 'Готовим ссылку…',
    share_error: 'Не удалось создать ссылку. Попробуйте ещё раз.',
    shared_readonly: 'Только просмотр',
    shared_save_copy: 'Сохранить копию',
    shared_save_copy_title: 'Сохранить в свои проекты',
    shared_save_copy_desc: 'Копия этого дизайна добавится в ваше рабочее пространство, где вы сможете свободно её редактировать.',
    shared_save_copy_btn: 'Сохранить копию',
    shared_editable: 'Редактируемый',
    shared_no_edit_access: 'Что-то не так — у вас нет доступа на редактирование этого дизайна.',
    shared_edit_expired: 'Срок вашего доступа на редактирование истёк — сгенерируйте новый код и отправьте его владельцу.',
    share_editable_label: 'Редактируемый?',
    share_editable_hint: 'Вставьте код редактора, чтобы разрешить ему редактировать этот дизайн по ссылке.',
    share_code_ph: 'Вставьте код доступа',
    share_code_apply: 'Включить',
    share_code_ok: 'Доступ на редактирование предоставлен.',
    share_code_used: 'Этот код уже использован.',
    share_code_expired: 'Срок действия кода истёк. Запросите новый.',
    share_code_invalid: 'Такого кода не существует.',
    share_code_error: 'Не удалось включить редактирование — проверьте правила Firestore и создайте новый код.',
    share_to_chat: 'Отправить в сообщении',
    share_to_chat_note: 'Добавить примечание (необязательно)',
    share_to_chat_none: 'Переписок пока нет. Сначала откройте переписку из профиля.',
    share_to_chat_sent: 'Отправлено',
    share_to_chat_error: 'Не удалось отправить. Попробуйте ещё раз.',
    share_kind_project: 'Проект',
    share_kind_photo: 'Фото',
    share_kind_design: '3D-дизайн',
    share_msg_open: 'Открыть',
    share_msg_untitled: 'Без названия',
    share_msg_gone: 'Ссылка недоступна',
    shared_view_house: 'Весь дом',
    shared_view_rooms: 'Комнаты',
    shared_made_with: 'Сделано в Tunify',
    shared_try: 'Создать свой',
    shared_not_available: 'Этот проект недоступен. Возможно, ссылка неверна или доступ отключён.',
    shared_back_home: 'Перейти в Tunify',
    shared_loading: 'Загрузка проекта…',
    shared_no_rooms: 'В этом проекте пока нет комнат.',
    loading_3d: 'Подготовка 3D‑вида…',
  },

  hy: {
    ns_ios_install: "iPhone-ում նախ ավելացրեք Tunify-ը հիմնական էկրանին — Safari-ն ծանուցումներ թույլ է տալիս միայն տեղադրված հավելվածներին։",
    pwa_install: "Տեղադրել հավելվածը",
    pwa_ios_title: "Ավելացրեք Tunify-ը հիմնական էկրանին",
    pwa_ios_step1: "Սեղմեք Safari-ի «Կիսվել» կոճակը",
    pwa_ios_step2: "Ընտրեք «Ավելացնել հիմնական էկրանին»",
    pwa_ios_note: "Հիմնական էկրանից բացելիս Tunify-ն աշխատում է ամբողջ էկրանով՝ առանց բրաուզերի վահանակների։",
    chat_emoji: "Էմոջի",
    ns_title: "Ծանուցումներ",
    ns_push: "Բրաուզերի push-ծանուցումներ",
    ns_push_desc: "Ստացեք ծանուցում աշխատասեղանին, երբ ձեզ գրում են, նույնիսկ եթե Tunify-ը այլ ներդիրում է։",
    ns_always_on: "Ձայնը, հաղորդագրությունների հաշվիչը և հավելվածի ներսի ծանուցումները միշտ միացված են և չեն անջատվում։",
    ns_blocked: "Արգելափակված է բրաուզերի կարգավորումներում։ Թույլատրեք ծանուցումները այս կայքի համար։",
    ns_unsupported: "Ձեր բրաուզերը չի աջակցում աշխատասեղանի ծանուցումներ։",
    npr_title: "Միացրե՛ք ծանուցումները",
    npr_text: "Ստացե՛ք ծանուցում հենց այն պահին, երբ հաճախորդը կամ դիզայները ձեզ գրում է՝ նույնիսկ երբ Tunify-ը փակ է։",
    npr_enable: "Միացնել",
    npr_later: "Ոչ հիմա",
    ds_rate_unit: "Մեկ",
    ds_unit_hour: "ժամում",
    ds_unit_sqm: "մ²-ի համար",
    ds_unit_project: "նախագծի համար",
    ds_unit_day: "օրում",
    ds_per_sqm: "/մ²",
    ds_per_project: "/նախագիծ",
    ds_per_day: "/օր",
    rs_own_colors: "Իմ երկու գույները",
    rs_color_main: "Հիմնական գույն",
    rs_color_accent: "Ակցենտային գույն",
    rs_surfaces: "Ի՞նչը կարելի է վերափոխել",
    rs_surfaces_hint: "Դռներն ու պատուհանները մնում են նույն բացվածքներում՝ ոչինչ չի տեղափոխվում կամ ավելանում։",
    rs_surf_floor: "Հատակ",
    rs_surf_walls: "Պատեր",
    rs_surf_ceiling: "Առաստաղ",
    rs_surf_doors: "Դռներ",
    rs_surf_windows: "Պատուհաններ",
    rs_opt_finished: "Վերանորոգված",
    rs_opt_unfinished: "Չվերանորոգված",
    // Real Room AI Virtual Staging
    rs_open: "AI կահավորում",
    rs_title: "Իրական սենյակի AI կահավորում",
    rs_sub: "Վերբեռնեք իրական սենյակի լուսանկարը և կահավորեք այն AI-ով։",
    rs_upload: "Վերբեռնեք սենյակի լուսանկարը",
    rs_upload_hint: "Քաշեք լուսանկարն այստեղ կամ սեղմեք՝ ընտրելու համար",
    rs_your_photo: "Ձեր սենյակի լուսանկարը",
    rs_replace: "սեղմեք՝ փոխարինելու համար",
    rs_room_type: "Սենյակի տեսակ",
    rs_style: "Ինտերիերի ոճ",
    rs_palette: "Գունային գամմա",
    rs_state: "Սենյակի վիճակ",
    rs_notes: "Հատուկ ցանկություններ (ըստ ցանկության)",
    rs_notes_ph: "e.g. add indoor plants, a large round rug",
    rs_notes_hint: "Գրեք անգլերեն — AI-ն այդպես լավագույնս է հասկանում։",
    rs_generate: "Կահավորել սենյակը",
    rs_working: "Կահավորվում է…",
    rs_again: "Կրկին փորձել",
    rs_download: "Ներբեռնել",
    rs_open_image: "Բացել նկարը",
    rs_err_not_image: "Այս ֆայլը նկար չէ։",
    rs_err_read: "Չհաջողվեց կարդալ նկարը։ Փորձեք այլ լուսանկար։",
    rs_disclaimer: "Ստեղծված է AI-ով։ Սենյակի ձևն ու պատուհանները պահպանվում են, սակայն պատերի և հատակի հարդարանքը կարող է ճշգրիտ չհամընկնել ձեր լուսանկարի հետ։",
    rs_opt_living: "Հյուրասենյակ",
    rs_opt_bedroom: "Ննջասենյակ",
    rs_opt_kitchen: "Խոհանոց",
    rs_opt_bathroom: "Լոգարան",
    rs_opt_dining: "Ճաշասենյակ",
    rs_opt_office: "Տնային գրասենյակ",
    rs_opt_modern_minimalist: "Ժամանակակից մինիմալիզմ",
    rs_opt_scandinavian: "Սկանդինավյան",
    rs_opt_luxury_modern: "Լյուքս մոդեռն",
    rs_opt_japandi: "Ջապանդի",
    rs_opt_industrial: "Ինդուստրիալ",
    rs_opt_boho: "Բոհո",
    rs_opt_warm_neutrals: "Տաք չեզոք",
    rs_opt_cool_greys: "Սառը մոխրագույն և կապույտ",
    rs_opt_earthy: "Հողային երանգներ",
    rs_opt_white_lightwood: "Սպիտակ և բաց փայտ",
    rs_opt_bold_dark: "Մուգ շեշտադրում",
    rs_opt_auto: "Ավտո (AI-ն կընտրի)",
    rs_opt_kids: "Մանկական սենյակ",
    rs_opt_nursery: "Նորածնի սենյակ",
    rs_opt_teen: "Դեռահասի սենյակ",
    rs_opt_guest: "Հյուրասենյակ-ննջարան",
    rs_opt_hallway: "Միջանցք / Նախասրահ",
    rs_opt_studio: "Ստուդիա բնակարան",
    rs_opt_dressing: "Հանդերձարան",
    rs_opt_balcony: "Պատշգամբ / Լոջա",
    rs_opt_classic: "Դասական",
    rs_opt_neoclassic: "Նեոդասական",
    rs_opt_contemporary: "Ժամանակակից",
    rs_opt_mid_century: "Միդ-սենչուրի",
    rs_opt_art_deco: "Արտ դեկո",
    rs_opt_mediterranean: "Միջերկրածովյան",
    rs_opt_rustic: "Ռուստիկ / Գյուղական",
    rs_opt_provence: "Պրովանս",
    rs_opt_loft: "Լոֆթ",
    rs_opt_high_tech: "Հայ-թեք",
    rs_opt_monochrome: "Մոնոխրոմ",
    rs_opt_greige: "Գրեժ և տաուպ",
    rs_opt_sage: "Եղեսպակ և ձիթապտուղ",
    rs_opt_blush: "Փոշոտ վարդագույն",
    rs_opt_jewel: "Թանկարժեք երանգներ",
    rs_opt_navy_brass: "Մուգ կապույտ և արույր",
    rs_opt_pastel: "Փափուկ պաստելային",
    rs_opt_walnut_cream: "Ընկույզ և կրեմ",
    rs_opt_empty: "Դատարկ սենյակ (լրիվ կահավորում)",
    rs_opt_furnished: "Կահավորված (վերաձևավորում)",
    // Ռենդերի որակի ընտրություն 3D տեսքերում
    quality_label: 'Որակ',
    quality_auto: 'Ավտոմատ',
    quality_low: 'Ցածր',
    quality_medium: 'Միջին',
    quality_high: 'Բարձր',
    quality_high_note: 'Ամենագեղեցիկն է, բայց կարող է դանդաղեցնել հեռախոսներում և հին համակարգիչներում։',
    quality_auto_note: 'Ընտրում է լավագույն կարգավորումը ձեր սարքի համար։',
    // App / SaveLoad
    save: 'Պահպանել',
    saving: 'Պահպանվում է…',
    saved: 'Պահպանված է',
    upload: 'Բեռնել',
    dash_new_project_sub: 'Նախագծին անուն տվեք՝ սկսելու համար:',
    dbn1_title: 'Վերբեռնեք լուսանկար՝ AI-ը կկահավորի',
    dbn1_body:  'Ուղարկեք դատարկ սենյակի լուսանկարը և ստացեք այն կահավորված ու ձևավորված։',
    dbn2_title: 'Ձեր 3D սենյակը՝ որպես լուսանկար',
    dbn2_body:  'Կառուցեք սենյակը 3D-ով, ապա ցանկացած տեսք վերածեք ֆոտոռեալիստիկ AI պատկերի։',
    dbn3_title: 'Սկսեք հատակագծից',
    dbn3_body:  'Տեղադրեք պատեր, դռներ և պատուհաններ ցանցի վրա՝ ուղիղ ձեր վահանակից։',
    dbn4_title: 'Գտեք դիզայներ',
    dbn4_body:  'Դիտեք պորտֆոլիոներ, հետևեք ձեզ դուր եկածներին և գրեք նրանց ուղղակիորեն։',
    dbn5_title: 'Ամբողջ սենյակը՝ մեկ տեղում',
    dbn5_body:  'Կահույք, լուսավորություն, սալիկ, հատակ և հարդարում՝ Tunify-ի խանութներից, գներով։',
    unsaved_title: 'Չպահպանված փոփոխություններ',
    unsaved_sub: 'Դուք ունեք չպահպանված փոփոխություններ։ Ի՞նչ կցանկանայիք անել։',
    unsaved_save: 'Պահպանել և դուրս գալ',
    unsaved_leave: 'Դուրս գալ առանց պահպանման',
    unsaved_stay: 'Մնալ',
    design_saved: 'Դիզայնը պահպանված է!',
    design_loaded: 'Դիզայնը բեռնված է!',
    invalid_file: 'Անվավեր ֆայл',
    unsupported_version: 'Չաջակցվող տարբերակ',
    try_now: 'Փորձել անվճար',
    guest_save_tooltip: 'Գրանցվեք՝ ձեր նախագիծը ամպում պահպանելու համար',
    guest_locked_hint: 'Գրանցվեք ավելիի համար',
    guest_customize_locked: 'Գրանցվեք՝ գույներն ու ոճերը փոխելու համար',
    guest_screenshot_locked: 'Գրանցվեք՝ սքրինշոթեր պահպանելու համար',
    guest_time_locked: 'Գրանցվեք՝ բացելու համար',
    time_morning: 'Առավոտ',
    time_evening: 'Երեկո',
    time_night: 'Գիշեր',
    guest_welcome_title: 'Բարի գալուստ Tunify',
    guest_welcome_sub: 'Դուք անվճար փորձնական ռեժիմում եք՝ առանց հաշվի: Ահա ինչպես սկսել.',
    guest_welcome_step1_title: 'Կազմեք ձեր հատակագիծը',
    guest_welcome_step1_body: 'Քաշեք սենյակները ցանցի վրա՝ ձեր տան դասավորությունը ստեղծելու համար:',
    guest_welcome_step2_title: 'Ստուգեք հատակագիծը',
    guest_welcome_step2_body: 'Բացեք «Հատակագիծ»-ը (ներքևում ձախ կոճակը)՝ դասավորությունն ամբողջությամբ տեսնելու համար:',
    guest_welcome_step2_body_mobile: 'Բացեք «Հատակագիծ»-ը (վերևում աջ կոճակը)՝ դասավորությունն ամբողջությամբ տեսնելու համար:',
    guest_welcome_step3_title: 'Ուսումնասիրեք 3D-ով',
    guest_welcome_step3_body: 'Սեղմեք ցանկացած սենյակի վրա՝ այն ամբողջական 3D-ով շրջելու համար:',
    guest_welcome_cta: 'Սկսել նախագծել',

    // Builder
    custom_tools: 'Գործիքներ',
    draw_room: 'Նկարել սենյակ',
    add_room: 'Ավելացնել սենյակ',
    free_wall: 'Ազատ պատ',
    make_room: 'Ստեղծել սենյակ',
    free_room_fail: 'Նախ փակեք ազատ պատերը օղակի մեջ, ապա «Ստեղծել սենյակ»։',
    draw_walls: 'Նկարել պատեր',
    draw_room_hint: 'Քաշեք ցանցի վրա սենյակ նկարելու համար',
    wall_mode_hint: 'Սեղմեք ցանցի հատումներին · սեղմեք սկզբնական կետին փակելու',
    wall_blocked_msg: 'Հնարավոր չէ պատ դնել մեկ այլ պատի վրա',
    merge_btn: 'Միավորել',
    merge_tooltip: 'Միավորել ընդհանուր պատ ունեցող սենյակները',
    merge_hint: 'Սեղմեք սենյակների վրա՝ միավորելու համար (պետք է ընդհանուր պատ)',
    merge_fail_msg: 'Այս սենյակները ընդհանուր պատ չունեն, չեն կարող միավորվել',
    merge_free_msg: 'Գծված սենյակները (թեք կամ կոր պատերով) հնարավոր չէ միավորել',
    rooms_tab: 'Սենյակներ',
    furniture_tab: 'Կահույք',
    drag_hint_rooms: 'Քաշել ցանց · սեղմել կահույքի համար',
    drag_hint_furniture: 'Քաշել ցանց',
    openings_hint: 'Ընտրեք տեսակը, ապա սեղմեք որևէ պատի վրա տեղադրելու համար',
    clear_all: 'Մաքրել բոլորը',
    view_floor_plan: 'Հատակագիծ →',
    add_room_first: 'Ավելացրեք առնվազն 1 սենյակ',
    wall_height_label: 'Պատի բարձրությունը',
    wall_label_short: 'Պատ',
    room_width: 'Լայնություն',
    room_height: 'Բարձրություն',
    room_name: 'Անուն',
    finish: 'Ավարտել',
    cancel: 'Չեղարկել',
    prev: 'Հետ',
    done: 'Պատրաստ',
    walls: 'Պատեր',
    remove: 'Հեռացնել',
    delete_room: 'Ջնջել սենյակը',
    delete_room_confirm: 'Ջնջե՞լ այս սենյակը',
    delete_confirm: 'Ջնջե՞լ այս տարրը',
    yes: 'Այո',
    no: 'Ոչ',
    rotate: '↻ Պտտել',
    change_type: 'Փոխել տեսակը',
    color_label: 'Գույն',

    // FloorPlan
    edit_layout: '← Խմբագրել հատակագիծը',
    step2: 'Քայլ 2-ը 3-ից',
    floor_plan_title: 'Ձեր հատակագիծը',
    floor_plan_sub: 'Ընտրեք սենյակ դիզայնը սկսելու համար',
    fp_click_room_hint: 'Սեղմեք սենյակի վրա 3D դիտման համար',
    rooms_stat: 'Սենյակներ',
    styled_stat: 'Ձևավորված',
    unstyled: 'Անձևավորված',
    view_3d: '3D Դիտում',

    // RoomEditor
    floor_plan_back: 'Հատակագիծ',
    layer_undo: 'Հետ',
    layer_undo_hint: 'Չեղարկել այս շերտի վերջին փոփոխությունը',
    select_wall: 'Ընտրել հատված',
    select_floor: 'Ընտրել հատակի հատված',
    wall_pick_hint: 'Սեղմեք ~1մ հատվածները պատին…',
    floor_pick_hint: 'Սեղմեք ~1մ հատվածները հատակին…',
    wall_cells: 'բջիջ',
    wall_clear: 'Չեղարկել',
    wall_reset_area: 'Ջնջել',
    step3: 'Քայլ 3 · Ձևավորում',
    complete_badge: '✦ Ավարտված',
    reset: 'Վերականգնել',
    live_preview: 'Կենդանի նախադիտում',
    floor_tab: 'Հատակ',
    walls_tab: 'Պատեր',
    ceiling_tab: 'Առաստաղ',
    custom_material: 'Հատուկ նյութ',
    custom_preview_hint: 'նախադիտում ↗',
    editing_color_for: 'Ոճի կարգավորում՝',
    color_from_scratch_hint: 'Ընտրեք գույն և հարդարանք՝ նոր հատուկ նյութ ստեղծելու համար.',
    finish_label: 'Մշակում',
    name_label: 'Անուն',
    apply: 'Կիրառել',
    applied: 'Կիրառված ✓',

    // Openings
    wall_openings: 'Պատի բացվածքներ',
    door: 'Դուռ',
    window: 'Պատուհան',
    arch: 'Կամար',
    archway: 'Կամար',
    painting: 'Նկար',
    ac: 'Կոնդիցիոներ',
    clock: 'Պատի ժամացույց',
    outlet: 'Վարդակ',
    radiator: 'Ռադիատոր',
    sill: 'Պատուհանի շեմ',
    size: 'Չափ',
    place_on_wall_hint: 'Սեղմեք ցանկացած պատի վրա · կրկին սեղմեք կոճակը՝ չեղարկելու',
    openings_label: 'Բացվածքներ',
    no_openings_hint: 'Բացվածք չկա · օգտագործեք Դուռ/Պատուհան/Կամար գործիքը',
    wall_items_label: 'Պատի իրեր',
    wall_items_hint: 'Ընտրեք իրը, ապա սեղմեք որևէ պատի վրա տեղադրելու համար',
    room_wall: 'Սենյակի պատ',
    curve_btn: 'Կորացնել',
    straight_btn: 'Ուղիղ',
    horizontal: 'հորիզոնական',
    vertical: 'ուղղահայաց',
    rotate_90: '90°',

    // 3D Room Editor (ThreeDRoom.jsx)
    edit_btn: 'Խմբագրել',
    fullscreen_tooltip: 'Լիաէկրան',
    exit_fullscreen_tooltip: 'Ելք լիաէկրանից',
    add_furniture_btn: '+ Կահույք',
    add_opening_btn: '+ Բացվածք',
    add_wallitem_btn: '+ Իր',
    add_lighting_btn: '+ Լուսավորություն',
    done_btn: 'Պատրաստ է',
    view_mode_label: 'դիտման ռեժիմ',
    edit_mode_label: 'խմբագրման ռեժիմ',
    drag_rotate_color_hint: 'քաշել · ↻ պտտել · գույն',
    copy_ctrlc_tooltip: 'Պատճենել (Ctrl+C)',
    rotate90_tooltip: 'Պտտել 90°',
    delete_tooltip: 'Ջնջել',
    close_tooltip: 'Փակել',
    gate_why_like: 'Ստեղծեք հաշիվ՝ {name}-ին հավանելու համար։',
    gate_why_message: 'Ստեղծեք հաշիվ՝ {name}-ին գրելու համար։',
    drag_to_move_hint: 'քաշեք տեղափոխելու համար',
    default_color: 'Կանխադրված (օրիգինալ)',
    style_label: 'Ոճ',
    design_label: 'Դիզայն',
    undo_ctrlz_tooltip: 'Հետարկել (Ctrl+Z)',
    redo_ctrly_tooltip: 'Կրկնել (Ctrl+Y)',
    go_to_prefix: '→ Անցնել',
    add_opening_modal_title: 'Ավելացնել բացվածք',
    add_wallitem_modal_title: 'Ավելացնել իր',
    add_lighting_modal_title: 'Ավելացնել լուսավորություն',
    add_furniture_modal_title: 'Ավելացնել կահույք',
    cat_living: 'Հյուրասենյակ',
    cat_kitchen: 'Խոհանոց և ճաշասենյակ',
    cat_bedroom: 'Ննջասենյակ',
    cat_bathroom: 'Լոգարան',
    cat_office: 'Աշխատասենյակ',
    cat_anywhere: 'Ամենուր',
    cat_items: 'տարր',
    cat_pick_hint: 'Ընտրեք սենյակը՝ կահույքը տեսնելու համար',
    model_label: 'Մոդել',
    model_count: 'մոդել',
    type_label: 'Տեսակ',
    wall_label: 'Պատ',
    wall_side_label: 'Կողմ',
    wall_side_a: 'Այս կողմը',
    wall_side_b: 'Մյուս կողմը',
    position_label: 'Դիրք',
    along_wall: 'պատի երկայնքով',
    add_prefix: 'Ավելացնել',
    item_label: 'Իր',
    wall_top: 'Վերև',
    wall_bottom: 'Ներքև',
    wall_left: 'Ձախ',
    wall_right: 'Աջ',
    wall_suffix: 'պատ',
    interior_wall_label: 'Ներքին պատ',
    flip_to_other_side: 'Տեղափոխել մյուս կողմը',
    selected_label: 'ընտրված',

    // 3D design styles — Door
    opstyle_door_panel4: '4-վահանակով',
    opstyle_door_flush: 'Հարթ ժամանակակից',
    opstyle_door_glass: 'Ապակե վահանակով',
    opstyle_door_barn: 'Սահող (ամբարային)',
    opstyle_door_french: 'Ֆրանսիական կրկնակի',
    opstyle_door_panel6: '6-վահանակով գաղութային',
    // Window
    opstyle_window_doublehung: 'Կրկնակի բարձրացվող',
    opstyle_window_casement: 'Բացվող (կասեմենտ)',
    opstyle_window_picture: 'Պանորամային',
    opstyle_window_grid: 'Բազմաբաժին ցանց',
    opstyle_window_arched: 'Կամարաձև վերևով',
    opstyle_window_sliding: 'Սահող',
    // Archway
    opstyle_archway_round: 'Կլոր կամար',
    opstyle_archway_gothic: 'Գոթական կամար',
    opstyle_archway_flat: 'Ուղղանկյուն շրջանակով',
    opstyle_archway_elliptical: 'Էլիպսաձև կամար',
    opstyle_archway_roman: 'Հռոմեական բանալաքարով',
    opstyle_archway_modern: 'Ժամանակակից մինիմալ',
    // Painting
    opstyle_painting_abstract: 'Աբստրակտ',
    opstyle_painting_baroque: 'Զարդարուն բարոկկո',
    opstyle_painting_modern: 'Ժամանակակից սև',
    opstyle_painting_canvas: 'Կտավ առանց շրջանակի',
    opstyle_painting_collage: 'Լուսանկարների կոլաժ',
    opstyle_painting_landscape: 'Բնանկար, յուղաներկ',
    // AC Unit
    opstyle_ac_split: 'Սփլիտ համակարգ',
    opstyle_ac_cassette: 'Կասետային',
    opstyle_ac_curved: 'Կոր պրեմիում',
    opstyle_ac_window: 'Պատուհանի տիպի',
    opstyle_ac_slim: 'Բարակ պատի',
    opstyle_ac_retro: 'Ռետրո',
    // Wall Clock
    opstyle_clock_analog: 'Դասական անալոգային',
    opstyle_clock_digital: 'Թվային LED',
    opstyle_clock_cuckoo: 'Կկու (փայտե)',
    opstyle_clock_oversized: 'Մեծաչափ մինիմալ',
    opstyle_clock_vintage: 'Վինտաժ արույրե',
    opstyle_clock_skeleton: 'Սկելետոն ժամանակակից',
    // Power Outlet
    opstyle_outlet_eu: 'Եվրոպական կլոր',
    opstyle_outlet_us: 'Ամերիկյան',
    opstyle_outlet_uk: 'Բրիտանական 3-փին',
    opstyle_outlet_usb: 'USB համակցված',
    opstyle_outlet_brass: 'Արույրե հատակի',
    opstyle_outlet_industrial: 'Արդյունաբերական մետաղյա',
    // Radiator
    opstyle_radiator_panel: 'Վահանակային կոնվեկտոր',
    opstyle_radiator_castiron: 'Չուգունե սյուներով',
    opstyle_radiator_towel: 'Սրբիչների չորացուցիչ',
    opstyle_radiator_vertical: 'Ուղղահայաց դիզայներական',
    opstyle_radiator_skirting: 'Ցածր հատակամերձ',
    opstyle_radiator_electric: 'Էլեկտրական հարթ վահանակ',

    // House3DView
    back: 'Հետ',
    preview_3d: '3D Նախադիտում',
    full_house: 'Ամբողջ տունը',
    drag_hint_3d: 'Քաշեք պտտելու · Ոլորեք մեծացնելու',
    screenshot: 'Էկրանի նկար',

    // Room types
    room_living: 'Հյուրասենյակ',
    room_kitchen: 'Խոհանոց',
    room_bedroom: 'Ննջասենյակ',
    room_bathroom: 'Լոգարան',
    room_hallway: 'Միջանցք',
    room_garage: 'Ավտոտնակ',
    room_office: 'Գրասենյակ',
    room_dining: 'Ճաշասենյակ',
    room_custom: 'Սենյակ',

    // Furniture types
    furn_sofa: 'Բազմոց',
    furn_armchair: 'Բազկաթոռ',
    furn_table: 'Ճաշասեղան',
    furn_chair: 'Աթոռ',
    furn_bed: 'Մահճակալ',
    furn_desk: 'Գրասեղան',
    furn_tv: 'Հեռուստացույց',
    furn_shelf: 'Դարակ',
    furn_wardrobe: 'Զգեստապահարան',
    furn_bathtub: 'Լոգախցիկ',
    furn_toilet: 'Զուգարան',
    furn_sink: 'Լվացարան',
    furn_lamp: 'Կանգնակ',
    furn_plant: 'Բույս',
    furn_rug: 'Գորգ',
    light_chandelier: 'Ժամանակակից ջահ',
    light_ceiling_lamp: 'Մինիմալիստական առաստաղի լամպ',

    // Material categories
    cat_all: 'Բոլորը',
    cat_wood: 'Փայտ',
    cat_laminate: 'Լամինատ',
    cat_stone: 'Քար',
    cat_tile: 'Սալիկ',
    cat_carpet: 'Գորգ',
    cat_vinyl: 'Վինիլ',
    cat_neutral: 'Չեզոք',
    cat_colour: 'Գույն',
    cat_texture: 'Հյուսվածք',
    cat_pattern: 'Նախշ',
    cat_plain: 'Հարթ',

    // Finish options
    fin_matte: 'Մատ',
    fin_satin: 'Սատին',
    fin_semi_gloss: 'Կիսափայլ',
    fin_gloss: 'Փայլ',
    fin_metallic: 'Մետաղ',
    fin_brushed_metal: 'Փայլեցված',
    fin_velvet: 'Թավիշ',
    fin_pearl: 'Մարգարիտ',
    fin_concrete: 'Բետոն',

    // Landing page
    lnd_signin: 'Մուտք',
    lnd_browse_title:      'Ապրանքների կատալոգ',
    lnd_search_ph:         'Փնտրեք ապրանքներ…',
    lnd_search_btn:        'Փնտրել',
    lnd_search_loading:    'Որոնում…',
    lnd_search_none:       'Ոչինչ չգտնվեց: Փորձեք այլ բառ:',
    lnd_search_all:        'Տեսնել բոլոր արդյունքները →',
    lnd_cat_found:         'Գտնվել է {n} ապրանք',
    lnd_pages:             'Էջեր',
    lnd_prev:              'Նախորդ էջը',
    lnd_next:              'Հաջորդ էջը',
    lnd_sort:              'Դասավորել',
    lnd_sort_new:          'Սկզբում նորերը',
    lnd_sort_cheap:        'Սկզբում էժանները',
    lnd_sort_dear:         'Սկզբում թանկերը',
    lnd_sort_mix:          "Խառը հերթականությամբ",
    sr_rec_title:          "Առաջարկվող",
    sr_rec_more:           "Ցուցադրել բոլոր առաջարկվողները (ևս {n})",
    sr_rec_less:           "Ծալել",
    sr_all_title:          "Բոլոր ապրանքները",
    lnd_badge_new:         'Նոր',
    lnd_more_title:        'Ցանկանո՞ւմ եք տեսնել ավելին',
    lnd_more_sub:          'Ստեղծեք անվճար հաշիվ՝ հավանելու, դիզայներներին գրելու, ապրանքներ պահելու և ձեր սենյակը 3D-ով նախագծելու համար:',
    lnd_more_cta:          'Գրանցվել ավելիի համար',
    lang_settings: 'Լեզու',
    lnd_signup: 'Գրանցվել',
    lnd_open_app: 'Բացել',
    lnd_kicker: 'Տան 3D նախագծում · AI վիզուալիզացիա',
    lnd_title_pre: 'Նախագծեք Ձեր տունը',
    lnd_title_hl: 'AI-ի օգնությամբ,',
    lnd_title_post: '3D-ում։',
    lnd_sub: 'Գծեք հատակագծեր և կահավորեք սենյակները 3D-ով, ցանկացած տեսք վերածեք ֆոտոռեալիստիկ AI պատկերի և գտեք դիզայներ, ով կշարունակի աշխատանքը — ամբողջությամբ բրաուզերում և անվճար։',
    lnd_sub_short: 'Ծրագրեք սենյակները 3D-ով, պատկերեք AI-ով և գտեք դիզայներ։ Անվճար, բրաուզերում։',
    lnd_cta: 'Սկսել նախագծումը',
    lnd_badge_2d: '2D Հատակ',
    lnd_badge_3d: '+ 3D Տեսք',
    lnd_feat_kicker: 'Ամեն ինչ, ինչ անհրաժեշտ է',
    lnd_feat_title: 'AI, 3D և դիզայներներ',
    lnd_feat1_title: 'AI պատկերներ',
    lnd_feat1_desc: 'Վերածեք ցանկացած 3D տեսք ֆոտոռեալիստիկ պատկերի։ Նկարագրեք ցանկալի մթնոլորտը և վայրկյանների ընթացքում ստացեք պատրաստ արդյունք։',
    lnd_feat2_title: 'Հատակագիծ և կահույք 3D-ում',
    lnd_feat2_desc: 'Գծեք հատակագծեր ցանցի վրա, տեղադրեք դռներ, պատուհաններ և կահույք, ապա դիտեք արդյունքը 3D-ով։',
    lnd_feat3_title: 'Գտեք դիզայներ',
    lnd_feat3_desc: 'Դիտեք դիզայներների աշխատանքները, հետևեք ձեզ դուր եկածներին և գրեք նրանց ուղղակիորեն, երբ ցանկանաք գործը վստահել մասնագետին։',
    lnd_steps_title: 'Ինչպես է աշխատում',
    lnd_step1_label: 'Նկարեք սենյակներ',
    lnd_step1_sub: 'Սեղմեք ցանցի վրա պատեր տեղադրելու և սենյակի ուրվագծեր ստանալու համար:',
    lnd_step2_label: 'Ավելացրեք մանրամասներ',
    lnd_step2_sub: 'Տեղադրեք դռներ, պատուհաններ, կահույք և ընտրեք գույներ:',
    lnd_step3_label: 'Դիտեք 3D-ով',
    lnd_step3_sub: 'Մեկ սեղմումը բացում է ձեր նախագծի ամբողջական 3D դիտումը:',
    lnd_bottom_title: 'Պատրա՞ստ եք սկսել նախագծումը:',
    lnd_bottom_sub: 'Հաշիվ պետք չէ: Բացեք կոնստրուկտորը և սկսեք ստեղծել:',
    nav_home: 'Գլխավոր',
    nav_menu: 'Մենյու',
    nav_designers: 'Դիզայներներ',
    nav_marketplace: 'Խանութ',
    nav_projects: 'Իմ նախագծերը',
    lnd_steps_sub: 'Դատարկ ցանցից մինչև ֆոտոռեալիստիկ սենյակ՝ չորս քայլով։',
    lnd_step4_label: 'Կահավորեք իրականում',
    lnd_step4_sub: 'Գտեք ձեր նախագծի ապրանքները կամ հանձնեք այն դիզայներին։',
    lnd_tr_title: 'Առաջ և հետո',
    lnd_tr_sub: 'Երկու ճանապարհ՝ կահավորել առկա սենյակի լուսանկարը կամ ռենդեր անել 3D-ում կառուցվածը։',
    lnd_tr_before: 'Առաջ',
    lnd_tr_after: 'Հետո',
    lnd_tr1_t: 'Դատարկ սենյակը՝ կահավորված',
    lnd_tr1_b: 'Վերբեռնեք սենյակի լուսանկարն այնպես, ինչպես կա։ AI-ը կկահավորի այն՝ պահելով պատերը, պատուհանները և համամասնությունները նույն տեղում։',
    lnd_tr2_t: '3D տեսարանը՝ իրական',
    lnd_tr2_b: 'Կառուցեք սենյակը 3D-ով, ընտրեք տեսարանը և վերածեք այն ֆոտոռեալիստիկ պատկերի՝ նույն դասավորությունը՝ լույսով և հարդարմամբ։',
    lnd_dsg_title: 'Դիզայներները Tunify-ում',
    lnd_dsg_all: 'Բոլոր դիզայներները',
    lnd_shops_title: "Խանութները Tunify-ում",
    lnd_shops_all: "Բոլոր խանութները",
    lnd_shop_title: 'Կահավորեք',
    lnd_shop_sub: 'Կահույք, նյութեր և հարդարանք Tunify-ի խանութներից։',
    lnd_shop_all: 'Դեպի խանութ',
    lnd_dsg_projects: 'հրապարակված՝ {n}',
    lnd_footer_copy: '© 2026 Tunify · Բոլոր իրավունքները պաշտպանված են',

    // AuthLayout brand panel
    al_headline_pre: 'Նախագծեք Ձեր',
    al_headline_hl:  'Երազանքի Տունը',
    al_tagline:      'ԱԲ-վրա հիմնված ինտերիեր: Գծեք հատակագծեր, կահավորեք սենյակները, դիտեք 3D-ով — ամբողջությամբ բրաուզերում, անվճար:',
    al_stat_free:    'Անվճար հավերժ',
    al_stat_3d:      '3D զբոսանք',
    al_stat_furn:    'Կահույքի կտոր',

    // Dashboard
    dash_sign_out:         'Ելք',
    menu_language:         'Լեզու',
    menu_dark_mode:        'Մուգ ռեժիմ',
    menu_light_mode:       'Բաց ռեժիմ',
    menu_sign_out:         'Ելք',
    menu_admin:            'Ադմին վահանակ',
    adm_title:             'Վերլուծություն',
    adm_sec_ai:            'AI ծախսն ըստ տեսակի',
    adm_flow_render:       '3D ռենդեր',
    adm_flow_staging:      'Սենյակի ձևավորում',
    adm_flow_render_total: '3D ռենդեր, ամբողջ ժամանակ',
    adm_flow_staging_total: 'Ձևավորում, ամբողջ ժամանակ',
    adm_flow_sub:          '{n} նկար · {rate}/նկար',
    adm_n_images:          '{n} նկար',
    adm_flow_unattributed: '{n} գեներացիա գրանցվել է մինչ ծախսերի բաժանումն ըստ տեսակի, ուստի դրանք կան ընդհանուրում, բայց ոչ մի քարտում:',
    adm_signed_in:         'Մուտք եք գործել որպես {who}: Բոլոր ամսաթվերը UTC են:',
    adm_back:              'Հավելված',
    adm_tf_day:            'Այսօր',
    adm_tf_week:           '7 օր',
    adm_tf_month:          '30 օր',
    adm_tf_year:           '12 ամիս',
    adm_sec_product:       'Արտադրանք',
    adm_sec_content:       'Բովանդակություն',
    adm_sec_accounts:      'Հաշիվներ ըստ տեսակի',
    adm_sec_traffic:       'Այցելություններ',
    adm_total_users:       'Ընդամենը օգտատեր',
    adm_total_posts:       'Ընդամենը հրապարակումներ',
    adm_posts_today:       'Հրապարակումներ այսօր',
    adm_projects:          'Նախագծեր',
    adm_products:          'Ապրանքներ',
    adm_right_now:         'հենց հիմա',
    adm_new_users:         'Նոր օգտատերեր',
    adm_active_users:      'Ակտիվ օգտատերեր',
    adm_generations:       'AI գեներացիաներ',
    adm_spend:             'AI ծախս',
    adm_customers:         'Հաճախորդներ',
    adm_designers:         'Դիզայներներ',
    adm_shops:             'Խանութներ',
    adm_unclassified:      'Առանց տեսակի',
    adm_all_time:          'ամբողջ ժամանակ',
    adm_today:             'այսօր',
    adm_in_range:          'այս ժամանակահատվածում',
    adm_n_all_time:        '{n} ամբողջ ժամանակ',
    adm_spend_sub:         '{total} ամբողջ ժամանակ',
    adm_new_in_range:      '+{n} նոր',
    adm_no_type:           'հաշվի տեսակը գրանցված չէ',
    adm_chart_registrations: 'Նոր գրանցումներ',
    adm_chart_dau:         'Օրական ակտիվ օգտատերեր',
    adm_peak:              'առավելագույնը {n}',
    adm_visitors:          'Այցելուներ',
    adm_cached:            'քեշից, ≤30 րոպե',
    adm_pageviews:         'Էջադիտումներ',
    adm_unique:            'Եզակի այցելուներ',
    adm_distinct:          'եզակի մարդ',
    adm_sessions:          'Սեսիաներ',
    adm_visits:            'այցեր',
    adm_bounce:            'Մերժումների տոկոս',
    adm_conversion:        'Փոխարկման տոկոս',
    adm_conversions_n:     '{n} փոխարկում',
    adm_loading_traffic:   'Բեռնվում է…',
    adm_ga_not_connected:  'Analytics-ը միացված չէ:',
    adm_ga_no_property:    'GA4 ռեսուրս կարգավորված չէ:',
    adm_ga_step_access:    'Բացեք Analytics → Admin → Property access management:',
    adm_ga_step_viewer:    'Ավելացրեք այս հաշիվը Viewer դերով՝',
    adm_ga_step_viewer_generic: 'Ավելացրեք այս նախագծի ֆունկցիաների սպասարկման հաշիվը Viewer դերով:',
    adm_ga_step_wait:      'Սպասեք մեկ րոպե և թարմացրեք էջը: Վերատեղակայում պետք չէ:',
    adm_ga_step_id:        'Նշեք ռեսուրսի ID-ն՝ թվային, ոչ G-XXXXXXX՝',
    adm_ga_step_api:       'Միացրեք Analytics Data API-ն Google Cloud-ում:',
    adm_ga_step_redeploy:  'Վերատեղակայեք՝',
    adm_err_claim:         'Ձեր սեսիան դեռ չունի ադմինի իրավունք: Դուրս եկեք և նորից մուտք գործեք:',
    adm_err_load:          'Չհաջողվեց բեռնել վիճակագրությունը:',
    adm_no_data:           'Այս ժամանակահատվածի համար տվյալներ չկան:',
    adm_foot:              'Հաշվիչները թարմացվում են Cloud Functions-ի կողմից՝ իրադարձությունների ընթացքում. այս էջը կարդում է մեկ փաստաթուղթ յուրաքանչյուր գումարի և օրական մեկ փոքր տող:',
    menu_plans:            'Փաթեթներ և կրեդիտներ',
    menu_gen_code:         'Ստեղծել մուտքի կոդ',
    menu_generating:       'Ստեղծվում է…',
    menu_code_hint:        'Տվեք այս կոդը դիզայնի սեփականատիրոջը՝ խմբագրման մուտք ստանալու համար։ Գործում է 10 րոպե։',
    dash_signing_out:      'Դուրս գալ…',
    dash_get_started:      'Սկսել',
    dash_designer_title:   'Բացել կոնստրուկտոր',
    dash_designer_desc:    'Գծեք հատակագծեր, կահավորեք սենյակները, դիտեք 3D-ով:',
    dash_workspace_title:  'Իմ աշխատասեղան',
    dash_workspace_desc:   'Կառավարեք ձեր պրոեկտներն ու հավաքածուները:',
    dash_inspo_title:      'Ոգեշնչում',
    dash_inspo_desc:       'Ընդհատված ձևավորումներ և կաղապարներ:',
    dash_coming_soon:      'Շուտով',

    // Settings
    set_title:             'Հաշվի կարգավորումներ',
    set_back_to_dash:      'Վերադառնալ վահանակ',
    set_fullname_label:    'Անուն Ազգանուն',
    set_no_name:           'Անունը նշված չէ',
    set_save:              'Պահպանել փոփոխությունները',
    set_saving:            'Պահպանվում է…',
    set_saved:             'Անուն-ազգանունը թարմացվեց:',
    set_save_failed:       'Չհաջողվեց պահպանել: Փորձեք կրկին:',
    set_change_password_title:  'Փոխել գաղտնաբառը',
    set_current_password_label: 'Ընթացիկ գաղտնաբառ',
    set_current_password_ph:    'Մուտքագրեք ընթացիկ գաղտնաբառը',
    set_new_password_label:     'Նոր գաղտնաբառ',
    set_change_password_btn:    'Փոխել գաղտնաբառը',
    set_changing_password:      'Փոփոխվում է…',
    set_password_changed:       'Գաղտնաբառը հաջողությամբ փոխվեց:',
    set_wrong_current_password: 'Ընթացիկ գաղտնաբառը սխալ է:',
    set_google_only_password:   'Դուք մուտք եք գործել Google-ով — այստեղ գաղտնաբառ չկա փոխելու:',

    // Workspace
    ws_sign_out:                  'Ելք',
    ws_signing_out:               'Դուրս գալ…',
    ws_title:                     'Իմ աշխատասեղան',
    ws_sub:                       'Կառավարեք ձեր 3D հատակագծերն ու տեսարանները',
    ws_new_collection:            'Նոր հավաքածու',
    ws_new_project:               'Նոր պրոեկտ',
    ws_add_project:               'Ավելացնել պրոեկտ',
    ws_tab_projects:              'Բոլոր պրոեկտները',
    ws_tab_collections:           'Հավաքածուներ',
    ws_back_collections:          'Հավաքածուներ',
    ws_collection_label:          'Հավաքածու',
    ws_project_one:               'պրոեկտ',
    ws_project_many:              'պրոեկտ',
    ws_in_collection:             'այս հավաքածուում',
    ws_empty_projects_title:      'Պրոեկտներ չկան',
    ws_empty_projects_sub:        'Ստեղծեք առաջին պրոեկտը սկսելու համար:',
    ws_new_project_action:        '+ Նոր պրոեկտ',
    ws_empty_collections_title:   'Հավաքածուներ չկան',
    ws_empty_collections_sub:     'Խմբավորեք պրոեկտները հավաքածուներով:',
    ws_new_collection_action:     '+ Նոր հավաքածու',
    ws_empty_col_title:           'Պրոեկտներ չկան',
    ws_empty_col_sub:             'Ավելացրեք առաջին պրոեկտը այս հավաքածուին:',
    ws_add_project_action:        '+ Ավելացնել պրոեկտ',
    ws_field_required:            'Այս դաշտը պարտադիր է:',
    ws_create:                    'Ստեղծել',
    ws_creating:                  'Ստեղծվում է…',
    ws_delete:                    'Ջնջել',
    ws_rename:                    'Վերանվանել',
    ws_copy:                      'Պատճենել',
    ws_rename_title:              'Վերանվանել պրոեկտը',
    ws_save:                      'Պահպանել',
    ws_saving:                    'Պահպանվում է…',
    ws_yes:                       'Այո',
    ws_no:                        'Ոչ',
    ws_confirm_del_title:         'Ջնջե՞լ պրոեկտը',
    ws_confirm_del_msg:           'Պրոեկտը կջնջվի ընդմիշտ։ Այս գործողությունը հնարավոր չէ հետարկել։',
    ws_confirm_del_col_title:     'Ջնջե՞լ հավաքածուն',
    ws_confirm_del_col_msg:       'Հավաքածուն կջնջվի։ Դրա պրոեկտները կմնան և կդառնան առանձին։',
    cc_estimate:                  'Հաշվարկ',
    cc_reload:                    'Վերահաշվարկել',
    cc_title:                     'Արժեքի հաշվարկ',
    cc_currency:                  'Արժույթ',
    cc_empty:                     'Այս պրոեկտում դեռ սենյակներ չկան — ավելացրեք՝ արժեքը հաշվելու համար։',
    cc_surfaces:                  'Մակերեսներ',
    cc_room:                      'Սենյակ',
    cc_floor:                     'Հատակ',
    cc_wall:                      'Պատեր',
    cc_ceiling:                   'Առաստաղ',
    cc_total:                     'Ընդամենը',
    cc_free_walls:                'Ազատ պատեր',
    dl_title:            'Ներբեռնել պատկերը',
    dl_sub:              'Պահպանեք ընթացիկ տեսքը կամ թույլ տվեք ԱԻ-ին այն դարձնել ֆոտոռեալիստիկ ռենդեր:',
    dl_model_flux:        'AI Generation',
    dl_model_flux_desc:   'Արագ ֆոտոռեալիստիկ մշակում:',
    dl_model_soon:        'ՇՈՒՏՈՎ',
    dl_model_locked_desc: 'Ժամանակավորապես անհասանելի է:',
    dl_original:         'Ներբեռնել բնօրինակը',
    dl_original_desc:    'Պահպանել 3D տեսքը այնպես, ինչպես տեսնում եք հիմա:',
    dl_ai:               'Ստեղծել FHD ԱԻ',
    dl_ai_desc:          'Ձեր հատակագծի ֆոտոռեալիստիկ ռենդեր՝ Full HD որակով:',
    dl_ai_loading:       'Ստեղծվում է…',
    dl_ai_loading_desc:  'Սա կարող է տևել մինչև մեկ րոպե: Խնդրում ենք չփակել:',
    dl_ai_success:       'ԱԻ ռենդերը ներբեռնվեց:',
    dl_ai_failed:        'Չհաջողվեց ստեղծել ռենդերը: Փորձեք կրկին:',
    dl_ai_signin:        'Մուտք գործեք՝ ԱԻ ռենդերինգն օգտագործելու համար:',
    dl_ready_sub:        'Ռենդերը պատրաստ է: Սեղմեք՝ պահպանելու համար:',
    dl_save:             'Պահպանել պատկերը',
    dl_save_desc:        'Պահպանել ռենդերը ձեր սարքում:',
    dl_capture_failed:   'Չհաջողվեց նկարել 3D տեսքը: Փորձեք կրկին:',
    cc_per_sqm:                   'գին / մ²',
    cc_items:                     'Իրեր',
    cc_item:                      'Իր',
    cc_qty:                       'Քանակ',
    cc_unit_price:                'Միավորի գին',
    cc_items_total:               'Իրերի ընդամենը',
    cc_grand_total:               'Ընդհանուր գին',
    cc_calculate:                 'Հաշվարկել',
    cc_cur_USD:                   'Դոլար',
    cc_cur_RUB:                   'Ռուբլի',
    cc_cur_AMD:                   'Դրամ',
    ws_modal_project_title:       'Նոր պրոեկտ',
    ws_modal_project_label:       'Պրոեկտի անուն',
    ws_modal_project_ph:          'օր.՝ Հյուրասենյակի դիզայն',
    ws_size_label:                'Հարթակի չափը',
    ws_modal_collection_title:    'Նոր հավաքածու',
    ws_modal_collection_label:    'Հավաքածուի անուն',
    ws_modal_collection_ph:       'օր.՝ Ամառային տուն',
    ws_modal_addtocol_title:      'Ավելացնել պրոեկտ հավաքածուին',
    ws_modal_addtocol_label:      'Պրոեկտի անուն',
    ws_modal_addtocol_ph:         'օր.՝ Հիմնական ննջասենյակ',

    // Auth pages
    auth_login_title:      'Բարի վերադարձ',
    auth_login_sub:        'Մուտք գործեք ձեր նախագծմանը շարունակելու համար:',
    auth_google_signin:    'Մուտք Google-ով',
    auth_google_signup:    'Գրանցվել Google-ով',
    auth_or_email_signin:  'կամ մուտք գործեք email-ով',
    auth_phone_signin:     'Մուտք հեռախոսահամարով',
    auth_phone_signup:     'Գրանցվել հեռախոսահամարով',
    auth_or_phone_signin:  'կամ մուտք գործեք հեռախոսահամարով',
    auth_or_phone_signup:  'կամ գրանցվեք հեռախոսահամարով',
    auth_phone_back_email: 'Օգտագործել email',
    phone_label:           'Հեռախոսահամար',
    phone_country:         'Երկիր',
    phone_ph:              '77 12 34 56',
    phone_hint:            'Կուղարկենք 6-նիշ կոդ SMS-ով: Հնարավոր է օպերատորի վճար:',
    // The labels already carry the definite article (-ը), so the template must
    // not add a second one after the placeholder.
    phone_recaptcha_note:    'Այս կայքը պաշտպանված է reCAPTCHA-ով. կիրառվում են Google-ի {privacy} և {terms}:',
    phone_recaptcha_privacy: 'Գաղտնիության քաղաքականությունը',
    phone_recaptcha_terms:   'Օգտագործման պայմանները',
    phone_send:            'Ուղարկել կոդը',
    phone_sending:         'Ուղարկվում է…',
    phone_code_label:      'Հաստատման կոդ',
    phone_code_sent:       'Մուտքագրեք 6-նիշ կոդը, որն ուղարկվել է',
    phone_verify:          'Հաստատել և շարունակել',
    phone_verifying:       'Ստուգվում է…',
    phone_resend:          'Ուղարկել կրկին',
    phone_resend_in:       'Կրկին {n} վրկ հետո',
    phone_change:          'Փոխել համարը',
    phone_err_required:      'Մուտքագրեք ձեր հեռախոսահամարը:',
    phone_err_invalid:       'Ընտրված երկրի համար այս համարը վավեր չէ:',
    phone_err_code_required: 'Մուտքագրեք 6-նիշ կոդը:',
    phone_err_code_invalid:  'Կոդը սխալ է: Ստուգեք և կրկին փորձեք:',
    phone_err_code_expired:  'Կոդի ժամկետը լրացել է: Խնդրեք նորը:',
    phone_err_expired_session: 'Ստուգման ժամկետը լրացավ: Խնդրեք նոր կոդ:',
    phone_err_too_many:      'Չափազանց շատ փորձեր: Սպասեք մի քանի րոպե:',
    phone_err_quota:         'SMS-ը ժամանակավորապես անհասանելի է: Փորձեք ավելի ուշ կամ օգտագործեք email:',
    phone_err_captcha:       'Ստուգումը ձախողվեց: Թարմացրեք էջը և կրկին փորձեք:',
    phone_err_network:       'Ցանցի սխալ: Ստուգեք միացումը:',
    phone_err_not_enabled:   'Հեռախոսով մուտքը այս պահին հասանելի չէ:',
    phone_err_unauthorized_domain: 'Չհաջողվեց ստուգել սարքը: Թարմացրեք էջը և կրկին փորձեք կամ օգտագործեք email:',
    phone_err_disabled:      'Այս հաշիվը արգելափակված է:',
    phone_err_in_use:        'Այս համարն արդեն կապված է այլ հաշվի հետ:',
    phone_err_generic:       'Ինչ-որ բան սխալ գնաց: Կրկին փորձեք:',
    auth_or_email_signup:  'կամ գրանցվեք email-ով',
    auth_email_label:      'Էլ. փոստ',
    auth_email_ph:         'you@example.com',
    auth_id_label:         'Էլ. փոստ կամ հեռախոս',
    auth_id_ph:            'you@example.com կամ +374 77 12 34 56',
    auth_id_phone_hint:    'Թողեք գաղտնաբառը դատարկ՝ կուղարկենք կոդ SMS-ով:',
    auth_id_phone_pw_hint: 'Մուտք հեռախոսահամարով և գաղտնաբառով:',
    auth_err_phone_no_password: 'Այս համարի համար գաղտնաբառ սահմանված չէ: Թողեք դաշտը դատարկ՝ կոդով մուտք գործելու համար:',
    auth_err_email_reserved: 'Այս հասցեն վերապահված է: Օգտագործեք մեկ ուրիշը:',
    auth_err_password_not_set: 'Չհաջողվեց պահել գաղտնաբառը: Կարող եք սահմանել այն ավելի ուշ կարգավորումներում:',
    phone_pw_intro:        'Ձեր համարը հաստատված է: Սահմանեք գաղտնաբառ՝ առանց կոդի սպասելու մուտք գործելու համար:',
    phone_pw_hint:         'Նվազագույնը 6 նիշ: Միշտ կարող եք մուտք գործել նաև կոդով:',
    phone_pw_save:         'Պահել գաղտնաբառը',
    phone_pw_skip:         'Բաց թողնել',
    nav_ai:                'AI',
    sup_admin_name:            'Ադմին',
    adm_support_target_you:    'Ադմինին ուղղված զրույցները գալիս են այս հաշվին։',
    adm_support_target_other:  'Ադմինին ուղղված զրույցները գնում են {uid}։',
    adm_support_target_none:   'Աջակցության հաշիվ ընտրված չէ — «Կապվել ադմինի հետ» կոճակը թաքցված է բոլորի համար։',
    adm_support_claim:         'Օգտագործել այս հաշիվը',
    sup_contact_admin:     'Կապվել ադմինի հետ',
    sup_opening:           'Բացվում է…',
    close:                 'Փակել',
    sup_sub:               'Գրեք մեզ, և մենք կպատասխանենք։',
    sup_message:           'Հաղորդագրություն',
    sup_message_ph:        'Ինչո՞վ կարող ենք օգնել։',
    sup_contact:           'Ինչպես կապվել ձեզ հետ',
    sup_contact_ph:        'Հեռախոս կամ email',
    sup_send:              'Ուղարկել',
    sup_sending:           'Ուղարկվում է…',
    sup_done:              'Հաղորդագրությունն ուղարկվեց։ Մենք կպատասխանենք հնարավորինս շուտ։',
    sup_or_call:           'Կամ զանգահարեք ուղիղ',
    sup_err_failed:        'Չհաջողվեց ուղարկել։ Ստուգեք կապը և փորձեք նորից։',
    sup_err_rejected:      'Հաղորդագրությունը չընդունվեց։ Փորձեք կրճատել այն։',
    sup_err_wait:          'Խնդրում ենք սպասել {s} վրկ՝ հաջորդ հաղորդագրությունն ուղարկելուց առաջ։',
    adm_support:           'Աջակցության հաղորդագրություններ',
    adm_support_none:      'Դեռ հաղորդագրություններ չկան։',
    adm_support_new:       'Նոր',
    adm_support_handled:   'Մշակված',
    adm_support_mark:      'Նշել որպես մշակված',
    adm_support_reopen:    'Վերաբացել',
    adm_support_signedout: 'Առանց մուտքի',
    nav_about:             'Մեր մասին',
    nav_privacy:           'Գաղտնիություն',
    nav_support:           'Կապ մեզ հետ',
    builder_move:          'Տեղափոխել',
    builder_move_on:       'Տեղափոխում',
    phone_exists_title:    '{number} համարով Tunify հաշիվ արդեն գոյություն ունի։',
    phone_exists_body:     'Մենք մուտք գործեցինք այդ հաշիվ։ Եթե ցանկանում էիք ստեղծել երկրորդ հաշիվ, օգտագործեք այլ համար։',
    phone_exists_continue: 'Անցնել իմ հաշիվ',
    phone_taken_body:      'Կոդ չի ուղարկվել։ Մուտք գործեք այս համարով կամ վերադարձեք և նշեք այլ համար։',
    phone_taken_signin:    'Մուտք գործել այս համարով',
    phone_pw_reset_intro:  'Համարը հաստատված է։ Ընտրեք նոր գաղտնաբառ։',
    phone_pw_reset_save:   'Պահպանել նոր գաղտնաբառը',
    phone_pw_reset_skip:   'Շարունակել առանց փոխելու',
    phone_pw_reset_new:    'Այս համարով հաշիվ չկար, ուստի ստեղծեցինք նորը։ Ընտրեք գաղտնաբառ։',
    auth_forgot_use_phone: 'Վերականգնել հեռախոսահամարով',
    auth_forgot_use_email: 'Վերականգնել email հասցեով',
    auth_password_label:   'Գաղտնաբառ',
    auth_password_ph:      '••••••••',
    auth_forgot:           'Մոռացե՞լ եք գաղտնաբառը:',
    auth_signin_btn:       'Մուտք',
    auth_signin_ing:       'Մուտք…',
    auth_no_account:       'Հաշիվ չունե՞ք:',
    auth_create_free:      'Ստեղծեք անվճար',
    auth_register_title:   'Ստեղծել հաշիվ',
    auth_register_sub:     'Սկսեք նախագծել ձեր երազանքի տունը — անվճար:',
    auth_name_label:       'Անուն Ազգանուն',
    auth_name_ph:          'Արամ Հայկազյան',
    auth_password_min_ph:  'Նվ. 6 նիշ',
    auth_confirm_label:    'Հաստատել գաղտնաբառը',
    auth_confirm_ph:       'Կրկնեք գաղտնաբառը',
    auth_signup_btn:       'Ստեղծել անվճար հաշիվ',
    auth_signup_ing:       'Ստեղծվում է…',
    auth_have_account:     'Արդեն ունե՞ք հաշիվ:',
    auth_signin_link:      'Մուտք',
    auth_pw_tooshort:      'Շատ կարճ',
    auth_pw_weak:          'Թույլ',
    auth_pw_fair:          'Միջին',
    auth_pw_good:          'Լավ',
    auth_pw_strong:        'Ուժեղ',
    auth_forgot_title:     'Վերականգնել գաղտնաբառը',
    auth_forgot_sub:       'Մուտքագրեք email-ը — կուղարկենք 6-նիշանոց կոդ:',
    auth_reset_step_sub:   'Մուտքագրեք կոդը և ընտրեք նոր գաղտնաբառ:',
    auth_reset_password_btn: 'Վերականգնել գաղտնաբառը',
    auth_resetting:        'Վերականգնվում է…',
    auth_reset_done_title: 'Գաղտնաբառը վերականգնված է!',
    auth_reset_done_sub:   'Այժմ կարող եք մուտք գործել ձեր նոր գաղտնաբառով:',
    auth_code_sent_to:     'Կոդն ուղարկվել է՝',
    auth_email_addr_label: 'Էլ. փոստի հասցե',
    auth_send_reset:       'Ուղարկել հղումը',
    auth_sending:          'Ուղարկվում է…',
    auth_back_login:       '← Վերադառնալ մուտք',
    auth_inbox_title:      'Ստուգեք ձեր փոստը',
    auth_inbox_sent:       'Մենք ուղարկել ենք վերակայման հղում հետևյալ հասցեով',
    auth_inbox_spam:       'Եթե չտեսնեք — ստուգեք «Spam» թղթապանակը:',
    auth_err_name:         'Անունը պետք է լինի առնվազն 2 նիշ:',
    auth_err_email_req:    'Մուտքագրեք email:',
    auth_err_email_inv:    'Մուտքագրեք ճիշտ email:',
    auth_err_email_taken:  'Այս email-ով հաշիվ արդեն գոյություն ունի:',
    auth_err_email_google: 'Այս email-ը գրանցված է Google-ով: Մուտք գործեք Google-ով:',
    auth_err_no_account:   'Այս email-ով հաշիվ չի գտնվել:',
    auth_err_pass_req:     'Մուտքագրեք գաղտնաբառ:',
    auth_err_pass_min:     'Գաղտնաբառը պետք է լինի առնվազն 6 նիշ:',
    auth_err_conf_req:     'Հաստատեք գաղտնաբառը:',
    auth_err_conf_match:   'Գաղտնաբառերը չեն համընկնում:',

    // Email OTP verification (RegisterForm + EmailCodeVerify)
    auth_send_code:        'Ուղարկել կոդը',
    auth_sending_code:     'Ուղարկվում է…',
    auth_code_label:       'Հաստատման կոդ',
    auth_verify_btn:       'Հաստատել',
    auth_verifying:        'Ստուգվում է…',
    auth_resend_code:      'Կրկին ուղարկել',
    pl_title: 'Փաթեթներ և կրեդիտներ',
    pl_title_credits: 'AI կրեդիտներ',
    pl_lead_credits: 'Կրեդիտները վճարում են AI գեներացիայի համար։ Փաթեթը գնվում է մեկ անգամ — բաժանորդագրություն չկա, կրեդիտները չեն այրվում։',
    pl_balance: 'Դուք ունեք {n} կրեդիտ',
    pl_on_plan: '{p} փաթեթ',
    crb_title: 'Ձեր AI կրեդիտները',
    icm_title: 'Կրեդիտները բավարար չեն',
    pst_your_plan: 'Ձեր փաթեթը',
    ann_title: 'Պրոֆիլի բաններ',
    ann_sub_one: 'Մեկ նկար ձեր հրապարակային էջի վերևում։',
    ann_sub_many: 'Մինչև {n} նկար՝ կարուսել ձեր հրապարակային էջի վերևում։',
    ann_add: 'Ավելացնել',
    ann_working: 'Մշակվում է…',
    ann_remove: 'Հեռացնել',
    ann_move_left: 'Ձախ',
    ann_move_right: 'Աջ',
    ann_err_not_image: 'Սա նկար չէ։',
    ann_err_read: 'Չհաջողվեց կարդալ նկարը։ Փորձեք ուրիշը։',
    ann_err_too_big: 'Նկարը շատ մեծ է նույնիսկ սեղմումից հետո։ Ընտրեք ավելի փոքրը։',
    ann_err_save: 'Չհաջողվեց պահպանել։ Փորձեք կրկին։',
    ann_err_denied: 'Ձեր փաթեթը դա չի թույլատրում։ Թարմացրեք էջը և ստուգեք փաթեթը։',
    pst_msg_free: 'Բարձրացրեք ձեր էջը որոնման մեջ',
    pst_msg_bronze: 'Ավելի բարձր և առաջարկվողների մեջ',
    pst_msg_silver: 'Առաջին տեղերը որոնման և գլխավոր էջում',
    pst_msg_gold: 'Առավելագույն փաթեթը — ամենուր առաջինը',
    pst_upgrade: 'Անցնել {p}-ի',
    pst_manage: 'Կառավարել փաթեթը',
    icm_body: 'Այս գեներացիան արժե ավելի շատ կրեդիտ, քան մնացել է։ Լրացրեք հաշիվը շարունակելու համար։',
    icm_have: 'Դուք ունեք',
    icm_need: 'Անհրաժեշտ է',
    icm_buy: 'Գնել կրեդիտներ',
    icm_cancel: 'Ոչ հիմա',
    pl_lead: 'Սկսեք անվճար։ Անցեք վճարովի փաթեթի, երբ անհրաժեշտ է ավելի շատ տեղ, ավելի լավ դիրք և ամսական կրեդիտներ։',
    pl_free: 'Անվճար',
    pl_name_free: 'Անվճար',
    pl_name_bronze: 'Բրոնզ',
    pl_name_silver: 'Արծաթ',
    pl_name_gold: 'Ոսկի',
    pl_per_mo: '{n}/ամիս',
    pl_once: '{n} միանվագ',
    pl_month: 'ամիս',
    pl_popular: 'Ամենապահանջվածը',
    pl_current: 'Ձեր փաթեթը',
    pl_choose: 'Ընտրել',
    pl_unlimited: 'Անսահմանափակ',
    pl_credits: 'կրեդիտ',
    pl_credits_mo: '{n} կրեդիտ ամեն ամիս',
    pl_credits_once: '{n} կրեդիտ սկսելու համար',
    pl_f_credits: 'AI կրեդիտներ',
    pl_f_portfolio: 'Պորտֆոլիոյի նկարներ',
    pl_f_projects: 'Նախագծեր',
    pl_f_discount: 'Զեղչ փաթեթների վրա',
    pl_f_messaging: 'Հաղորդագրություններ հաճախորդներից',
    pl_f_search: 'Դիրքը որոնման մեջ',
    pl_f_recommended: 'Առաջարկություններ',
    pl_f_social: 'Մեր Instagram / TikTok',
    pl_f_design: 'Պրոֆիլի էջի դիզայն',
    pl_f_banner: 'Պրոֆիլի բաններ',
    pl_lead_shop: 'Ձեր խանութն ու ապրանքները՝ առաջին տեղերում որոնման մեջ, առաջարկություններում և գլխավոր էջում։',
    pl_f_prodimg: 'Ապրանքի նկարներ',
    pl_f_recshops: 'Առաջարկվող խանութներ',
    pl_f_landing: 'Ցուցադրում գլխավոր էջում',
    pl_recshop_none: 'Երբեք',
    pl_recshop_chance: 'Հնարավորություն',
    pl_recshop_always: 'Միշտ',
    pl_social_days: '{n} օր',
    pl_design_default: 'Ստանդարտ',
    pl_ask_title: 'Հարցե՞ր ունեք, կամ պետք է մի բան, որը այստեղ չկա։',
    pl_ask_body: 'Գրեք Tunify-ի թիմին ուղիղ, և մենք կպատասխանենք։',
    pl_ask_btn: 'Կապվել ադմինի հետ',
    pl_banner_one: '1 նկար',
    pl_banner_many: '{n} — կարուսել',
    pl_f_support: 'Առաջնահերթ աջակցություն',
    pl_rank_0: 'Ստանդարտ',
    pl_rank_1: 'Սովորական',
    pl_rank_2: 'Ավելի բարձր',
    pl_rank_3: 'Ամենաբարձր',
    pl_rec_0: 'Երբեք',
    pl_rec_1: 'Փոքր շանս',
    pl_rec_2: 'Լավ շանս',
    pl_rec_3: 'Միշտ',
    pl_social_0: '—',
    pl_social_1: 'Ամսական 1',
    pl_social_2: 'Ամսական 2+',
    pl_design_free: 'Սովորական',
    pl_design_bronze: 'Bronze',
    pl_design_silver: 'Silver',
    pl_design_gold: 'Gold',
    pl_packs_title: 'Գնել կրեդիտներ',
    pl_packs_lead: '3D ռենդերը՝ {render} կրեդիտ։ AI վիզուալացումը լուսանկարից՝ {staging}։ Կրեդիտները չեն այրվում։',
    pl_best: 'Ամենաշահավետը',
    pl_per_credit: '${n} մեկի համար',
    pl_soon: 'Վճարումները դեռ միացված չեն — գները վերջնական են, բայց հավելվածում գնել հնարավոր չէ։',
    auth_code_spam_hint:   'Նամակը կարող է հասնել մեկ րոպեի ընթացքում։ Եթե չեք գտնում, ստուգեք «Սպամ» պանակը։',
    auth_resend_in:        'Կրկին՝',
    auth_email_verified:   'Email-ը հաստատված է:',
    auth_enter_email_first: 'Նախ մուտքագրեք վավեր email:',
    auth_enter_code:       'Մուտքագրեք 6-նիշանոց կոդը:',
    auth_verify_email_gate: 'Նախ հաստատեք ձեր email-ը:',
    auth_verify_step_sub:  'Նախ հաստատենք ձեր email հասցեն:',
    auth_details_step_sub: 'Գրեթե պատրաստ է — ընտրեք անուն և գաղտնաբառ:',
    auth_type_step_sub: 'Ինչպե՞ս եք օգտագործելու Tunify-ը:',
    auth_continue: 'Շարունակել',
    ut_title: 'Հաշվի տեսակ',
    ut_customer: 'Հաճախորդ',
    atg_welcome: 'Բարի գալուստ Tunify',
    atg_sub: 'Ընտրեք ձեզ հարմարը։ Հետագայում կարող եք փոխել կարգավորումներում։',
    atg_change_later: 'Հաշվի տեսակը ցանկացած պահի կարող եք փոխել կարգավորումներում։',
    atg_save_failed: 'Չհաջողվեց պահպանել։ Ստուգեք կապը և կրկին փորձեք։',
    ut_customer_desc: 'Նախագծեք ձեր տունը 3D-ով, պլանավորեք սենյակները և հաշվեք արժեքը:',
    ut_designer: 'Դիզայներ',
    ut_designer_desc: 'Ամեն ինչ, ինչ ունի հաճախորդը, գումարած հրապարակային էջ՝ ձեր աշխատանքները ցուցադրելու համար:',
    ut_shop: 'Խանութ',
    ut_shop_desc: 'Վաճառեք նյութեր, կահույք կամ ֆուռնիտուրա՝ հրապարակային էջ ապրանքներով, գներով և կոնտակտներով:',

    // ── ԽԱՆՈՒԹԻ ՊՐՈՖԻԼ ──
    shop_logo: 'Լոգո',
    shop_name: 'Խանութի անվանումը',
    shop_name_ph: 'օր․՝ Քար և Փայտ',
    shop_categories: 'Ի՞նչ եք վաճառում',
    shop_delivery: 'Կա առաքում',
    shop_delivery_hint: 'Ցուցադրվում է ձեր էջում և օգտագործվում է որպես որոնման զտիչ:',
    shop_location: 'Հասցե',
    shop_description: 'Խանութի մասին',
    shop_description_ph: 'Ի՞նչ եք վաճառում, ո՞ր բրենդները, աշխատանքային ժամերը…',
    shop_website: 'Կայք',
    shop_socials: 'Կոնտակտներ և սոցցանցեր',
    shop_social_handle: 'օգտանուն',
    shop_social_phone: 'Հեռախոս',
    shop_social_instagram: 'Instagram',
    shop_social_facebook: 'Facebook',
    shop_social_tiktok: 'TikTok',
    shop_social_telegram: 'Telegram',
    shop_section_title: 'Խանութի պրոֆիլ',
    shop_section_sub: 'Սա այն է, ինչ տեսնում են հաճախորդները, երբ գտնում են ձեզ:',
    shop_save: 'Պահպանել խանութի պրոֆիլը',
    shop_saved: 'Խանութի պրոֆիլը պահպանվեց:',
    shop_err_name: 'Նշեք խանութի անվանումը (նվազագույնը 2 նիշ):',
    shop_err_categories: 'Ընտրեք գոնե մեկ կատեգորիա:',
    shop_cat_building_materials: 'Շինանյութ',
    shop_cat_furniture: 'Կահույք',
    shop_cat_openings: 'Պատուհաններ և դռներ',
    shop_cat_walls: 'Պատեր և ներկ',
    shop_cat_floor: 'Հատակ',
    shop_cat_ceiling: 'Առաստաղ',
    shop_cat_lighting: 'Լուսավորություն',
    shop_cat_electronics: 'Էլեկտրոնիկա',
    shop_cat_plumbing: 'Սանտեխնիկա',
    shop_cat_tiles: 'Սալիկ',
    shop_cat_textiles: 'Տեքստիլ',
    shop_cat_decor: 'Դեկոր',
    shop_cat_kitchen: 'Խոհանոց',
    shop_cat_bathroom: 'Լոգարան',
    shop_cat_garden: 'Այգի և բակ',
    shop_cat_tools: 'Գործիքներ',
    // ── PRODUCT TAXONOMY ──
    prod_type: 'Ապրանքի տեսակ',
    prod_type_ph: 'Ընտրեք տեսակը…',
    prod_subtype: 'Ենթատեսակ',
    prod_subtype_ph: 'Ընտրեք ենթատեսակը…',
    prod_color: 'Գույն',
    prod_price_range: 'Գին',
    prod_price_min: 'Սկսած',
    prod_price_max: 'Մինչև',
    prod_err_type: 'Ընտրեք ապրանքի տեսակը:',
    prod_err_subtype: 'Ընտրեք ենթատեսակը:',
    prod_err_color: 'Ընտրեք գույնը:',
    search_products: 'Գտնել ապրանքներ',
    search_mode_products: 'Ապրանքներ',
    search_product_ph: 'Որոնել ըստ անվան, տեսակի կամ գույնի…',
    search_none_products: 'Այս ֆիլտրերով ապրանք չի գտնվել:',
    prod_color_white: 'Սպիտակ',
    prod_color_beige: 'Բեժ',
    prod_color_grey: 'Մոխրագույն',
    prod_color_black: 'Սև',
    prod_color_brown: 'Շագանակագույն',
    prod_color_wood: 'Փայտի',
    prod_color_gold: 'Ոսկեգույն',
    prod_color_silver: 'Արծաթագույն',
    prod_color_blue: 'Կապույտ',
    prod_color_green: 'Կանաչ',
    prod_color_red: 'Կարմիր',
    prod_color_yellow: 'Դեղին',
    prod_color_orange: 'Նարնջագույն',
    prod_color_pink: 'Վարդագույն',
    prod_color_purple: 'Մանուշակագույն',
    prod_color_multicolor: 'Բազմագույն',
    prod_sub_cement: 'Ցեմենտ և շաղախ',
    prod_sub_plaster_mix: 'Սվաղ և շպակլյովկա',
    prod_sub_insulation: 'Ջերմամեկուսիչ',
    prod_sub_timber: 'Փայտանյութ',
    prod_sub_drywall: 'Գիպսաստվարաթուղթ',
    prod_sub_brick_block: 'Աղյուս և բլոկ',
    prod_sub_adhesive: 'Սոսինձ և հերմետիկ',
    prod_sub_waterproofing: 'Հիդրոմեկուսացում',
    prod_sub_sofa: 'Բազմոց',
    prod_sub_armchair: 'Բազկաթոռ',
    prod_sub_chair: 'Աթոռ',
    prod_sub_table: 'Սեղան',
    prod_sub_bed: 'Մահճակալ',
    prod_sub_wardrobe: 'Պահարան',
    prod_sub_shelving: 'Դարակաշար',
    prod_sub_desk: 'Գրասեղան',
    prod_sub_sideboard: 'Կոմոդ',
    prod_sub_stool: 'Թաբուրետ և նստարան',
    prod_sub_window: 'Պատուհան',
    prod_sub_door_interior: 'Միջսենյակային դուռ',
    prod_sub_door_entrance: 'Մուտքի դուռ',
    prod_sub_sliding_door: 'Շարժական դուռ',
    prod_sub_door_handle: 'Բռնակներ և կողպեքներ',
    prod_sub_window_sill: 'Պատուհանագոգ',
    prod_sub_paint: 'Ներկ',
    prod_sub_wallpaper: 'Պաստառ',
    prod_sub_wall_panel: 'Պատի վահանակներ',
    prod_sub_decorative_plaster: 'Դեկորատիվ սվաղ',
    prod_sub_wall_moulding: 'Մոլդինգ և ծեփածո',
    prod_sub_parquet: 'Պարկետ',
    prod_sub_laminate: 'Լամինատ',
    prod_sub_floor_tile: 'Հատակի սալիկ',
    prod_sub_carpet: 'Գորգածածկ',
    prod_sub_vinyl: 'Վինիլ և LVT',
    prod_sub_skirting: 'Պլինտուս',
    prod_sub_underlay: 'Ենթաշերտ',
    prod_sub_stretch_ceiling: 'Ձգվող առաստաղ',
    prod_sub_ceiling_panel: 'Առաստաղի վահանակներ',
    prod_sub_plasterboard_ceiling: 'Գիպսակարտոնե առաստաղ',
    prod_sub_cornice: 'Քիվ',
    prod_sub_chandelier: 'Ջահ',
    prod_sub_pendant_light: 'Կախովի լուսատու',
    prod_sub_ceiling_light: 'Առաստաղի լուսատու',
    prod_sub_wall_light: 'Պատի լուսատու',
    prod_sub_floor_lamp: 'Հատակի լամպ',
    prod_sub_table_lamp: 'Սեղանի լամպ',
    prod_sub_led_strip: 'LED ժապավեն',
    prod_sub_spotlight: 'Կետային լուսատու',
    prod_sub_outdoor_light: 'Բացօթյա լուսատու',
    prod_sub_tv: 'Հեռուստացույց',
    prod_sub_fridge: 'Սառնարան',
    prod_sub_oven: 'Ջեռոց',
    prod_sub_hob: 'Գազօջախ',
    prod_sub_extractor_hood: 'Օդաքաշ',
    prod_sub_dishwasher: 'Ամանլվաց մեքենա',
    prod_sub_washing_machine: 'Լվացքի մեքենա',
    prod_sub_air_conditioner: 'Օդորակիչ',
    prod_sub_water_heater_el: 'Ջրատաքացուցիչ',
    prod_sub_smart_home: 'Խելացի տուն',
    prod_sub_audio: 'Աուդիո տեխնիկա',
    prod_sub_plumbing_sink: 'Լվացարան',
    prod_sub_basin: 'Ձեռքլվացարան',
    prod_sub_toilet: 'Զուգարանակոնք',
    prod_sub_bathtub: 'Լոգարան',
    prod_sub_shower_cabin: 'Ցնցուղախցիկ',
    prod_sub_tap: 'Ծորակ',
    prod_sub_radiator: 'Ռադիատոր',
    prod_sub_boiler: 'Կաթսա',
    prod_sub_pipe_fitting: 'Խողովակներ և ֆիտինգներ',
    prod_sub_ceramic_tile: 'Կերամիկական սալիկ',
    prod_sub_porcelain_tile: 'Կերամոգրանիտ',
    prod_sub_mosaic: 'Խճանկար',
    prod_sub_natural_stone: 'Բնական քար',
    prod_sub_grout: 'Խյուս և սոսինձ',
    prod_sub_curtains: 'Վարագույրներ և ժալյուզի',
    prod_sub_rug: 'Գորգ',
    prod_sub_cushion: 'Բարձեր',
    prod_sub_bedding: 'Անկողնային սպիտակեղեն',
    prod_sub_upholstery_fabric: 'Կահույքի գործվածք',
    prod_sub_towels: 'Սրբիչներ',
    prod_sub_mirror: 'Հայելի',
    prod_sub_wall_art: 'Նկարներ և պաստառներ',
    prod_sub_vase: 'Ծաղկաման',
    prod_sub_clock: 'Ժամացույց',
    prod_sub_candle_holder: 'Մոմեր և մոմակալներ',
    prod_sub_planter_indoor: 'Ծաղկաման (ներսի)',
    prod_sub_figurine: 'Արձանիկներ',
    prod_sub_photo_frame: 'Լուսանկարի շրջանակ',
    prod_sub_kitchen_set: 'Խոհանոցի կահույք',
    prod_sub_countertop: 'Աշխատասեղան',
    prod_sub_backsplash: 'Խոհանոցի գոգնոց',
    prod_sub_kitchen_sink: 'Խոհանոցի լվացարան',
    prod_sub_kitchen_tap: 'Խոհանոցի ծորակ',
    prod_sub_cookware: 'Խոհանոցային սպասք',
    prod_sub_kitchen_storage: 'Խոհանոցի պահեստավորում',
    prod_sub_vanity_unit: 'Լվացարանի պահարան',
    prod_sub_bathroom_cabinet: 'Լոգարանի պահարան',
    prod_sub_shower_enclosure: 'Ցնցուղի պատնեշ',
    prod_sub_towel_rail: 'Սրբիչի չորանոց',
    prod_sub_bathroom_mirror: 'Լոգարանի հայելի',
    prod_sub_bathroom_accessory: 'Լոգարանի պարագաներ',
    prod_sub_garden_furniture: 'Այգու կահույք',
    prod_sub_planter_outdoor: 'Բացօթյա ծաղկաման',
    prod_sub_garden_lighting: 'Այգու լուսավորություն',
    prod_sub_paving: 'Սալահատակ',
    prod_sub_bbq_grill: 'Խորոված և գրիլ',
    prod_sub_fencing: 'Ցանկապատ',
    prod_sub_power_tool: 'Էլեկտրական գործիքներ',
    prod_sub_hand_tool: 'Ձեռքի գործիքներ',
    prod_sub_ladder: 'Սանդուղքներ',
    prod_sub_measuring_tool: 'Չափիչ գործիքներ',
    prod_sub_fixings: 'Ամրակներ',
    prod_sub_safety_gear: 'Պաշտպանիչ միջոցներ',
    // Խանութի հրապարակային էջ և ապրանքներ
    shop_not_found: 'Այդպիսի խանութ չգտնվեց:',
    prod_gone: 'Այս հայտարարությունն այլևս հասանելի չէ:',
    prod_call: 'Զանգահարել',
    prod_zoom: 'Դիտել ամբողջ չափով',
    gate_why_basket: 'Ստեղծեք հաշիվ՝ «{name}»-ը զամբյուղում ավելացնելու համար։',
    shop_tab_products: 'Ապրանքներ',
    shop_no_products: 'Դեռ ոչինչ հրապարակված չէ:',
    gal_menu_details: 'Նկարագրություն և գին',
    gal_details_sub: 'Ի՞նչ ապրանք է սա, ի՞նչ արժե և որտեղից գնել:',
    gal_product_desc_ph: 'Անվանում, չափս, նյութ, բրենդ…',
    gal_name: 'Ապրանքի անվանումը',
    gal_name_ph: 'օր․՝ Կաղնու աթոռ',
    gal_price: 'Գին',
    gal_price_ph: '0',
    gal_product_link: 'Հղում ապրանքին',
    gal_link_optional: 'Հղումը պարտադիր չէ — թողեք դատարկ՝ թաքցնելու համար:',
    gal_price_gate: 'Գինը պարտադիր է: Քանի դեռ չեք նշել, լուսանկարը չի հրապարակվում — կարող եք ավելացնել ավելի ուշ՝ քարտի ընտրացանկից:',
    gal_err_price: 'Նշեք 0-ից մեծ գին:',
    gal_err_price_max: 'Գինը չափազանց մեծ է:',
    gal_err_link: 'Սա հղման նման չէ:',
    gal_needs_price: 'Պետք է գին',
    gal_needs_details: 'Պետք է տեսակ',
    gal_buy: 'Դիտել ապրանքը',
    gal_skip: 'Բաց թողնել',
    gal_image_count: '{n} լուսանկար',
    gal_new_post: 'Նոր հրապարակում',
    gal_new_post_sub: 'Ավելացրեք մինչև {max} լուսանկար և նկարագրեք դրանք:',
    gal_new_product_sub: 'Ավելացրեք մինչև {max} լուսանկար, ապա նշեք՝ ինչ ապրանք է սա և ինչ արժե:',
    gal_add_images: 'Ավելացնել լուսանկարներ',
    gal_remove_image: 'Հեռացնել այս լուսանկարը',
    gal_shot_n: 'Լուսանկար {n}',
    gal_post: 'Հրապարակել',
    gal_images_hint: '{n} / {max} լուսանկար: Առաջինը շապիկն է:',
    gal_err_no_image: 'Ավելացրեք գոնե մեկ լուսանկար:',
    gal_images: 'Այս հրապարակման լուսանկարները',
    gal_err_images_max: 'Ավելացվել են միայն առաջին {n} լուսանկարները — մեկ հրապարակումն ավելին չի տեղավորում:',
    ds_avatar: 'Պրոֆիլի նկար',
    ds_avatar_hint: 'Քառակուսի նկար: Չափը փոխվում է ավտոմատ:',
    ds_avatar_remove: 'Հեռացնել',
    avl_open: 'Դիտել պրոֆիլի նկարը',
    tab_feed: 'Գլխավոր',
    tab_search: 'Որոնում',
    tab_messages: 'Հաղորդագրություններ',
    tab_alerts: 'Ծանուցումներ',
    tab_profile: 'Պրոֆիլ',
    nav_primary: 'Հիմնական նավիգացիա',
    avl_change: 'Փոխել նկարը',
    avl_add: 'Ավելացնել նկար',
    avl_delete_confirm: 'Հեռացնե՞լ պրոֆիլի նկարը։',
    avc_title: 'Տեղադրեք ձեր լուսանկարը',
    avc_hint: 'Քաշեք՝ տեղաշարժելու համար · սեղմեք կամ պտտեք՝ մասշտաբի համար',
    avc_zoom: 'Մասշտաբ',
    avc_apply: 'Կիրառել',
    ps_likes: 'Հավանումներ',
    ml_title: 'Իմ հավանածները',
    // ── ԶԱՄԲՅՈՒՂ ──
    bsk_title: 'Իմ զամբյուղը',
    bsk_add: 'Ավելացնել զամբյուղում',
    bsk_remove: 'Հեռացնել զամբյուղից',
    bsk_clear: 'Դատարկել զամբյուղը',
    bsk_remove_title: 'Հեռացնե՞լ այս ապրանքը։',
    bsk_remove_msg: 'Այն կհեռացվի զամբյուղից։ Կարող եք ցանկացած պահի նորից ավելացնել այն իր էջից։',
    bsk_clear_title: 'Դատարկե՞լ զամբյուղը։',
    bsk_clear_msg: 'Բոլոր պահված ապրանքները ({n}) կհեռացվեն։',
    bsk_empty: 'Զամբյուղը դատարկ է: Բացեք խանութի ապրանքը և սեղմեք զամբյուղի պատկերակը:',
    bsk_unavailable: 'Այլևս հասանելի չէ',
    chat_title: 'Հաղորդագրություններ',
    chat_message: 'Գրել',
    chat_none: 'Դեռ զրույցներ չկան:',
    chat_pick: 'Ընտրեք զրույցը:',
    chat_empty: 'Հաղորդագրություններ դեռ չկան: Բարևեք:',
    chat_no_messages: 'Հաղորդագրություններ չկան',
    chat_placeholder: 'Գրել հաղորդագրություն...',
    chat_send: 'Ուղարկել',
    chat_older: 'Բեռնել հին հաղորդագրությունները',
    // ── floor plan import (create-project modal) ──
    fp_label: 'Հատակագիծ (ըստ ցանկության)',
    fp_upload: 'Վերբեռնել հատակագիծ',
    fp_upload_hint: 'PNG կամ JPG — կհայտնաբերենք սենյակները, դռներն ու պատուհանները',
    fp_ai_notice: 'Ստեղծված է AI-ով, ճշգրտությունը սովորաբար 70–100% է՝ կախված գծագրից: Ստուգեք պատերը, դռներն ու պատուհանները և ուղղեք սխալները — ամեն ինչ մնում է խմբագրելի:',
    fp_detecting: 'Հայտնաբերում ենք սենյակները…',
    fp_found: '{rooms} սենյակ · {doors} դուռ · {windows} պատուհան',
    fp_nothing_found: 'Ոչինչ չհայտնաբերվեց — կարող եք ստեղծել նախագիծը և գծել ինքներդ:',
    fp_failed: 'Չհաջողվեց կարդալ հատակագիծը: Փորձեք այլ նկար:',
    fp_not_configured: 'Հատակագծի հայտնաբերումը կարգավորված չէ:',
    fp_remove: 'Հեռացնել',
    fp_scale: 'Մասշտաբ',
    fp_scale_hint: 'Քաշեք, մինչև չափը համընկնի իրական տան հետ:',
    fp_overlay: 'Բնօրինակ հատակագիծը',
    fp_overlay_hint: 'Ցուցադրեք վերբեռնված գծագիրը հետևում՝ ստուգելու պատերի համընկնումը:',
    chat_edit: 'Խմբագրել',
    chat_save: 'Պահպանել',
    chat_edited: 'խմբագրված',
    chat_reply: "Պատասխանել",
    chat_react: "Ռեակցիա",
    chat_actions: "Հաղորդագրության գործողություններ",
    chat_img_add: "Ուղարկել նկար",
    chat_img_open: "Բացել նկարը",
    chat_img_working: "Նկարը պատրաստվում է…",
    chat_blocked_word: 'Հաղորդագրությունը չուղարկվեց — «{word}» բառը այստեղ թույլատրելի չէ։',
    chat_send_failed: 'Հաղորդագրությունը չուղարկվեց։ Փորձեք նորից։',
    chat_img_type: "Այս ֆայլը նկար չէ։",
    chat_img_large: "Այս նկարը չափազանց մեծ է ուղարկելու համար։",

    // ── comments on a photo ──
    cm_title: "Մեկնաբանություններ",
    cm_none: "Դեռ մեկնաբանություններ չկան։ Եղեք առաջինը։",
    cm_loading: "Բեռնվում է…",
    cm_post: "Ուղարկել",
    cm_placeholder: "Ավելացնել մեկնաբանություն…",
    cm_replying: "Պատասխան՝ {name}",
    cm_edited: "խմբագրված",
    cm_someone: "Ինչ-որ մեկը",
    cm_signin: "Մուտք գործեք՝ քննարկմանը միանալու համար։",
    cm_now: "հենց հիմա",
    cm_m: "{n} ր",
    cm_h: "{n} ժ",
    cm_d: "{n} օր",
    chat_copy: "Պատճենել",
    chat_replying_to: "Պատասխան՝",
    chat_reply_gone: "Հաղորդագրությունն անհասանելի է",
    chat_delete: 'Ջնջել զրույցը',
    chat_delete_confirm: 'Հեռացնե՞լ այս զրույցը ցանկից: Այն կվերադառնա, եթե ձեզ նորից գրեն:',
    chat_delete_msg_confirm: 'Ջնջե՞լ այս հաղորդագրությունը բոլորի մոտ:',
    chat_loading: 'Բեռնվում է...',
    chat_someone: 'Ինչ-որ մեկը',
    chat_you: 'Դուք՝',
    ml_sub: 'Ձեր հավանած լուսանկարներն ու 3D նախագծերը:',
    ml_empty: 'Դեռ ոչինչ չկա: Սեղմեք սիրտը ձեր հավանած աշխատանքի վրա:',
    ml_untitled: 'Անանուն նախագիծ',
    ps_views: 'Դիտումներ',
    ps_like: 'Հավանել',
    ps_liked: 'Հավանված',
    ps_unlike: 'Հեռացնել հավանումը',
    ps_login_to_like: 'Մուտք գործեք՝ հավանելու համար',
    ps_like_own: 'Սա ձեր աշխատանքն է',
    ds_fullname: 'Անուն Ազգանուն',
    ds_fullname_ph: 'Անի Հակոբյան',
    ds_optional: '(ըստ ցանկության)',
    ds_styles: 'Դիզայնի ոճեր',
    ds_experience: 'Աշխատանքային փորձ (տարի)',
    ds_rate: 'Դրույք',
    ds_rate_ph: 'օր. 5000',
    ds_currency: 'Արժույթ',
    ds_err_rate: 'Մուտքագրեք վավեր դրույք:',
    ds_years_short: '{n} տարվա փորձ',
    ds_per_hour: '/ժամ',
    gal_prev: 'Նախորդ',
    gal_shrink: 'Դուրս գալ լիաէկրանից',
    gal_next: 'Հաջորդ',
    ds_location: 'Տեղանք',
    ds_location_ph: 'Սկսեք գրել քաղաքը…',
    ds_location_map_hint: 'Փնտրեք վայրը կամ սեղմեք քարտեզին՝ նշիչ դնելու համար:',
    ds_description: 'Ձեր մասին',
    ds_description_ph: 'Պատմեք հաճախորդներին ձեր աշխատանքի մասին…',
    ds_websites: 'Կայքեր',
    ds_add_website: 'Ավելացնել կայք',
    ds_contacts: 'Կոնտակտներ',
    ds_add_contact: 'Ավելացնել կոնտակտ',
    ds_contact_link: 'Հղում',
    ds_contact_phone: 'Հեռախոս',
    ds_remove: 'Հեռացնել',
    ds_err_name: 'Մուտքագրեք անուն ազգանունը (նվազագույնը 2 նիշ):',
    ds_err_name_long: 'Անունը շատ երկար է:',
    ds_err_desc_long: 'Նկարագրությունը շատ երկար է:',
    ds_err_experience: 'Մուտքագրեք ամբողջ թիվ 0-70 միջակայքում:',
    ds_err_styles_max: 'Չափազանց շատ ոճեր են ընտրված:',
    ds_err_sites_max: 'Չափազանց շատ կայքեր:',
    ds_err_site_invalid: 'Կայքի հասցեներից մեկը վավեր չէ:',
    ds_err_contacts_max: 'Չափազանց շատ կոնտակտներ:',
    ds_err_contact_invalid: 'Կոնտակտներից մեկը վավեր հղում կամ հեռախոս չէ:',
    ds_err_avatar: 'Չհաջողվեց մշակել նկարը: Փորձեք մեկ ուրիշը:',
    ds_err_avatar_large: 'Նկարը շատ մեծ է նույնիսկ սեղմումից հետո:',
    ds_section_title: 'Դիզայների պրոֆիլ',
    gal_photos_title: 'Լուսանկարներ',
    like_add: 'Հավանել',
    like_liked: 'Հավանված',
    like_remove: 'Հեռացնել հավանումը',
    like_own: 'Սա ձեր պրոֆիլն է',
    like_count: 'Հավանումներ',
    md_title: 'Իմ դիզայներները',
    md_card_desc: 'Ձեր հավանած դիզայներները:',
    md_empty: 'Դեռ ոչ մեկին չեք հավանել: Բացեք պրոֆիլը և սեղմեք «Հավանել»:',
    md_liked_shops: 'Հավանած խանութներ',
    md_recommended: 'Առաջարկվող դիզայներներ',
    md_recommended_sub: 'Հայտնի աշխատանքներն ավելի հաճախ են երևում, ցանկը փոխվում է ամեն այցի:',
    md_projects: 'Նախագծեր',
    md_projects_sub: 'Tunify-ում հրապարակված աշխատանքներն ու ապրանքները:',
    md_shops: 'Խանութներ',
    md_shops_sub: 'Նյութեր, կահույք և ֆուռնիտուրա Tunify-ի խանութներից:',
    md_work: 'Հրապարակված',
    md_filter_all: 'Բոլորը',
    md_filter_projects: 'Նախագծեր',
    md_filter_products: 'Ապրանքներ',
    md_no_projects: 'Դեռ նախագծեր չկան:',
    md_no_products: 'Դեռ ապրանքներ չկան:',
    md_none: 'Դեռ ցուցադրելու բան չկա:',
    gal_show_more: 'Ցույց տալ ևս ({n})',
    notif_title: 'Ծանուցումներ',
    notif_none: 'Ծանուցումներ դեռ չկան:',
    notif_liked: '{name}-ը հավանել է ձեր պրոֆիլը',
    notif_liked_project: '{name}-ը հավանել է ձեր նախագիծը',
    notif_liked_photo: '{name}-ը հավանել է ձեր լուսանկարը',
    notif_replied: "{name}-ը պատասխանել է ձեր մեկնաբանությանը",
    notif_commented_photo: '{name}-ը մեկնաբանել է ձեր լուսանկարը',
    notif_commented_design: '{name}-ը մեկնաբանել է ձեր նախագիծը',
    search_designers: 'Գտնել դիզայներների',
    search_shops: 'Գտնել խանութներ',
    search_mode: 'Ի՞նչ եք փնտրում',
    search_mode_designers: 'Դիզայներներ',
    search_mode_shops: 'Խանութներ',
    search_shop_ph: 'Որոնել ըստ անվան կամ ապրանքի…',
    search_delivery_only: 'Միայն առաքումով',
    search_none_shops: 'Այս ֆիլտրերով խանութ չի գտնվել:',
    search_ph: 'Որոնել ըստ անվան կամ ոճի…',
    search_any: 'Ցանկացած',
    search_exp_min: '{n}+ տարի',
    search_clear: 'Մաքրել ֆիլտրերը',
    search_loading: 'Բեռնվում է…',
    search_none: 'Այս ֆիլտրերով դիզայներ չի գտնվել:',
    search_count: '{n} դիզայներ',
    dp_not_found: 'Այս պրոֆիլը հասանելի չէ:',
    dp_no_work: 'Այստեղ դեռ ոչինչ հրապարակված չէ:',
    dp_tier_verified: 'Հաստատված {p} դիզայներ',
    dp_cap_recommended: 'Առաջարկվող',
    dp_cap_partner: "Գործընկեր",
    dp_cap_prioritySupport: 'Առաջնահերթություն',
    nav_login: 'Մուտք',
    gal_settings: 'Կարգավորումներ',
    gal_menu_publish: 'Դարձնել հրապարակային',
    gal_menu_unpublish: 'Դարձնել թաքցված',
    gal_menu_description: 'Նկարագրություն',
    gal_desc_sub: 'Ցուցադրվում է այս տարրի տակ ձեր պրոֆիլում:',
    gal_save: 'Պահպանել',
    gal_yes: 'Այո, ջնջել',
    gal_no: 'Չեղարկել',
    dg_title: 'Հրապարակված աշխատանքներ',
    dg_tab_img: 'Նկար',
    dg_tab_3d: '3D',
    dg_3d_empty: 'Հրապարակված նախագծեր դեռ չկան: Բացեք նախագիծը և ընտրեք «Հրապարակել» ընտրացանկից:',
    pub_action: 'Հրապարակել',
    pub_title: 'Հրապարակել պրոֆիլում',
    pub_sub: 'Ընտրեք շապիկի նկարը և նկարագրեք նախագիծը:',
    pub_pick_cover: '+ Ընտրել շապիկ',
    pub_publish: 'Հրապարակել',
    pub_allow_copy: "Թույլ տալ պահպանել պատճենը իրենց աշխատասեղանին",
    pub_allow_download: "Թույլ տալ ներբեռնել պատկերը",
    pub_err_cover: 'Նախ ընտրեք շապիկի նկարը:',
    gal_designs_title: 'Հրապարակված 3D նախագծեր',
    gal_sub: 'Հրապարակված տարրերը երևում են ձեր պրոֆիլում:',
    gal_add: '+ Ավելացնել նկարներ',
    gal_uploading: 'Բեռնվում է…',
    gal_empty: 'Դեռ ոչինչ հրապարակված չէ: Ավելացրեք ձեր աշխատանքների նկարները:',
    gal_designs_empty: 'Հրապարակված նախագծեր դեռ չկան: Ավելացրեք 3D սենյակի ռենդեր:',
    gal_desc_ph: 'Ավելացրեք նկարագրություն…',
    gal_hide: 'Թաքցնել պրոֆիլից',
    gal_show: 'Ցուցադրել պրոֆիլում',
    gal_hidden: 'Թաքցված',
    gal_delete: 'Ջնջել',
    gal_open: 'Բացել նկարը',
    gal_delete_confirm: 'Ջնջե՞լ այս տարրը ընդմիշտ:',
    gal_err_upload: 'Չհաջողվեց բեռնել նկարը: Փորձեք մեկ ուրիշը:',
    gal_err_large: 'Նկարը շատ մեծ է նույնիսկ սեղմումից հետո:',
    gal_err_save: 'Չհաջողվեց պահպանել փոփոխությունը: Փորձեք կրկին:',
    gal_err_max: 'Հասել եք տարրերի առավելագույն քանակին:',
    ds_section_sub: 'Այս տվյալները երևում են հրապարակային էջում և որոնման մեջ:',
    ds_save: 'Պահպանել պրոֆիլը',
    ds_saved: 'Դիզայների պրոֆիլը պահպանվեց:',
    ds_saved_unpublished: 'Պրոֆիլը պահպանվեց, բայց դեռ չի երևում որոնման մեջ: Փորձեք կրկին:',
    ds_become: 'Դառնալ դիզայներ',
    ds_become_desc: 'Հրապարակեք աշխատանքները, որ հաճախորդները ձեզ գտնեն:',
    ds_style_modern: 'Մոդեռն',
    ds_style_minimalist: 'Մինիմալիզմ',
    ds_style_scandinavian: 'Սկանդինավյան',
    ds_style_industrial: 'Ինդուստրիալ',
    ds_style_loft: 'Լոֆթ',
    ds_style_classic: 'Դասական',
    ds_style_neoclassic: 'Նեոկլասիկ',
    ds_style_contemporary: 'Ժամանակակից',
    ds_style_art_deco: 'Արտ դեկո',
    ds_style_mid_century: 'Դարի կես',
    ds_style_bohemian: 'Բոհո',
    ds_style_rustic: 'Ռուստիկ',
    ds_style_farmhouse: 'Ֆերմերային',
    ds_style_provence: 'Պրովանս',
    ds_style_mediterranean: 'Միջերկրածովյան',
    ds_style_japandi: 'Ջապանդի',
    ds_style_high_tech: 'Հայ-թեք',
    ds_style_eclectic: 'Էկլեկտիկ',
    auth_change_email:     '← Փոխել email-ը',

    // Share / public read-only view
    share: 'Կիսվել',
    share_title: 'Կիսվել այս նախագծով',
    share_desc: 'Հղումն ունեցող ցանկացած մարդ կարող է դիտել ձեր նախագիծը 3D-ով՝ շրջել սենյակներով և ամբողջ տանով: Խմբագրել հնարավոր չէ:',
    share_link_label: 'Դիտման հղում',
    share_copy: 'Պատճենել հղումը',
    share_copied: 'Պատճենվեց!',
    share_enabling: 'Հղումը պատրաստվում է…',
    share_error: 'Չհաջողվեց ստեղծել հղումը: Փորձեք նորից:',
    shared_readonly: 'Միայն դիտում',
    shared_save_copy: 'Պահել պատճենը',
    shared_save_copy_title: 'Պահել ձեր պրոեկտներում',
    shared_save_copy_desc: 'Այս դիզայնի պատճենը կավելացվի ձեր աշխատանքային տարածք, որտեղ կարող եք ազատ խմբագրել այն։',
    shared_save_copy_btn: 'Պահել պատճենը',
    shared_editable: 'Խմբագրելի',
    shared_no_edit_access: 'Ինչ-որ բան այն չէ — դուք չունեք այս դիզայնը խմբագրելու թույլտվություն։',
    shared_edit_expired: 'Ձեր խմբագրման մուտքի ժամկետն անցել է — խնդրում ենք ստեղծել նոր կոդ և ուղարկել սեփականատիրոջը։',
    share_editable_label: 'Խմբագրելի՞',
    share_editable_hint: 'Տեղադրեք խմբագրողի կոդը՝ թույլ տալու նրան խմբագրել այս դիզայնը հղումով։',
    share_code_ph: 'Տեղադրեք մուտքի կոդը',
    share_code_apply: 'Միացնել',
    share_code_ok: 'Խմբագրման մուտքը տրված է։',
    share_code_used: 'Այս կոդն արդեն օգտագործվել է։',
    share_code_expired: 'Այս կոդի ժամկետն անցել է։ Խնդրեք նորը։',
    share_code_invalid: 'Այդպիսի կոդ գոյություն չունի։',
    share_code_error: 'Չհաջողվեց միացնել խմբագրումը — ստուգեք Firestore-ի կանոնները և ստեղծեք նոր կոդ։',
    share_to_chat: 'Ուղարկել հաղորդագրությամբ',
    share_to_chat_note: 'Ավելացնել նշում (ըստ ցանկության)',
    share_to_chat_none: 'Դեռ զրույցներ չկան։ Սկզբում բացեք զրույց օգտատիրոջ էջից։',
    share_to_chat_sent: 'Ուղարկված է',
    share_to_chat_error: 'Չհաջողվեց ուղարկել։ Փորձեք նորից։',
    share_kind_project: 'Դիզայն',
    share_kind_photo: 'Լուսանկար',
    share_kind_design: '3D դիզայն',
    share_msg_open: 'Բացել',
    share_msg_untitled: 'Անանուն դիզայն',
    share_msg_gone: 'Հղումը հասանելի չէ',
    shared_view_house: 'Ամբողջ տունը',
    shared_view_rooms: 'Սենյակներ',
    shared_made_with: 'Ստեղծված է Tunify-ով',
    shared_try: 'Ստեղծել քո սեփականը',
    shared_not_available: 'Այս նախագիծը հասանելի չէ: Հղումը կարող է սխալ լինել, կամ կիսվելն անջատված է:',
    shared_back_home: 'Անցնել Tunify',
    shared_loading: 'Նախագիծը բեռնվում է…',
    shared_no_rooms: 'Այս նախագիծը դեռ սենյակներ չունի:',
    loading_3d: '3D տեսքը պատրաստվում է…',
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// CONTEXT + HOOK
// ─────────────────────────────────────────────────────────────────────────────
const LangContext = createContext({ lang: 'en', setLang: () => {}, langChosen: true });

const LS_KEY = 'hd_lang';

const isKnown = (code) => LANGS.some(l => l.code === code);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(LS_KEY);
    return isKnown(saved) ? saved : 'hy';
  });

  // ── HAS THIS PERSON ACTUALLY CHOSEN? ──────────────────────────────────────
  // Distinct from `lang`, which always has a value: a first-time visitor is
  // shown the site in Armenian because something had to be picked, not because
  // they picked it. The stored key is the only evidence of a real choice, so
  // its absence is what the first-visit language prompt keys off (see
  // LanguageModal). Without this the prompt could only ever fire by guessing.
  const [langChosen, setLangChosen] = useState(() => isKnown(localStorage.getItem(LS_KEY)));

  const setLang = useCallback((code) => {
    setLangState(code);
    setLangChosen(true);
    localStorage.setItem(LS_KEY, code);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-lang', lang);
    // AND THE REAL `lang` ATTRIBUTE, which is a different thing from the one
    // above. `data-lang` is ours, for CSS; `lang` is the one the platform
    // reads — screen readers pick the voice and pronunciation rules from it,
    // and it is how a crawler knows the page is in Armenian rather than
    // mis-reading it as badly spelled English. index.html ships lang="en"
    // and nothing has been updating it since, so a visitor reading Հայերեն
    // was being announced by an English voice.
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, langChosen }}>
      {children}
    </LangContext.Provider>
  );
}

export function useT() {
  const { lang, setLang, langChosen } = useContext(LangContext);
  const t = useCallback(
    (key) => (T[lang] && T[lang][key]) || T.hy[key] || T.en[key] || key,
    [lang]
  );
  return { t, lang, setLang, langChosen };
}

// Renders translated text with auto-scaled font size for words > 6 characters.
export function Tx({ k, style: extraStyle }) {
  const { t } = useT();
  const text = t(k);
  const len = text.length;
  const scale = len > 5
    ? Math.max(0.72, 1 - (len - 5) * 0.06)
    : len === 5 ? 0.85 : 1;
  const style = scale < 1
    ? { fontSize: `${scale}em`, lineHeight: 1.2, ...extraStyle }
    : extraStyle;
  return style ? <span style={style}>{text}</span> : text;
}
